var _style, _polygon, _polygon2, _polygon3, _polygon4, _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _g5, _polygon5, _polygon6, _path5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path6, _path7, _path8, _path9, _g16, _polygon7, _polygon8, _path10, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _g27, _polygon15, _g28, _g29, _g30, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _g31, _ellipse, _path35, _g32, _path36, _path37, _g33, _ellipse2, _path38, _g34, _ellipse3, _path39, _path40, _g35, _polygon16, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g36, _polygon17, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _g37, _g38, _path63, _path64, _g39, _path65, _path66, _path67, _g40, _g41, _g42, _path68, _path69, _g43, _polygon18, _polygon19, _polygon20, _path70, _path71, _g44, _path72, _g45, _g46, _g47, _path73, _g48, _g49, _path74, _path75, _path76, _path77, _g50, _polygon21, _polygon22, _path78, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _path79, _path80, _polygon23, _polygon24, _polygon25, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _path81, _g70, _g71, _g72, _path82, _path83, _g73, _path84, _path85, _g74, _g75, _g76, _g77, _path86, _path87, _g78, _g79, _g80, _g81, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _g82, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _g83, _g84;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 440 264",
    style: {
      enableBackground: "new 0 0 440 264"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#95A9B6;}\r\n\t.st1{fill:#1C3B47;}\r\n\t.st2{fill:#36474D;}\r\n\t.st3{fill:#5E737B;}\r\n\t.st4{fill:#EDEDEC;}\r\n\t.st5{fill:#5F90A1;}\r\n\t.st6{fill:#275869;}\r\n\t.st7{fill:#346E85;}\r\n\t.st8{fill:#38B048;}\r\n\t.st9{opacity:0.7;fill:#5F90A1;enable-background:new    ;}\r\n\t.st10{fill:#171D21;}\r\n\t.st11{fill:#BDB9B0;}\r\n\t.st12{fill:url(#SVGID_1_);}\r\n\t.st13{fill:#355059;}\r\n\t.st14{fill:#E0E0DF;}\r\n\t.st15{fill:#F7F7F6;}\r\n\t.st16{fill:#CACACA;}\r\n\t.st17{fill:#E7E7E7;}\r\n\t.st18{fill:#777A79;}\r\n\t.st19{fill:#6B6E6D;}\r\n\t.st20{fill:#A1A1A1;}\r\n\t.st21{fill:#FDFFFF;}\r\n\t.st22{fill:#385459;}\r\n\t.st23{fill:#E7E7E4;}\r\n\t.st24{fill:url(#SVGID_2_);}\r\n\t.st25{fill:#3C3C3C;}\r\n\t.st26{fill:#404242;}\r\n\t.st27{fill:#BBC8D1;}\r\n\t.st28{fill:url(#SVGID_3_);}\r\n\t.st29{fill:#DBA777;}\r\n\t.st30{fill:url(#SVGID_4_);}\r\n\t.st31{fill:url(#SVGID_5_);}\r\n\t.st32{fill:url(#SVGID_6_);}\r\n\t.st33{fill:url(#SVGID_7_);}\r\n\t.st34{fill:url(#SVGID_8_);}\r\n\t.st35{fill:url(#SVGID_9_);}\r\n\t.st36{fill:url(#SVGID_10_);}\r\n\t.st37{fill:url(#SVGID_11_);}\r\n\t.st38{fill:url(#SVGID_12_);}\r\n\t.st39{fill:url(#SVGID_13_);}\r\n\t.st40{fill:url(#SVGID_14_);}\r\n\t.st41{fill:url(#SVGID_15_);}\r\n\t.st42{fill:url(#SVGID_16_);}\r\n\t.st43{fill:url(#SVGID_17_);}\r\n\t.st44{fill:url(#SVGID_18_);}\r\n\t.st45{opacity:0.4;fill:#10242B;enable-background:new    ;}\r\n\t.st46{fill:#393B38;}\r\n\t.st47{fill:#4A4D49;}\r\n\t.st48{fill:#636661;}\r\n\t.st49{fill:#4A0A0C;}\r\n\t.st50{fill:#474743;}\r\n\t.st51{fill:#BFBFBE;}\r\n\t.st52{fill:url(#SVGID_19_);}\r\n\t.st53{fill:#FFF3EC;}\r\n\t.st54{fill:url(#SVGID_20_);}\r\n\t.st55{fill:#E1CC30;}\r\n\t.st56{fill:#FCE436;}\r\n\t.st57{fill:#FFD35E;}\r\n\t.st58{fill:#FFEC64;}\r\n\t.st59{fill:#BFAC24;}\r\n\t.st60{fill:#4D5259;}\r\n\t.st61{fill:#71757A;}\r\n\t.st62{fill:#5E6F71;}\r\n\t.st63{fill:#EBDBCE;}\r\n\t.st64{fill:#F8B859;}\r\n\t.st65{fill:#4E5D5E;}\r\n\t.st66{fill:#FFF294;}\r\n\t.st67{fill:url(#SVGID_21_);}\r\n\t.st68{fill:#E3E3E2;}\r\n\t.st69{fill:#63CAF6;}\r\n\t.st70{fill:#B1E3FA;}\r\n\t.st71{fill:#B3B3B3;}\r\n\t.st72{fill:#425B63;}\r\n\t.st73{fill:#60C5F0;}\r\n\t.st74{fill:#1B9AD1;}\r\n\t.st75{fill:url(#SVGID_22_);}\r\n\t.st76{fill:url(#SVGID_23_);}\r\n\t.st77{fill:#4381C4;}\r\n\t.st78{fill:#8EB3DC;}\r\n\t.st79{fill:#326193;}\r\n\t.st80{enable-background:new    ;}\r\n\t.st81{fill:url(#SVGID_24_);}\r\n\t.st82{fill:url(#SVGID_25_);}\r\n\t.st83{fill:url(#SVGID_26_);}\r\n\t.st84{fill:url(#SVGID_27_);}\r\n\t.st85{fill:url(#SVGID_28_);}\r\n\t.st86{fill:#D2ECFD;}\r\n\t.st87{fill:#BAD1E0;}\r\n\t.st88{fill:#93DAF8;}\r\n\t.st89{fill:#CAEBFD;}\r\n\t.st90{fill:#C9C9C9;}\r\n\t.st91{fill:#959595;}\r\n\t.st92{fill:#23AAE1;}\r\n\t.st93{fill:#D4D4D3;}\r\n\t.st94{fill:#DEDEDD;}\r\n\t.st95{fill:#858585;}\r\n\t.st96{fill:#21A2D6;}\r\n\t.st97{fill:#1A92C6;}\r\n\t.st98{fill:url(#SVGID_29_);}\r\n\t.st99{fill:url(#SVGID_30_);}\r\n\t.st100{fill:url(#SVGID_31_);}\r\n\t.st101{fill:url(#SVGID_32_);}\r\n\t.st102{opacity:0.3;}\r\n\t.st103{fill:#303033;}\r\n\t.st104{fill:#121214;}\r\n\t.st105{fill:#939598;}\r\n\t.st106{fill:#535359;}\r\n\t.st107{fill:#16A89F;}\r\n\t.st108{fill:#0A8074;}\r\n\t.st109{fill:#FF8400;}\r\n\t.st110{fill:#BA6000;}\r\n\t.st111{fill:#A7A9AC;}\r\n\t.st112{fill:#BCBEC0;}\r\n\t.st113{fill:#6D6E71;}\r\n\t.st114{fill:#F0C6B4;}\r\n\t.st115{fill:#9C251F;}\r\n\t.st116{fill:#C7A496;}\r\n\t.st117{fill:#3C2415;}\r\n\t.st118{fill:#E31B25;}\r\n\t.st119{fill:url(#SVGID_33_);}\r\n\t.st120{fill:#FFFFFF;}\r\n\t.st121{fill:#174666;}\r\n\t.st122{fill:#2B5E85;}\r\n\t.st123{fill:#3576AB;}\r\n\t.st124{fill:#603913;}\r\n\t.st125{fill:url(#SVGID_34_);}\r\n\t.st126{opacity:0.2;fill:#121214;}\r\n\t.st127{fill:#1D374E;}\r\n\t.st128{fill:#FF4D75;}\r\n\t.st129{fill:#E6DAB0;}\r\n\t.st130{opacity:0.2;}\r\n\t.st131{fill:#FF2456;}\r\n\t.st132{fill:#0F2034;}\r\n")), /*#__PURE__*/React.createElement("g", null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "440,127.3 401.1,149.7 342.1,183.7 213.1,258.1 0,135.1 55,103.4 56.1,102.7 72.8,93.1 162.6,41.3  226.9,4.3  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "238.6,243.4 213.1,258.1 208.8,260.6 0,140.1 0,135.1 0.6,134.7 0.6,134.7 1.7,134.1 25.5,120.4  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "213.1,258.1 213.1,263.1 440,132.3 440,127.3  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "213.1,258.1 213.1,263.1 208.8,260.6 0,140.1 0,135.1  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "190,111.1 191.4,110.4 191.8,110.6 190.5,111.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "192.7,109.6 194.1,108.8 194.6,109 193.2,109.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "195.5,108 196.8,107.2 197.3,107.5 195.9,108.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "198.2,106.4 199.6,105.6 200,105.9 198.7,106.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "200.9,104.8 202.3,104 202.8,104.3 201.4,105.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "203.7,103.3 205,102.5 205.5,102.7 204.1,103.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "206.4,101.7 207.8,100.9 208.2,101.1 206.9,101.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "209.1,100.1 210.5,99.3 210.9,99.6 209.6,100.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "211.9,98.5 213.2,97.7 213.7,98 212.3,98.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "214.6,96.9 216,96.2 216.4,96.4 215,97.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "217.3,95.4 218.7,94.6 219.1,94.8 217.8,95.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "220.1,93.8 221.4,93 221.9,93.3 220.5,94.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "222.8,92.2 224.2,91.4 224.6,91.7 223.2,92.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "225.5,90.6 226.9,89.8 227.3,90.1 226,90.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "228.3,89.1 229.6,88.3 230.1,88.5 228.7,89.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "231,87.5 232.4,86.7 232.8,87 231.4,87.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "233.7,85.9 235.1,85.1 235.5,85.4 234.2,86.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "236.4,84.3 237.8,83.5 238.3,83.8 236.9,84.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "239.2,82.7 240.5,82 241,82.2 239.6,83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "241.9,81.2 243.3,80.4 243.7,80.6 242.4,81.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "244.6,79.6 246,78.8 246.5,79.1 245.1,79.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "247.4,78 248.7,77.2 249.2,77.5 247.8,78.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "250.1,76.4 251.5,75.6 251.9,75.9 250.6,76.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "252.8,74.9 254.2,74.1 254.7,74.3 253.3,75.1  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "149,86.5 150.4,85.7 150.8,85.9 149.4,86.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "151.7,84.9 153.1,84.1 153.5,84.4 152.2,85.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "154.5,83.3 155.8,82.5 156.3,82.8 154.9,83.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "157.2,81.7 158.6,81 159,81.2 157.6,82  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "159.9,80.2 161.3,79.4 161.7,79.6 160.4,80.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "162.7,78.6 164,77.8 164.5,78.1 163.1,78.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "165.4,77 166.7,76.2 167.2,76.5 165.8,77.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "168.1,75.4 169.5,74.6 169.9,74.9 168.6,75.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "170.8,73.9 172.2,73.1 172.7,73.3 171.3,74.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "173.6,72.3 174.9,71.5 175.4,71.8 174,72.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "176.3,70.7 177.7,69.9 178.1,70.2 176.8,71  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "179,69.1 180.4,68.3 180.9,68.6 179.5,69.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "181.8,67.5 183.1,66.8 183.6,67 182.2,67.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "184.5,66 185.9,65.2 186.3,65.4 185,66.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "187.2,64.4 188.6,63.6 189.1,63.9 187.7,64.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "190,62.8 191.3,62 191.8,62.3 190.4,63.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "192.7,61.2 194.1,60.4 194.5,60.7 193.2,61.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "195.4,59.7 196.8,58.9 197.3,59.1 195.9,59.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "198.2,58.1 199.5,57.3 200,57.6 198.6,58.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "200.9,56.5 202.3,55.7 202.7,56 201.4,56.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "203.6,54.9 205,54.1 205.4,54.4 204.1,55.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "206.4,53.4 207.7,52.6 208.2,52.8 206.8,53.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "209.1,51.8 210.5,51 210.9,51.2 209.5,52  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "211.8,50.2 213.2,49.4 213.6,49.7 212.3,50.5  "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "226.6,137.6 228,136.8 228.4,137.1 227,137.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "229.3,136 230.7,135.2 231.1,135.5 229.8,136.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "232.1,134.4 233.4,133.6 233.9,133.9 232.5,134.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "234.8,132.9 236.2,132.1 236.6,132.3 235.2,133.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "237.5,131.3 238.9,130.5 239.3,130.7 238,131.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "240.2,129.7 241.6,128.9 242.1,129.2 240.7,130  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "243,128.1 244.3,127.3 244.8,127.6 243.4,128.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "245.7,126.5 247.1,125.8 247.5,126 246.2,126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "248.4,125 249.8,124.2 250.3,124.4 248.9,125.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "251.2,123.4 252.5,122.6 253,122.9 251.6,123.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "253.9,121.8 255.3,121 255.7,121.3 254.4,122.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "256.6,120.2 258,119.4 258.5,119.7 257.1,120.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "259.4,118.7 260.7,117.9 261.2,118.1 259.8,118.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "262.1,117.1 263.5,116.3 263.9,116.6 262.6,117.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "264.8,115.5 266.2,114.7 266.7,115 265.3,115.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "267.6,113.9 268.9,113.1 269.4,113.4 268,114.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "270.3,112.3 271.7,111.6 272.1,111.8 270.8,112.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "273,110.8 274.4,110 274.9,110.2 273.5,111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "275.8,109.2 277.1,108.4 277.6,108.7 276.2,109.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "278.5,107.6 279.9,106.8 280.3,107.1 279,107.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "281.2,106 282.6,105.2 283,105.5 281.7,106.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "284,104.5 285.3,103.7 285.8,103.9 284.4,104.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "286.7,102.9 288.1,102.1 288.5,102.4 287.1,103.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "289.4,101.3 290.8,100.5 291.2,100.8 289.9,101.6  "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "370.9,151.9 350.7,163.6 330.5,151.9 350.7,140.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "350.7,163.6 350.7,164.6 370.9,152.9 370.9,151.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "330.5,151.9 330.5,152.9 350.7,164.6 350.7,163.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "332.5,151.9 350.7,141.4 368.9,151.9 350.7,162.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M297.7,67.3l-0.9,0.5c-1.3,0.8-3.3,0.9-4.9,0.4l-24.1-7.3c-2.3-0.7-5.1-0.4-6.9,0.6l-8.8,5.1 c-2.2,1.3-6,1.3-8.2,0l0,0c-2.2-1.3-2.2-3.4,0-4.7l8.8-5.1c1.8-1,2.2-2.7,1-4l-12.6-13.8c-0.9-1-0.5-2.2,0.8-3l0.8-0.4l23.4,13.5 l10-5.9c1-0.6,1.6-1.6,1.2-2.3l-1.8-4.8c-0.1-0.5,0.1-1,0.6-1.3l0.5-0.3l7.3,4.2l1.3,0.8l5.5,3.1l1.3,0.8l7.3,4.2l-0.5,0.3 c-0.6,0.4-1.4,0.5-2.3,0.4l-8.3-1c-1.4-0.1-3,0.1-4.2,0.7l-10,5.8L297.7,67.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M272.3,50c0,0.4,0.3,0.5,0.7,0.3c0.4-0.3,0.6-0.7,0.6-1s-0.3-0.5-0.6-0.3C272.5,49.2,272.3,49.7,272.3,50z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M272.5,49.9c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.4,0.4-0.7s-0.1-0.3-0.4-0.1 C272.7,49.5,272.5,49.7,272.5,49.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -946.4749,
    y1: 216.4574,
    x2: -945.0299,
    y2: 216.4574,
    gradientTransform: "matrix(-1 0 0 -1 -673.0945 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A232C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A121C"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M271.9,49.9c0-0.4,0.3-0.8,0.6-1c0.1-0.1,0.4-0.1,0.5,0l0.4,0.3l0,0c-0.1-0.1-0.3,0-0.5,0 c-0.4,0.3-0.7,0.7-0.7,1c0,0.1,0,0.3,0.1,0.3l0,0l-0.4-0.3C272,50.1,271.9,50,271.9,49.9z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M270.7,51c0,0.4,0.3,0.5,0.7,0.3c0.4-0.3,0.6-0.6,0.6-1c0-0.4-0.3-0.5-0.6-0.3 C271,50.2,270.7,50.6,270.7,51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M270.8,50.9c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.4,0.4-0.7c0-0.3-0.1-0.3-0.4-0.1 C271.1,50.4,270.8,50.6,270.8,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M270.3,50.8c0-0.4,0.3-0.8,0.6-1c0.1-0.1,0.4-0.1,0.5,0l0.4,0.3l0,0c-0.1-0.1-0.3,0-0.5,0 c-0.4,0.3-0.7,0.7-0.7,1c0,0.1,0,0.3,0.1,0.3l0,0l-0.4-0.3C270.3,51,270.3,50.9,270.3,50.8z"
  }))), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "273.3,48.6 274,48.9 273.4,48.9 272.8,48.6  "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "273.4,48.9 273,49.1 272.5,48.8 272.8,48.6  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M271.4,50.5l0.5-0.7l0.3-0.1v-1.8l0.9-0.5v1.8l0.3-0.1h0.5c0.1,0.1,0.1,0.1,0.3,0.3v0.1l-3.1,1.8v-0.4 C271.2,50.8,271.2,50.6,271.4,50.5z"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M270.7,50.1l0.7,0.4l-0.3,0.5l-0.6-0.4C270.6,50.4,270.6,50.2,270.7,50.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "271.1,50.9 271.1,51.3 270.4,50.9 270.4,50.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "271.2,49.5 271.9,49.9 271.4,50.5 270.7,50.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "271.6,49.3 272.1,49.7 271.9,49.9 271.2,49.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "272.5,47 273,47.4 272.1,47.9 271.6,47.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "272.1,47.9 272.1,49.7 271.6,49.3 271.6,47.5  "
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M273.2,50.5c0,0.4,0.3,0.5,0.6,0.3c0.4-0.3,0.7-0.6,0.7-1c0-0.4-0.3-0.5-0.7-0.3 C273.4,49.7,273.2,50.2,273.2,50.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M273.4,50.4c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.4,0.4-0.6c0-0.3-0.1-0.3-0.4-0.1 C273.6,50,273.4,50.2,273.4,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M272.9,50.4c0-0.4,0.3-0.8,0.6-1c0.1-0.1,0.4-0.1,0.5,0l0.4,0.3l0,0c-0.1-0.1-0.3,0-0.5,0 c-0.4,0.3-0.6,0.6-0.6,1c0,0.1,0,0.3,0.1,0.3l0,0l-0.4-0.3C272.9,50.6,272.9,50.5,272.9,50.4z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M271.6,51.5c0,0.4,0.3,0.5,0.6,0.3c0.4-0.3,0.7-0.7,0.7-1s-0.3-0.5-0.7-0.3 C271.9,50.8,271.6,51.2,271.6,51.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M271.9,51.4c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.4,0.4-0.6c0-0.3-0.1-0.3-0.4-0.1 C272,50.9,271.9,51.2,271.9,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M271.2,51.3c0-0.4,0.3-0.8,0.6-1c0.1-0.1,0.4-0.1,0.5,0l0.4,0.3l0,0c-0.1-0.1-0.3,0-0.5,0 c-0.4,0.3-0.6,0.7-0.6,1c0,0.1,0,0.3,0.1,0.3l0,0l-0.4-0.3C271.2,51.5,271.2,51.4,271.2,51.3z"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M250.8,62.7c0,0.4,0.3,0.5,0.6,0.3c0.4-0.3,0.6-0.7,0.6-1s-0.3-0.5-0.6-0.3 C251.2,61.9,250.8,62.3,250.8,62.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M251.1,62.6c0,0.3,0.1,0.3,0.4,0.1c0.3-0.1,0.4-0.4,0.4-0.7s-0.1-0.3-0.4-0.1 C251.3,62.1,251.1,62.3,251.1,62.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M250.6,62.5c0-0.4,0.3-0.8,0.6-1c0.1-0.1,0.4-0.1,0.5,0l0.4,0.3l0,0c-0.1-0.1-0.3,0-0.5,0 c-0.4,0.3-0.6,0.6-0.6,1c0,0.1,0,0.3,0.1,0.3l0,0l-0.4-0.3C250.6,62.7,250.6,62.6,250.6,62.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "251.9,60 251.9,62.7 252.4,62.5 252.4,59.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "251.7,59.3 252.4,59.6 251.9,60 251.2,59.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "251.9,60 251.9,62.7 251.2,62.5 251.2,59.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M251.9,63.2c0,0.4,0.3,0.5,0.7,0.3c0.4-0.3,0.6-0.6,0.6-1c0-0.4-0.3-0.5-0.6-0.3 C252.1,62.5,251.9,62.9,251.9,63.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M252,63.1c0,0.3,0.1,0.3,0.4,0.1s0.4-0.4,0.4-0.7c0-0.3-0.1-0.3-0.4-0.1C252.2,62.6,252,62.9,252,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M251.5,63c0-0.4,0.3-0.8,0.6-1c0.1-0.1,0.4-0.1,0.5,0l0.4,0.3l0,0c-0.1-0.1-0.3,0-0.5,0 c-0.4,0.3-0.7,0.7-0.7,1c0,0.1,0,0.3,0.1,0.3l0,0l-0.4-0.3C251.5,63.2,251.5,63.2,251.5,63z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M278,24l7.9,7.3l-7.3,3.8l-2.6-8.8c-0.1-0.5,0-0.9,0.4-1.2L278,24z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "279,24.9 277.9,25.5 284.7,31.9 284.9,31.9 285,31.8 278.4,25.7 279.2,25.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M276.2,26.1c0,0.1,0,0.3,0,0.4l2.6,9.4v-0.7l-2.6-8.8C276.2,26.2,276.2,26.2,276.2,26.1z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M248.2,39.3c0-0.4-0.3-0.8-0.6-0.9c-0.1-0.1-0.3-0.1-0.4-0.1l0,0l-3,0.8l1.8,2.6l2.1-2.1l0,0 C248.2,39.5,248.2,39.3,248.2,39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M241.7,44.8c0,1.2-0.9,1.6-2.1,0.9c-1.2-0.7-2.1-2.2-2.1-3.4s0.9-1.6,2.1-0.9 C240.8,42.2,241.7,43.6,241.7,44.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M240.2,44.9c-0.9-0.5-1.7-1.8-1.7-2.7c0-0.3,0-0.5,0.1-0.6c-0.4,0-0.8,0.4-0.8,1c0,0.9,0.8,2.2,1.7,2.7 c0.6,0.4,1.3,0.4,1.6-0.1C240.8,45.3,240.5,45.2,240.2,44.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M239.6,41.9c-0.4-0.3-0.6-0.3-0.9-0.3c-0.1,0.1-0.1,0.4-0.1,0.7c0,0.9,0.8,2.2,1.7,2.7 c0.4,0.3,0.7,0.3,0.9,0.3c0.1-0.1,0.1-0.4,0.1-0.7C241.3,43.6,240.5,42.4,239.6,41.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M240.7,43.5c0-0.3-0.1-0.5-0.4-0.7c-0.1,0-0.3-0.1-0.3,0l0,0l-0.6,0.4l0.3,0.4l0.4,0.5l0.6-0.4l0,0 C240.7,43.6,240.7,43.6,240.7,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M240.2,43.9c0,0.3-0.1,0.3-0.4,0.1c-0.3-0.1-0.4-0.4-0.4-0.6c0-0.3,0.1-0.3,0.4-0.1 C239.9,43.4,240.2,43.6,240.2,43.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M246.7,41.3c0-0.8-0.6-2-1.6-2.5c-0.4-0.3-0.6-0.3-0.9-0.3l0,0l-2.3,0.5l0,0c-0.1,0-0.3,0-0.3,0.1l0,0 l-3.5,2l0,0c0.4-0.3,0.9-0.1,1.6,0.1c1.2,0.6,2.1,2.2,2.1,3.4c0,0.5-0.3,0.9-0.5,1l0,0l3.5-2l0,0c0.1,0,0.1-0.1,0.3-0.1l0,0 l1.6-1.7l0,0C246.5,41.8,246.7,41.5,246.7,41.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M241.7,44.8c0,0,2.6-1.3,2.7-3.1c0.1-2.1-2.6-2.2-5.7-0.5l0,0c0.3,0,0.7,0.1,0.9,0.3 C240.8,42.2,241.7,43.6,241.7,44.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M251.6,47.1c0-0.4-0.3-0.8-0.6-0.9c-0.1-0.1-0.3-0.1-0.4-0.1l0,0l-3,0.8l1.8,2.6l2.1-2.1l0,0 C251.5,47.4,251.6,47.3,251.6,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M245,52.7c0,1.2-0.9,1.6-2.1,0.9c-1.2-0.6-2.1-2.2-2.1-3.4s0.9-1.6,2.1-0.9C244.1,50.1,245,51.5,245,52.7z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M243.4,52.8c-0.9-0.5-1.7-1.8-1.7-2.7c0-0.3,0-0.5,0.1-0.7c-0.4,0-0.8,0.4-0.8,1c0,0.9,0.8,2.2,1.7,2.7 c0.6,0.4,1.3,0.4,1.6-0.1C244.2,53.2,243.8,53.1,243.4,52.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M242.9,49.7c-0.4-0.3-0.6-0.3-0.9-0.3c-0.1,0.1-0.1,0.4-0.1,0.7c0,0.9,0.8,2.2,1.7,2.7 c0.4,0.3,0.7,0.3,0.9,0.3c0.1-0.1,0.1-0.4,0.1-0.7C244.6,51.5,243.8,50.4,242.9,49.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M244.1,51.4c0-0.3-0.1-0.5-0.4-0.7c-0.1-0.1-0.3-0.1-0.3,0l0,0l-0.6,0.4l0.3,0.4l0.4,0.5l0.7-0.4l0,0 C243.9,51.5,244.1,51.5,244.1,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M243.4,51.8c0,0.3-0.1,0.3-0.4,0.1c-0.3-0.1-0.4-0.4-0.4-0.6c0-0.3,0.1-0.3,0.4-0.1 C243.3,51.3,243.4,51.5,243.4,51.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M249.9,49.2c0-0.8-0.6-2-1.6-2.5c-0.4-0.3-0.6-0.3-0.9-0.3l0,0l-2.3,0.5l0,0c-0.1,0-0.3,0-0.3,0.1l0,0 l-3.5,2l0,0c0.4-0.3,0.9-0.1,1.6,0.1c1.2,0.6,2.1,2.2,2.1,3.4c0,0.5-0.3,0.9-0.5,1l0,0l3.5-2l0,0c0.1,0,0.1-0.1,0.3-0.1l0,0 l1.6-1.7l0,0C249.8,49.7,249.9,49.5,249.9,49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M245,52.7c0,0,2.6-1.3,2.7-3.1c0.1-2.1-2.6-2.2-5.7-0.5l0,0c0.3,0,0.7,0.1,0.9,0.3 C244.1,50.1,245,51.5,245,52.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M240.2,26.7l12.7,15.6l5.5,3.8l-10.7,6.1l-1-2.6l-9.4-20c-0.3-0.5,0-1,0.4-1.3L240.2,26.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M240.2,26.6l12.7,15.6l5.5,3.8L248,51.8l-1-2.6l-9.6-19.8c-0.3-0.5,0-1,0.4-1.3L240.2,26.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "253,42.2 252.9,42.1 252.8,41.9 250.6,43.2 250.7,43.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "246.7,34.4 245.4,35.2 245.5,35.4 246.8,34.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "250.7,43.4 242.1,30 242.8,29.6 242.5,29.4 242,29.7 241.7,29.8 241.8,30.1 250.6,43.5  255.9,47.3 256.1,47.1  "
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M288.4,31.4c0-0.4-0.4-1-0.8-1.3c-0.3-0.1-0.4-0.1-0.7-0.1l0,0l-0.9,0.5l1.2,1.7l0.9-0.5l0,0 C288.3,31.8,288.4,31.5,288.4,31.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M287.3,30.9c-4.5,4.2-20.8,14.4-22.2,15.1c-1.6,0.6-4.4,1.7-4.4,1.7l-16.4,9.5c-2.6,1.7-6.6,6.5-6.6,6.5 l0,0c-0.1,0-0.4,0.1-0.6,0.4c-0.6,0.5-1.6,0.5-2.3,0.3c-0.3-0.1-0.5-0.1-0.7-0.1c0,0.1,0,0.3,0,0.4c0,0.4,0,1,1.7,1 c0,0,0,0,0.1,0c1.7,0,2.3-0.5,2.3-0.5l0,0c0,0,4.6-3.3,6.5-4.2s17-9.8,17.7-10c0.6-0.3,5.3-2.2,6.5-3c1.2-0.8,8.5-5.6,12.4-9.6 c2.7-2.9,5.3-5.2,6.5-6.4C287.6,31.4,287.5,31.1,287.3,30.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M286.8,30.4c-3,1.4-22.9,10.7-27.6,12.9c0,0-3.3,0.8-6.5,2.9c-3.3,2.1-12,7-12,7s-2.9,1.8-3.6,3.8 c-0.9,2-1.7,3.9-2.3,5.1l0,0c-0.4,0.6-0.7,1.4-0.8,2.1c0,0.1,0.1,0.4,0.3,0.5c0.5,0.5,1.6,0.6,2.1,0.1c0.5-0.4,0.8-0.7,1.3-1.2 l0,0c0,0,4.2-4.7,6.6-6.5l16.4-9.5c0,0,2.9-1,4.4-1.7c1.4-0.6,17.7-10.9,22.2-15.1C287.2,30.6,287.1,30.5,286.8,30.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M286.3,30.1c0,0-22.6,10.4-27.7,12.7c0,0-3.3,0.8-6.5,2.9s-12,7-12,7s-2.9,1.8-3.6,3.8 c-0.9,1.9-1.2,4-1.9,5.2c0,0.1-0.1,0.1-0.1,0.3c-0.4,0.6-0.6,1.3-0.8,2.1c0,0.3,0,0.4-0.1,0.7c0,0.3,0,0.6,0,0.9 c0,0.3,0.1,0.5,0.3,0.8c0,0.1,0.1,0.3,0.1,0.4c0,0,0,0,0.1,0.1c0-0.1-0.1-0.3-0.1-0.4c-0.1-0.3-0.1-0.5-0.1-0.7 c0-0.3,0-0.5,0-0.9c0-0.3,0-0.7,0.1-0.9c0.1-0.7,0.4-1.4,0.8-2.1l0,0c0.6-1.2,1.4-3.3,2.3-5.1c0.9-2,3.6-3.8,3.6-3.8 s8.7-4.8,12-7c3.3-2.1,6.5-2.9,6.5-2.9c4.7-2.2,24.6-11.4,27.6-12.9C286.7,30.2,286.6,30.1,286.3,30.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M287.6,31.7c-1.2,1-3.8,3.4-6.5,6.4c-3.9,4-11.2,8.8-12.4,9.6c-1.2,0.8-5.9,2.7-6.5,3 c-0.6,0.3-15.9,9.1-17.7,10c-1.8,0.9-6.5,4.2-6.5,4.2l0,0c0,0-0.8,0.5-2.5,0.5c0,0-1.4-0.3-1.7-1c0,0.1,0,0.4,0,0.5s0,0.3,0,0.4 c0.1,0.1,0.4,0.4,0.8,0.7c0.5,0.3,1,0.3,1.6,0.1c0.8-0.1,1.9-0.4,1.9-0.4l0,0l6.2-3l17.7-10c0,0,2.6-1.2,3.9-1.8 c1.4-0.7,8.6-4.8,11-7.3c2-2,8.3-8.7,10.7-11.3C287.6,32,287.6,31.9,287.6,31.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M276,45.8c-1.8,1.7-7.5,4.9-8.3,5.5c-0.8,0.5-11.3,6.1-11.3,6.1s-11.2,6.5-12,6.8 c-0.8,0.3-6.1,2.2-6.5,2.3l0,0c-0.4,0-1.6,0.3-2.6,0.3c-0.7-0.1-1.2-0.1-1.4-0.4v0.1c0,0.1,0.1,0.3,0.1,0.4 c0.1,0.1,0.5,0.4,1,0.5s1.3,0.1,2.3,0c0,0,4.7-0.5,7.5-2.1c2.9-1.6,27.7-15.9,27.7-15.9s3.1-1.8,7-6.8l7.9-10.1 C286.6,33.9,277.9,44.1,276,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M276.9,43.6c-2.5,2.5-9.6,6.6-11,7.3c-1.4,0.6-3.9,1.8-3.9,1.8l-17.7,10l-6,2.9c-0.3,0.1-0.4,0.1-0.7,0.3 c-0.4,0.1-1,0.3-1.6,0.3c-0.7,0.1-1.3,0-1.8-0.4c-0.3-0.1-0.4-0.4-0.5-0.5c0,0.1,0,0.3,0,0.5s0.1,0.4,0.1,0.5 c0.3,0.3,0.6,0.4,1.4,0.5c1,0,2.2-0.3,2.6-0.3c1.8-0.4,5.6-2,6.5-2.3c0.8-0.3,12-6.8,12-6.8s10.5-5.7,11.3-6.1 c0.8-0.4,6.5-3.6,8.3-5.5c1.8-1.7,10.5-12,11.6-13.3c0,0,0-0.1,0-0.4C285.3,34.8,278.9,41.7,276.9,43.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M247.4,56.2l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0,0,0.1-0.1,0.1-0.4l-0.4-1 C247.8,56.4,247.7,56.1,247.4,56.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M248.3,55.7l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4 l-0.4-1C248.7,55.8,248.6,55.6,248.3,55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M249.3,55.2l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4 l-0.4-1C249.6,55.3,249.5,55.1,249.3,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M250.2,54.7l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4 l-0.4-1C250.6,54.8,250.4,54.5,250.2,54.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M251.1,54.1l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0,0,0.1-0.1,0.1-0.4l-0.4-1 C251.5,54.3,251.3,54,251.1,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M252,53.6l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4l-0.4-1 C252.4,53.8,252.2,53.5,252,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M252.9,53.1l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4 l-0.4-1C253.3,53.2,253.2,53,252.9,53.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M253.8,52.5l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4 l-0.4-1C254.2,52.7,254.1,52.5,253.8,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M254.7,51.9l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0,0,0.1-0.1,0.1-0.4l-0.4-1 C255.1,52.2,255,51.9,254.7,51.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M255.6,51.4l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4 l-0.4-1C256,51.7,255.9,51.4,255.6,51.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M256.5,50.9l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4 l-0.4-1C256.9,51.2,256.8,50.9,256.5,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M257.4,50.4l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4 l-0.4-1C257.8,50.6,257.7,50.4,257.4,50.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M258.5,49.9l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4 l-0.4-1C258.7,50,258.6,49.7,258.5,49.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M259.4,49.3l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4 l-0.4-1C259.7,49.5,259.5,49.2,259.4,49.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M260.3,48.8l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4 l-0.4-1C260.6,48.9,260.4,48.7,260.3,48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M261.2,48.3l-0.3,0.1c0,0-0.3,0.1-0.1,0.4l0.4,1c0,0,0.1,0.3,0.3,0.1l0.3-0.1c0.1,0,0.1-0.1,0.1-0.4 l-0.4-1C261.5,48.4,261.3,48.2,261.2,48.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M249.3,57.9l-0.1,0.1c0,0-0.3,0.1-0.3,0.4s0,0.7,0,0.7s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4V58 C249.5,58.2,249.5,57.9,249.3,57.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M249,60.6h-0.1c-0.1-0.1-0.1-0.3-0.1-0.3s-0.1-1.3-0.1-1.7c0-0.5,0.4-0.8,0.4-0.8l0.4-0.3 c0.1,0,0.3,0,0.3,0c0.1,0.1,0.1,0.3,0.1,0.3l0.1,1.8c0,0.4-0.3,0.6-0.4,0.6l-0.4,0.3H249z M248.7,60.4c0,0,0,0.1,0.1,0.3 c0,0,0.1,0,0.3,0l0.4-0.3l0,0c0,0,0.3-0.3,0.3-0.5l-0.1-1.8c0,0,0-0.1-0.1-0.3c0,0-0.1,0-0.3,0l-0.4,0.1c0,0-0.4,0.3-0.4,0.7 C248.6,59.1,248.7,60.3,248.7,60.4L248.7,60.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M251.6,56.9l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C251.9,57.1,251.9,56.9,251.6,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M252.5,56.4l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C252.8,56.6,252.8,56.4,252.5,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M253.5,55.8l-0.1,0.1c0,0-0.3,0.1-0.3,0.4s0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C253.7,56,253.7,55.8,253.5,55.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M254.5,55.3l-0.1,0.1c0,0-0.3,0.1-0.3,0.4s0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C254.7,55.4,254.7,55.3,254.5,55.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M255.4,54.8l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C255.6,54.9,255.6,54.8,255.4,54.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M256.3,54.3l-0.1,0.1c0,0-0.3,0.1-0.3,0.4s0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C256.5,54.4,256.5,54.3,256.3,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M257.2,53.8l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C257.4,53.9,257.4,53.6,257.2,53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M258.2,53.2l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C258.4,53.4,258.4,53.1,258.2,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M259.1,52.7l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C259.4,52.8,259.4,52.6,259.1,52.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M260,52.2l-0.1,0.1c0,0-0.3,0.1-0.3,0.4s0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C260.3,52.3,260.3,52.1,260,52.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M261,51.7l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C261.2,51.8,261.2,51.5,261,51.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M261.9,51l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C262.1,51.3,262.1,51,261.9,51z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M265.6,48.9l-0.1,0.1c0,0-0.3,0.1-0.3,0.4s0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C265.9,49.1,265.9,48.9,265.6,48.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M266.7,48.4l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C266.8,48.6,266.8,48.4,266.7,48.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M267.6,47.9l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C267.7,48,267.7,47.9,267.6,47.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M268.5,47.4l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C268.8,47.5,268.8,47.3,268.5,47.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M269.4,46.9l-0.1,0.1c0,0-0.3,0.1-0.3,0.4s0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C269.7,47,269.7,46.7,269.4,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M270.3,46.3l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C270.6,46.5,270.6,46.2,270.3,46.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M271.4,45.6l-0.1,0.1c0,0-0.3,0.1-0.3,0.4s0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C271.5,45.7,271.5,45.6,271.4,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M275,43l-0.1,0.1c0,0-0.3,0.1-0.3,0.4s0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C275.3,43.1,275.3,42.8,275,43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M276,42.2l-0.1,0.1c0,0-0.3,0.1-0.3,0.4s0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C276.2,42.3,276.2,42.1,276,42.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M276.9,41.4l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C277.1,41.5,277.1,41.4,276.9,41.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M277.9,40.6l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,1,0,1s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4v-1 C278.1,40.8,278.1,40.5,277.9,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M273.2,44.3l-0.1,0.1c0,0-0.3,0.1-0.3,0.4c0,0.3,0,0.6,0,0.6s0,0.3,0.3,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.4 v-0.6C273.4,44.4,273.4,44.1,273.2,44.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M272.9,47h-0.1c-0.1-0.1-0.1-0.3-0.1-0.3s-0.1-1.3-0.1-1.7c0-0.5,0.4-0.8,0.4-0.8l0.4-0.3 c0.1,0,0.3,0,0.3,0c0.1,0.1,0.1,0.3,0.1,0.3l0.1,1.8c0,0.4-0.3,0.7-0.4,0.7L273,47C273,46.9,272.9,47,272.9,47z M272.7,46.6 c0,0,0,0.1,0.1,0.3c0.1,0,0.1,0,0.3,0l0.4-0.3l0,0c0,0,0.3-0.3,0.3-0.5l-0.1-1.8c0,0,0-0.1-0.1-0.3c0,0-0.1,0-0.3,0l-0.4,0.1 c0,0-0.4,0.3-0.4,0.7C272.5,45.3,272.7,46.6,272.7,46.6L272.7,46.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M237.4,56.1c-0.1-0.6,0-1,0-1c-0.4,0.4-0.8,0.9-0.9,1.4c-0.1,0.4-0.4,0.8-0.5,1.3c0,0.3,0.1,0.7,0.3,0.9 c0.4,0.8,1,1.2,1,1.2l0.9-1.7C237.7,57.3,237.6,56.6,237.4,56.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M238.3,58.3l-0.9,1.7c0,0,0.5,0.4,2.5,0.5c0.5,0,1.2,0,1.7-0.1c0.9-0.1,2.6-0.5,3.4-1l-0.3-2 c0,0-1.7,0.7-2.7,0.8C240.8,58.4,239.1,58.3,238.3,58.3z"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M282.8,36.9l4.5-4.7l12.2,4.2l-1,0.7c-0.6,0.5-1.6,0.6-2.3,0.6L282.8,36.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "286.4,33 296.7,36.5 297.9,35.8 297.6,35.7 296.7,36.2 286.7,32.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M298.4,37c-0.7,0.5-1.6,0.6-2.3,0.6l-13.3-0.8v0.5l13.3,0.6c0.8,0,1.7-0.1,2.3-0.6l1-0.7v-0.3L298.4,37z"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M276.4,35.7l9.6-4.8l3-15.2l-1.7,1c-0.8,0.5-1.6,1.2-1.9,2.1L276.4,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M287.3,16.7l1.7-1l-0.3-0.1l-1.7,1c-0.8,0.5-1.6,1.2-2,2.1L276,35.4l0.5,0.4l9-16.9 C285.8,18,286.4,17.2,287.3,16.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "287.7,16.6 287.7,16.4 287.5,16.7 284.5,31.7 284.9,31.5  "
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M271.2,58.6c0-0.4-0.3-0.8-0.7-0.9c-0.1-0.1-0.3-0.1-0.4-0.1l0,0l-3,0.8l1.8,2.6l2.1-2.1l0,0 C271.2,58.8,271.2,58.7,271.2,58.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M264.7,64.2c0,1.2-0.9,1.6-2.1,0.9c-1.2-0.7-2.1-2.2-2.1-3.4s0.9-1.6,2.1-0.9 C263.8,61.4,264.7,63,264.7,64.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M263.2,64.3c-0.9-0.5-1.7-1.8-1.7-2.7c0-0.3,0-0.5,0.1-0.6c-0.4,0-0.8,0.4-0.8,1c0,0.9,0.8,2.2,1.7,2.7 c0.7,0.4,1.3,0.4,1.6-0.1C263.8,64.5,263.6,64.5,263.2,64.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M262.6,61.2c-0.4-0.3-0.7-0.3-0.9-0.3c-0.1,0.1-0.1,0.4-0.1,0.6c0,0.9,0.8,2.2,1.7,2.7 c0.4,0.3,0.6,0.3,0.9,0.3c0.1-0.1,0.1-0.4,0.1-0.7C264.3,63,263.6,61.7,262.6,61.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M263.7,62.9c0-0.3-0.1-0.5-0.4-0.6c-0.1-0.1-0.3-0.1-0.3,0l0,0l-0.6,0.4l0.3,0.4l0.4,0.5l0.6-0.4l0,0 C263.7,63,263.7,62.9,263.7,62.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M263,63.1c0,0.3-0.1,0.3-0.4,0.1c-0.3-0.1-0.4-0.4-0.4-0.7c0-0.3,0.1-0.3,0.4-0.1 C262.9,62.7,263,63,263,63.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M269.5,60.6c0-0.8-0.6-2-1.6-2.5c-0.4-0.3-0.6-0.3-0.9-0.3l0,0l-2.3,0.5l0,0c-0.1,0-0.3,0-0.3,0.1l0,0 l-3.5,1.9l0,0c0.4-0.3,0.9-0.1,1.6,0.1c1.2,0.6,2.1,2.2,2.1,3.4c0,0.5-0.3,0.9-0.5,1l0,0l3.5-1.9l0,0c0.1,0,0.1-0.1,0.3-0.1l0,0 l1.6-1.7l0,0C269.5,61.2,269.5,60.9,269.5,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M264.7,64.2c0,0,2.6-1.3,2.7-3.1c0.1-2.1-2.6-2.2-5.7-0.5l0,0c0.3,0,0.6,0.1,0.9,0.3 C263.8,61.4,264.7,63,264.7,64.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M282.8,59.3c0-0.4-0.3-0.8-0.6-0.9c-0.1-0.1-0.3-0.1-0.4-0.1l0,0l-3,0.8l1.8,2.6l2.1-2.1l0,0 C282.8,59.5,282.8,59.3,282.8,59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M276.2,64.8c0,1.2-0.9,1.6-2.1,0.9c-1.2-0.7-2.1-2.2-2.1-3.4s0.9-1.6,2.1-0.9 C275.3,62.2,276.2,63.6,276.2,64.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M274.7,64.9c-0.9-0.5-1.7-1.8-1.7-2.7c0-0.3,0-0.5,0.1-0.7c-0.4,0-0.8,0.4-0.8,1c0,0.9,0.8,2.2,1.7,2.7 c0.6,0.4,1.3,0.4,1.6-0.1C275.4,65.3,275,65.2,274.7,64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M274.1,61.9c-0.4-0.3-0.7-0.3-0.9-0.3c-0.1,0.1-0.1,0.4-0.1,0.7c0,0.9,0.8,2.2,1.7,2.7 c0.4,0.3,0.6,0.3,0.9,0.3c0.1-0.1,0.1-0.4,0.1-0.6C275.8,63.6,275,62.5,274.1,61.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M275.3,63.5c0-0.3-0.1-0.5-0.4-0.7c-0.1,0-0.3-0.1-0.3,0l0,0l-0.7,0.4l0.3,0.4l0.4,0.5l0.6-0.4l0,0 C275.1,63.6,275.3,63.6,275.3,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M274.6,63.9c0,0.3-0.1,0.3-0.4,0.1s-0.4-0.4-0.4-0.7c0-0.3,0.1-0.3,0.4-0.1S274.6,63.6,274.6,63.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M281.1,61.3c0-0.8-0.7-2-1.6-2.5c-0.4-0.3-0.6-0.3-0.9-0.3l0,0l-2.3,0.5l0,0c-0.1,0-0.3,0-0.3,0.1l0,0 l-3.5,2l0,0c0.4-0.3,0.9-0.1,1.6,0.1c1.2,0.7,2.1,2.2,2.1,3.4c0,0.5-0.3,0.9-0.5,1l0,0l3.5-2l0,0c0.1,0,0.1-0.1,0.3-0.1l0,0 l1.6-1.7l0,0C281,61.8,281.1,61.6,281.1,61.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M276.2,64.8c0,0,2.6-1.3,2.7-3.1c0.1-2.1-2.6-2.2-5.7-0.5l0,0c0.3,0,0.6,0.1,0.9,0.3 C275.3,62.2,276.2,63.6,276.2,64.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M256.4,57.4l10.9-6.4l6.5,3.1l23.1,5.1l-2.6,1.4c-0.5,0.3-1,0.4-1.6,0.4L256.4,57.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "286,56.9 284.9,57.5 285,57.8 286.6,56.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "273.8,54.1 273.6,54 271.4,55.3 271.5,55.6 274,54.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "292.7,58.3 292,58.7 271.6,55.3 265.2,52.3 264.9,52.5 265,52.6 271.5,55.6 271.5,55.6 291.6,59  292,59.1 292.4,58.8 293.2,58.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M294.4,60.6c-0.5,0.3-1,0.4-1.6,0.4l-36.4-3.6l-0.4,0.9l36.8,3c0.5,0,1.2-0.1,1.6-0.4l2.6-1.4v-0.1 L294.4,60.6z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M231.4,80.5l0.7-0.4c1-0.6,2.5-0.7,3.8-0.3l18.5,5.6c1.8,0.5,3.9,0.3,5.3-0.5l6.8-3.9c1.7-1,4.6-1,6.3,0l0,0 c1.7,1,1.7,2.6,0,3.6l-6.8,3.9c-1.4,0.8-1.7,2.1-0.8,3.1l9.7,10.6c0.7,0.8,0.4,1.7-0.6,2.3l-0.6,0.3l-18-10.4l-7.7,4.5 c-0.8,0.5-1.2,1.2-0.9,1.8l1.4,3.7c0.1,0.4-0.1,0.8-0.5,1l-0.4,0.2l-5.6-3.2l-1-0.6l-4.2-2.4l-1-0.6l-5.6-3.2l0.4-0.2 c0.5-0.3,1.1-0.4,1.8-0.3l6.4,0.8c1.1,0.1,2.3-0.1,3.2-0.5l7.7-4.5L231.4,80.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M252,93.6c0,0.3,0.2,0.4,0.5,0.2c0.3-0.2,0.5-0.5,0.5-0.8s-0.2-0.4-0.5-0.2S252,93.4,252,93.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M252.1,93.5c0,0.2,0.1,0.2,0.3,0.1c0.2-0.1,0.3-0.3,0.3-0.5s-0.1-0.2-0.3-0.1 C252.3,93.2,252.1,93.4,252.1,93.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -925.894,
    y1: 172.7654,
    x2: -924.7825,
    y2: 172.7654,
    gradientTransform: "matrix(-1 0 0 -1 -673.0945 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A232C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A121C"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M251.7,93.5c0-0.3,0.2-0.6,0.5-0.8c0.1-0.1,0.3-0.1,0.4,0l0.3,0.2l0,0c-0.1-0.1-0.2,0-0.4,0 c-0.3,0.2-0.5,0.5-0.5,0.8c0,0.1,0,0.2,0.1,0.2l0,0l-0.3-0.2C251.7,93.7,251.7,93.6,251.7,93.5z"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M250.7,94.4c0,0.3,0.2,0.4,0.5,0.2c0.3-0.2,0.5-0.5,0.5-0.8s-0.2-0.4-0.5-0.2 C250.9,93.8,250.7,94.1,250.7,94.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M250.9,94.3c0,0.2,0.1,0.2,0.3,0.1c0.2-0.1,0.3-0.3,0.3-0.5s-0.1-0.2-0.3-0.1S250.9,94.1,250.9,94.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M250.4,94.2c0-0.3,0.2-0.6,0.5-0.8c0.1-0.1,0.3-0.1,0.4,0l0.3,0.2l0,0c-0.1-0.1-0.2,0-0.4,0 c-0.3,0.2-0.5,0.5-0.5,0.8c0,0.1,0,0.2,0.1,0.2l0,0l-0.3-0.2C250.5,94.4,250.4,94.3,250.4,94.2z"
  }))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "252.8,92.5 253.3,92.8 252.8,92.8 252.3,92.5  "
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "252.8,92.8 252.6,92.9 252.1,92.7 252.3,92.5  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M251.2,94l0.4-0.5l0.2-0.1V92l0.7-0.4V93l0.2-0.1h0.4c0.1,0.1,0.1,0.1,0.2,0.2v0.3l-2.4,1.4v-0.3 C251.1,94.2,251.2,94.1,251.2,94z"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M250.7,93.7l0.5,0.3l-0.2,0.4l-0.5-0.3C250.6,93.9,250.7,93.8,250.7,93.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "251,94.3 251,94.6 250.6,94.3 250.6,94.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "251.2,93.2 251.7,93.5 251.2,94 250.7,93.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "251.4,93.1 251.9,93.4 251.7,93.5 251.2,93.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "252.1,91.3 252.6,91.6 251.9,92 251.4,91.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "251.9,92 251.9,93.4 251.4,93.1 251.4,91.7  "
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M252.7,94c0,0.3,0.2,0.4,0.5,0.2c0.3-0.2,0.5-0.5,0.5-0.8s-0.2-0.4-0.5-0.2 C252.9,93.4,252.7,93.8,252.7,94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M252.9,93.9c0,0.2,0.1,0.2,0.3,0.1c0.2-0.1,0.3-0.3,0.3-0.5s-0.1-0.2-0.3-0.1 C253,93.6,252.9,93.8,252.9,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M252.4,93.9c0-0.3,0.2-0.6,0.5-0.8c0.1-0.1,0.3-0.1,0.4,0l0.3,0.2l0,0c-0.1-0.1-0.2,0-0.4,0 c-0.3,0.2-0.5,0.5-0.5,0.8c0,0.1,0,0.2,0.1,0.2l0,0l-0.3-0.2C252.4,94.1,252.4,94,252.4,93.9z"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M251.4,94.8c0,0.3,0.2,0.4,0.5,0.2c0.3-0.2,0.5-0.5,0.5-0.8s-0.2-0.4-0.5-0.2S251.4,94.5,251.4,94.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M251.6,94.7c0,0.2,0.1,0.2,0.3,0.1c0.2-0.1,0.3-0.3,0.3-0.5s-0.1-0.2-0.3-0.1S251.6,94.5,251.6,94.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M251.1,94.6c0-0.3,0.2-0.6,0.5-0.8c0.1-0.1,0.3-0.1,0.4,0l0.3,0.2l0,0c-0.1-0.1-0.2,0-0.4,0 c-0.3,0.2-0.5,0.5-0.5,0.8c0,0.1,0,0.2,0.1,0.2l0,0l-0.3-0.2C251.2,94.8,251.1,94.7,251.1,94.6z"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M266.9,85c0,0.3,0.2,0.4,0.5,0.2c0.3-0.2,0.5-0.5,0.5-0.8s-0.2-0.4-0.5-0.2 C267.1,84.4,266.9,84.7,266.9,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M267.1,84.9c0,0.2,0.1,0.2,0.3,0.1c0.2-0.1,0.3-0.3,0.3-0.5s-0.1-0.2-0.3-0.1 C267.2,84.5,267.1,84.7,267.1,84.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M266.6,84.9c0-0.3,0.2-0.6,0.5-0.8c0.1-0.1,0.3-0.1,0.4,0l0.3,0.2l0,0c-0.1-0.1-0.2,0-0.4,0 c-0.3,0.2-0.5,0.5-0.5,0.8c0,0.1,0,0.2,0.1,0.2l0,0l-0.3-0.2C266.7,85.1,266.6,85,266.6,84.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "267.6,82.9 267.6,85.1 268,84.9 268,82.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "267.5,82.4 268,82.7 267.6,82.9 267.2,82.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "267.6,82.9 267.6,85.1 267.2,84.8 267.2,82.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M267.6,85.4c0,0.3,0.2,0.4,0.5,0.2s0.5-0.5,0.5-0.8s-0.2-0.4-0.5-0.2S267.6,85.2,267.6,85.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M267.8,85.3c0,0.2,0.1,0.2,0.3,0.1c0.2-0.1,0.3-0.3,0.3-0.5s-0.1-0.2-0.3-0.1S267.8,85.1,267.8,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M267.3,85.3c0-0.3,0.2-0.6,0.5-0.8c0.1-0.1,0.3-0.1,0.4,0l0.3,0.2l0,0c-0.1-0.1-0.2,0-0.4,0 c-0.3,0.2-0.5,0.5-0.5,0.8c0,0.1,0,0.2,0.1,0.2l0,0l-0.3-0.2C267.4,85.5,267.3,85.4,267.3,85.3z"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M223.4,92.7l9.9,3.7l4.2-2.6l-11.7-1.7c-0.5-0.1-1.1,0-1.5,0.2L223.4,92.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "234,96 234.1,95.9 225.9,92.8 225,93.3 225.3,93.4 225.9,93 233.9,96.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "223.4,92.7 223.4,92.9 233.2,96.8 233.3,96.4  "
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M253.3,82.6c0-0.9-0.7-2-1.6-2.6c-0.5-0.3-0.9-0.3-1.2-0.1l0,0l-2.7,1.5l0,0c0,0,0,0,0.1,0 c-0.1,0-0.2,0.1-0.2,0.2l0,0l-1.6,1.7l1.7,2.4l2.3-0.6l0,0c0.1,0,0.1,0,0.2-0.1l0,0l0,0l2.7-1.5l0,0 C253.1,83.3,253.3,83,253.3,82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M253.3,82.6c0-0.9-0.7-2-1.6-2.6c-0.1-0.1-0.3-0.1-0.4-0.2c0,0-3.1,1.6-3.3,2.2s-0.8,2.8,2.1,2.5l3.3-1.8 C253.3,82.7,253.3,82.6,253.3,82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M248.1,85c0,0.6-0.5,0.8-1.1,0.5c-0.6-0.4-1.1-1.1-1.1-1.8c0-0.6,0.5-0.8,1.1-0.5 C247.6,83.6,248.1,84.4,248.1,85z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M247.9,84.9c0-0.5-0.4-1.2-0.9-1.5c-0.3-0.2-0.6-0.2-0.8-0.1l0,0l-2.4,1.9l0,0c0.1-0.1,0.3-0.1,0.5,0 c0.4,0.2,0.7,0.7,0.7,1c0,0.2-0.1,0.3-0.2,0.3l0,0l2.8-1.3l0,0C247.8,85.3,247.9,85.1,247.9,84.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M245,86.3c0,0.4-0.3,0.5-0.7,0.3s-0.7-0.7-0.7-1s0.3-0.5,0.7-0.3C244.7,85.5,245,85.9,245,86.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M244.5,86.4c-0.3-0.2-0.5-0.5-0.5-0.8c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.2,0.1-0.2,0.3 c0,0.3,0.2,0.7,0.5,0.8c0.2,0.1,0.4,0.1,0.5,0C244.8,86.4,244.7,86.4,244.5,86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M244.4,85.4c-0.1-0.1-0.2-0.1-0.3-0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.3,0.2,0.7,0.5,0.8 c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C244.9,85.9,244.7,85.6,244.4,85.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M244.1,80.5c0-0.9-0.7-2-1.6-2.6c-0.5-0.3-0.9-0.3-1.2-0.1l0,0l-2.7,1.5l0,0c0,0,0,0,0.1,0 c-0.1,0-0.2,0.1-0.2,0.2l0,0l-1.6,1.7l1.7,2.4l2.3-0.6l0,0c0.1,0,0.1,0,0.2-0.1l0,0l0,0l2.7-1.5l0,0 C243.9,81.1,244.1,80.9,244.1,80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M244.1,80.5c0-0.9-0.7-2-1.6-2.6c-0.1-0.1-0.3-0.1-0.4-0.2c0,0-3.1,1.6-3.3,2.2s-0.8,2.8,2.1,2.5l3.3-1.8 C244.1,80.5,244.1,80.5,244.1,80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M238.9,82.8c0,0.6-0.5,0.8-1.1,0.5c-0.6-0.4-1.1-1.1-1.1-1.8c0-0.6,0.5-0.8,1.1-0.5 C238.4,81.4,238.9,82.2,238.9,82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M238.7,82.7c0-0.5-0.4-1.2-0.9-1.5c-0.3-0.2-0.6-0.2-0.8-0.1l0,0l-2.4,1.9l0,0c0.1-0.1,0.3-0.1,0.5,0 c0.4,0.2,0.7,0.7,0.7,1c0,0.2-0.1,0.3-0.2,0.3l0,0l2.8-1.3l0,0C238.6,83.2,238.7,83,238.7,82.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M235.8,84.2c0,0.4-0.3,0.5-0.7,0.3s-0.7-0.7-0.7-1c0-0.4,0.3-0.5,0.7-0.3 C235.5,83.3,235.8,83.8,235.8,84.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M235.3,84.2c-0.3-0.2-0.5-0.5-0.5-0.8c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.2,0.1-0.2,0.3 c0,0.3,0.2,0.7,0.5,0.8c0.2,0.1,0.4,0.1,0.5,0C235.6,84.3,235.5,84.3,235.3,84.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M235.2,83.3c-0.1-0.1-0.2-0.1-0.3-0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.3,0.2,0.7,0.5,0.8 c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C235.7,83.8,235.5,83.4,235.2,83.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M252.5,81.8l-23.8-6.2c-0.6-0.2-1.2-0.1-1.8,0.2l-1.8,1l17.8,7.3l4,2.9L252.5,81.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "242.9,84.1 243,84.2 243.2,84.3 244.9,83.3 244.8,83.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "231.8,79.6 232.1,79.7 233.2,79.1 233.1,78.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "248.3,85.8 248.5,85.7 244.8,83 228,77.1 227,77.6 227.2,77.7 228,77.3 244.7,83.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "243,84.2 225.2,76.8 225.2,77 243,84.7 247,87.6 247,87  "
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M251.5,83.4c1.7-1.6,3.1-2.4,5.7-3.9c0,0,4.7-2.8,6.3-3.8c1.3-0.7,2.3-1.3,3.4-1.6c0.5-0.2,1.1-0.2,1.7-0.1 c0.3,0,0.7,0.1,1.1,0.2c-0.8-0.4-1.5-0.6-2.1-0.7s-1.1-0.1-1.7,0.1c-1,0.3-2,0.9-3.4,1.6c-1.7,0.9-6.3,3.8-6.3,3.8 c-2.5,1.5-3.9,2.3-5.7,3.9c-1.7,1.6-6.7,4.3-7.7,5.1c-1.1,0.8-10.7,8.1-10.7,8.1l0.1,0.2c1.9-1.3,10.6-7.1,11.6-7.8 C244.9,87.7,249.8,85,251.5,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M272.4,75.5c-0.2-0.1-0.5-0.2-0.8-0.3c-0.4-0.1-0.7-0.2-0.7-0.2c-0.4-0.4-0.8-0.6-1.2-0.8 c-0.4-0.1-0.8-0.1-1.1-0.2c-0.6-0.1-1.1-0.1-1.7,0.1c-1,0.3-2,0.9-3.4,1.6c-1.7,0.9-6.3,3.8-6.3,3.8c-2.5,1.5-3.9,2.3-5.7,3.9 c-1.7,1.6-6.7,4.3-7.7,5.1c-0.9,0.7-9.6,6.5-11.6,7.8l0.3,0.5l16.6-7.9c0,0,2-0.9,4.4-2.5c1.2-0.8,2.5-2,3.9-2.8 c5.4-3.2,11.3-6.5,11.8-6.8c1.3-0.8,2.9-0.7,2.9-0.7c0.3,0,0.5,0,0.7,0s0.4,0,0.6,0C273.1,75.8,272.7,75.6,272.4,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M273.5,78.1c-0.3,0.2-0.7,0.5-0.9,0.7c0,0-0.6,0.7-1.8,1.4c-1,0.6-20.2,12.1-20.2,12.1s-4.1,2.2-6.8,2.6 L233,97.5l0.2,0.3l10.4-1.9c2.8-0.4,5.6-1.8,5.6-1.8s21-12.3,21.9-13c0.7-0.6,1.7-1.5,2.3-2.1c0-0.1,0.1-0.1,0.1-0.2 c0.2-0.4,0.3-0.7,0.4-1C273.7,77.9,273.6,78,273.5,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M271.1,81.1c-0.9,0.7-21.9,13-21.9,13s-2.9,1.4-5.6,1.8l-10.4,1.9l0,0l11-1c2.8-0.4,5.4-2.1,5.4-2.1 s20.6-12,21.5-12.7s1.6-2,1.6-2c0.3-0.3,0.5-0.6,0.7-1C272.8,79.7,271.9,80.6,271.1,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M273.8,76.8c-0.1-0.2-0.2-0.4-0.4-0.6c-0.1,0-0.3,0-0.6,0c-0.2,0-0.4,0-0.7,0c0,0-1.6-0.1-2.9,0.7 c-0.5,0.3-6.4,3.6-11.8,6.8c-1.4,0.9-2.7,2-3.9,2.8c-2.5,1.6-4.4,2.5-4.4,2.5l-16.6,7.9l0.3,0.4l10.4-3.4 c2.8-0.8,6.9-2.7,6.9-2.7s2-0.9,4.4-2.5c1.2-0.8,2.5-2,3.9-2.8c5.4-3.2,11.3-6.5,11.8-6.8c1.3-0.8,2.4-1.3,2.4-1.3 c0.3-0.1,0.6-0.2,0.8-0.3c0.2-0.1,0.3-0.2,0.4-0.3C273.9,77,273.9,76.9,273.8,76.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M273.9,77.1c-0.1,0.1-0.2,0.2-0.4,0.3c-0.2,0.1-0.5,0.2-0.8,0.3c0,0-1.1,0.5-2.4,1.3 c-0.5,0.3-6.4,3.6-11.8,6.8c-1.4,0.9-2.7,2-3.9,2.8c-2.5,1.6-4.4,2.5-4.4,2.5s-4.1,1.9-6.9,2.7l-10.4,3.4l0.2,0.3l10.8-2.6 c2.8-0.4,6.8-2.6,6.8-2.6s19.2-11.5,20.2-12.1c1.3-0.8,1.8-1.4,1.8-1.4c0.3-0.3,0.6-0.5,0.9-0.7c0.1-0.1,0.2-0.1,0.3-0.2 C273.9,77.6,273.9,77.3,273.9,77.1z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7992 -0.6011 0.6011 0.7992 -11.5145 159.4132)",
    className: "st16",
    cx: 232.8,
    cy: 96.9,
    rx: 0.6,
    ry: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M233.3,97.3c0-0.3-0.2-0.6-0.5-0.8c-0.2-0.1-0.3-0.1-0.4,0l0,0l-0.7,0.4l0.8,1.1l0.7-0.4l0,0 C233.2,97.5,233.3,97.4,233.3,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M232.6,97.6c0,0.3-0.2,0.4-0.5,0.2c-0.3-0.2-0.5-0.5-0.5-0.8s0.2-0.4,0.5-0.2 C232.4,97,232.6,97.4,232.6,97.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M270.3,74.6l1,0.6c0,0,0.6,0.5,0.8,0.8c0.1,0.3,0.1,0.8-0.3,1.2l-1,0.8l-0.6-1.2c0,0,1-0.7,0.9-1.2 C271,75.1,270.6,74.7,270.3,74.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M258.1,83.8l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C258.3,83.9,258.3,83.7,258.1,83.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M258.8,83.4l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C259,83.5,259,83.3,258.8,83.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M259.5,83l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C259.7,83.1,259.7,82.9,259.5,83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M260.2,82.6l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0,0,0.1-0.1,0.1-0.3 l-0.3-0.8C260.4,82.7,260.4,82.5,260.2,82.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M260.9,82.2l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0,0,0.1-0.1,0.1-0.3 l-0.3-0.8C261.1,82.3,261.1,82.1,260.9,82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M261.6,81.8l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1L262,83c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C261.8,81.9,261.8,81.7,261.6,81.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M262.3,81.4l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C262.5,81.5,262.5,81.3,262.3,81.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M263,80.9l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C263.3,81.1,263.2,80.9,263,80.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M263.7,80.5l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.2-0.7C264,80.7,263.9,80.5,263.7,80.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M264.4,80.1l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C264.7,80.3,264.6,80.1,264.4,80.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M265.1,79.7l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C265.4,79.9,265.3,79.7,265.1,79.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M265.8,79.3l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C266.1,79.5,266,79.3,265.8,79.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M266.5,78.9l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C266.8,79,266.7,78.8,266.5,78.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M267.2,78.5l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C267.5,78.6,267.4,78.4,267.2,78.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M267.9,78.1l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C268.2,78.2,268.1,78,267.9,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M268.6,77.7l-0.2,0.1c0,0-0.2,0.1-0.1,0.3l0.3,0.8c0,0,0.1,0.2,0.2,0.1l0.2-0.1c0.1,0,0.1-0.1,0.1-0.3 l-0.3-0.8C268.9,77.8,268.8,77.6,268.6,77.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M253.6,89.1l-0.1,0.1c0,0-0.2,0.1-0.2,0.3s0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3v-0.8 C253.8,89.2,253.8,89.1,253.6,89.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M254.3,88.7l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C254.5,88.8,254.5,88.7,254.3,88.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M251.4,90.3l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C251.6,90.5,251.6,90.3,251.4,90.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M250.7,90.7l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C250.9,90.9,250.9,90.7,250.7,90.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M250,91.2l-0.1,0.1c0,0-0.2,0.1-0.2,0.3s0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3v-0.8 C250.2,91.3,250.2,91.1,250,91.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M249.3,91.6l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C249.4,91.7,249.4,91.5,249.3,91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M255,88.3l-0.1,0.1c0,0-0.2,0.1-0.2,0.3s0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3v-0.8 C255.2,88.4,255.2,88.3,255,88.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M255.8,87.9l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 V88C255.9,88,255.9,87.8,255.8,87.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M256.5,87.5l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C256.6,87.6,256.6,87.4,256.5,87.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M257.2,87.1l-0.1,0.1c0,0-0.2,0.1-0.2,0.3s0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3v-0.8 C257.4,87.2,257.4,87,257.2,87.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M252.5,89.6l-0.1,0.1c0,0-0.2,0.1-0.2,0.3s0,0.5,0,0.5s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3v-0.5 C252.6,89.7,252.6,89.6,252.5,89.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M252.2,91.7h-0.1c-0.1-0.1-0.1-0.2-0.1-0.2s-0.1-1-0.1-1.3c0-0.4,0.3-0.6,0.3-0.6l0.3-0.2 c0.1,0,0.2,0,0.2,0c0.1,0.1,0.1,0.2,0.1,0.2l0.1,1.4c0,0.3-0.2,0.5-0.3,0.5l-0.3,0.2C252.4,91.7,252.3,91.7,252.2,91.7z  M252.1,91.4c0,0,0,0.1,0.1,0.2c0,0,0.1,0,0.2,0l0.3-0.2l0,0c0,0,0.2-0.2,0.2-0.4l-0.1-1.4c0,0,0-0.1-0.1-0.2c0,0-0.1,0-0.2,0 l-0.3,0.1c0,0-0.3,0.2-0.3,0.5C252,90.5,252.1,91.4,252.1,91.4L252.1,91.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M263.6,83.2l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C263.7,83.3,263.7,83.1,263.6,83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M262.8,83.6l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C263,83.7,263,83.5,262.8,83.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M261.4,84.4l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C261.6,84.5,261.6,84.3,261.4,84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M262.1,84l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C262.3,84.1,262.3,84,262.1,84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M264.3,82.8l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C264.4,82.9,264.4,82.7,264.3,82.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M265,82.3l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C265.2,82.5,265.2,82.3,265,82.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M265.7,81.9l-0.1,0.1c0,0-0.2,0.1-0.2,0.3s0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3V82 C265.9,82.1,265.9,81.9,265.7,81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M266.4,81.5l-0.1,0.1c0,0-0.2,0.1-0.2,0.3s0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3v-0.8 C266.6,81.6,266.6,81.5,266.4,81.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M267.2,81.1l-0.1,0.1c0,0-0.2,0.1-0.2,0.3s0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3v-0.8 C267.3,81.2,267.3,81.1,267.2,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M261.4,84.4l-0.1,0.1c0,0-0.2,0.1-0.2,0.3s0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3v-0.8 C261.6,84.6,261.6,84.4,261.4,84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M260.7,84.8l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C260.8,84.9,260.8,84.8,260.7,84.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M260,85.3l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.8C260.1,85.4,260.1,85.2,260,85.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M259.2,85.7l-0.1,0.1c0,0-0.2,0.1-0.2,0.3s0,0.8,0,0.8s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3v-0.8 C259.4,85.8,259.4,85.6,259.2,85.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M268.4,80.3l-0.1,0.1c0,0-0.2,0.1-0.2,0.3c0,0.2,0,0.5,0,0.5s0,0.2,0.2,0.1l0.1-0.1c0,0,0.1-0.1,0.1-0.3 v-0.5C268.6,80.4,268.6,80.2,268.4,80.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M268.2,82.4h-0.1c-0.1-0.1-0.1-0.2-0.1-0.2s-0.1-1-0.1-1.3c0-0.4,0.3-0.6,0.3-0.6l0.3-0.2 c0.1,0,0.2,0,0.2,0c0.1,0.1,0.1,0.2,0.1,0.2l0.1,1.4c0,0.3-0.2,0.5-0.3,0.5l-0.3,0.2C268.3,82.3,268.2,82.4,268.2,82.4z  M268,82.1c0,0,0,0.1,0.1,0.2c0.1,0,0.1,0,0.2,0l0.3-0.2l0,0c0,0,0.2-0.2,0.2-0.4l-0.1-1.4c0,0,0-0.1-0.1-0.2c0,0-0.1,0-0.2,0 l-0.3,0.1c0,0-0.3,0.2-0.3,0.5C267.9,81.1,268,82.1,268,82.1L268,82.1z"
  }))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M268.5,91.6c0-0.9-0.7-2-1.6-2.6c-0.5-0.3-0.9-0.3-1.2-0.1l0,0l-2.7,1.5l0,0c0,0,0,0,0.1,0 c-0.1,0-0.2,0.1-0.2,0.2l0,0l-1.6,1.7l1.7,2.4l2.3-0.6l0,0c0.1,0,0.1,0,0.2-0.1l0,0l0,0l2.7-1.5l0,0 C268.4,92.2,268.5,92,268.5,91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M268.5,91.6c0-0.9-0.7-2-1.6-2.6c-0.1-0.1-0.3-0.1-0.4-0.2c0,0-3.1,1.6-3.3,2.2c-0.2,0.6-0.8,2.8,2.1,2.5 l3.3-1.8C268.5,91.6,268.5,91.6,268.5,91.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M263.4,93.9c0,0.6-0.5,0.8-1.1,0.5c-0.6-0.4-1.1-1.1-1.1-1.8c0-0.6,0.5-0.8,1.1-0.5 C262.9,92.5,263.4,93.3,263.4,93.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M263.2,93.8c0-0.5-0.4-1.2-0.9-1.5c-0.3-0.2-0.6-0.2-0.8-0.1l0,0l-2.4,1.9l0,0c0.1-0.1,0.3-0.1,0.5,0 c0.4,0.2,0.7,0.7,0.7,1c0,0.2-0.1,0.3-0.2,0.3l0,0l2.8-1.3l0,0C263.1,94.3,263.2,94.1,263.2,93.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M260.3,95.3c0,0.4-0.3,0.5-0.7,0.3c-0.4-0.2-0.7-0.7-0.7-1c0-0.4,0.3-0.5,0.7-0.3 C260,94.4,260.3,94.9,260.3,95.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M259.8,95.3c-0.3-0.2-0.5-0.5-0.5-0.8c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.2,0.1-0.2,0.3 c0,0.3,0.2,0.7,0.5,0.8c0.2,0.1,0.4,0.1,0.5,0C260,95.4,259.9,95.4,259.8,95.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M259.6,94.4c-0.1-0.1-0.2-0.1-0.3-0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.3,0.2,0.7,0.5,0.8 c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C260.2,94.9,259.9,94.5,259.6,94.4z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M270.7,95.9c0-0.9-0.7-2-1.6-2.6c-0.5-0.3-0.9-0.3-1.2-0.1l0,0l-2.7,1.5l0,0c0,0,0,0,0.1,0 c-0.1,0-0.2,0.1-0.2,0.2l0,0l-1.6,1.7l1.7,2.4l2.3-0.6l0,0c0.1,0,0.1,0,0.2-0.1l0,0l0,0l2.7-1.5l0,0 C270.6,96.6,270.7,96.3,270.7,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M270.7,95.9c0-0.9-0.7-2-1.6-2.6c-0.1-0.1-0.3-0.1-0.4-0.2c0,0-3.1,1.6-3.3,2.2c-0.2,0.6-0.8,2.8,2.1,2.5 l3.3-1.8C270.7,96,270.7,95.9,270.7,95.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M265.5,98.3c0,0.6-0.5,0.8-1.1,0.5c-0.6-0.4-1.1-1.1-1.1-1.8c0-0.6,0.5-0.8,1.1-0.5 C265,96.9,265.5,97.7,265.5,98.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M265.4,98.2c0-0.5-0.4-1.2-0.9-1.5c-0.3-0.2-0.6-0.2-0.8-0.1l0,0l-2.4,1.9l0,0c0.1-0.1,0.3-0.1,0.5,0 c0.4,0.2,0.7,0.7,0.7,1c0,0.2-0.1,0.3-0.2,0.3l0,0l2.8-1.3l0,0C265.3,98.6,265.4,98.5,265.4,98.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M262.5,99.6c0,0.4-0.3,0.5-0.7,0.3c-0.4-0.2-0.7-0.7-0.7-1s0.3-0.5,0.7-0.3S262.5,99.3,262.5,99.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M262,99.7c-0.3-0.2-0.5-0.5-0.5-0.8c0-0.1,0-0.2,0.1-0.2c-0.1,0-0.2,0.1-0.2,0.3c0,0.3,0.2,0.7,0.5,0.8 c0.2,0.1,0.4,0.1,0.5,0C262.2,99.8,262.1,99.7,262,99.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M261.8,98.7c-0.1-0.1-0.2-0.1-0.3-0.1c0,0.1-0.1,0.1-0.1,0.2c0,0.3,0.2,0.7,0.5,0.8 c0.1,0.1,0.2,0.1,0.3,0.1c0-0.1,0.1-0.1,0.1-0.2C262.3,99.3,262.1,98.9,261.8,98.7z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M270.9,100.8l-2,1.2l-9.8-8.6l-4.9-2.2v0.7l4.9,2.2l9.8,8L270.9,100.8c0.2,0,0.4-0.3,0.3-0.6 C271.2,100.5,271.1,100.7,270.9,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M254.2,91.2l8.2-4.8l8.7,13.5c0.2,0.3,0.1,0.7-0.2,0.9l-2,1.2l-9.8-8.6L254.2,91.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "256,90.1 255.8,90.2 255.9,90.2 260.8,92.5 268,100.1 267.2,100.5 267.3,100.7 268.4,100.1  260.9,92.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "264.4,98.1 264.5,98.2 265.8,97.5 265.6,97.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "260.9,92.4 259.1,93.4 259.1,93.4 259.2,93.5 261,92.5  "
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M234,97l5.8,5.3l1.1-0.5c0.3-0.2,0.5-0.5,0.4-0.9l-1.9-5.4L234,97z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "239.1,101.6 240,101.1 235.1,96.6 234.9,96.7 234.9,96.8 239.7,101.1 239,101.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M241.2,100.9L241.2,100.9c0,0.3-0.1,0.6-0.4,0.7l-1.1,0.5l-5.8-5.3v0.4l5.8,5l1.1-0.5 C241.2,101.7,241.4,101.3,241.2,100.9z"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M241.3,90.5l-7-4.8c-0.4-0.3-1-0.3-1.4-0.1l-1.5,0.8l2.5,9L241.3,90.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "232.4,85.9 234.9,94.7 235.1,94.6 232.6,85.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M232.9,85.6c0.4-0.2,0.9-0.2,1.3,0l0,0C233.9,85.3,233.2,85.3,232.9,85.6l-1.6,0.8l2.2,8.8l0.4,0.2l-2.5-9 L232.9,85.6z"
  })))), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "401.1,148.5 284.8,215.4 72.8,93.1 162.6,41.3 298.3,119.2 343,115.2  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "76.9,95.4 102.9,80.5 108.6,77.1 178.3,119.7 175.7,122.3 149.7,137.6  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "284.8,215.4 268,225.1 56.1,102.7 72.8,93.1  "
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "268,225 268,226.3 284.8,216.7 284.8,215.4  "
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "342.1,182.5 342.1,183.8 401.1,149.8 401.1,148.5  "
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "268,225.1 268,226.4 55,103.4 56.1,102.7  "
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "149.7,136.3 149.7,137.6 284.8,215.4 284.8,214.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "175.7,121 219.9,146.8 230.3,140.7 290.1,175.3 310.9,163.2 342.1,181.2 284.8,214.1 149.7,136.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "284.8,214.1 284.8,216.7 342.1,183.8 342.1,181.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "152.3,136.3 175.7,122.6 219.9,148.2 230.3,142.2 290.1,176.7 310.9,164.7 339.5,181.2 284.8,212.7  "
  })))), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "179.2,116.9 129.3,88.2 113.4,97.4 95.3,97.4 95.3,98.9 111.2,98.9 157.9,125.9 144.7,125.9  144.7,127.4 160.6,127.4 160.9,127.5  "
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "131.4,177.7 132.8,176.9 133.2,177.2 131.9,177.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "134.1,176.1 135.5,175.3 136,175.6 134.6,176.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "136.9,174.5 138.2,173.7 138.7,174 137.3,174.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "139.6,173 141,172.2 141.4,172.4 140.1,173.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "142.3,171.4 143.7,170.6 144.2,170.8 142.8,171.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "145.1,169.8 146.4,169 146.9,169.3 145.5,170.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "147.8,168.2 149.2,167.4 149.6,167.7 148.3,168.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "150.5,166.6 151.9,165.9 152.4,166.1 151,166.9  "
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "179.6,204.6 180.8,203.8 181.3,204.1 179.9,204.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "182.3,203 183.6,202.2 184.1,202.5 182.6,203.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "184.9,201.4 186.3,200.6 186.8,200.9 185.4,201.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "187.6,199.8 189.1,199.1 189.6,199.3 188.1,200.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "190.4,198.3 191.8,197.5 192.3,197.7 190.8,198.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "193.1,196.7 194.6,195.9 194.9,196.2 193.6,197  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "195.8,195.1 197.3,194.3 197.8,194.6 196.3,195.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "198.6,193.5 199.9,192.7 200.4,193 199.1,193.8  "
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "83.7,150.3 85.1,149.5 85.6,149.7 84.2,150.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "86.5,148.7 87.8,147.9 88.3,148.2 86.9,148.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "89.2,147.1 90.6,146.3 91,146.6 89.7,147.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "91.9,145.5 93.3,144.7 93.8,145 92.4,145.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "94.7,144 96,143.2 96.5,143.4 95.1,144.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "97.4,142.4 98.8,141.6 99.2,141.8 97.8,142.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "100.1,140.8 101.5,140 101.9,140.3 100.6,141.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "102.9,139.2 104.2,138.4 104.7,138.7 103.3,139.5  "
  }))), /*#__PURE__*/React.createElement("g", null, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M223.1,182.2c-2.3-2.7-9.9-4.8-12.3-4.8c-2.1,0-1.1,1.9,0.9,4.3h-3.2c-0.1,0-0.1,0.1-0.1,0.2 c0.1,0.3,0,0.7,0.3,0.9c0.2,0.1,0.3,0.2,0.4,0.2h3.7c2.1,2.3,4.3,4.1,6.4,4.1C221.5,187.1,225.4,184.9,223.1,182.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 208.2051,
    y1: 86.3529,
    x2: 210.1357,
    y2: 86.3529,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8B17E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#695133"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M210.1,182.4v-6h-1.9v6l0,0c0,0.1,0.1,0.3,0.3,0.4c0.4,0.2,1,0.2,1.4,0C210,182.7,210.1,182.5,210.1,182.4 z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M209.9,175.9c0.4,0.2,0.4,0.6,0,0.8s-1,0.2-1.4,0s-0.4-0.6,0-0.8S209.5,175.7,209.9,175.9z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 204.6463,
    y1: 97.4354,
    x2: 214.2359,
    y2: 89.6856,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59E529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#47DE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3ABA56"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M217,175.8c0,4.4-3.6,5.3-7.9,5.3c-4.4,0-7.9-0.9-7.9-5.3c0-4.4,3.6-15.3,7.9-15.3 C213.5,160.6,217,171.4,217,175.8z"
  })))), /*#__PURE__*/React.createElement("g", null, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M247.9,195.3c-2.3-2.7-9.9-4.8-12.3-4.8c-2.1,0-1.1,1.9,0.9,4.3h-3.2c-0.1,0-0.1,0.1-0.1,0.2 c0.1,0.3,0,0.7,0.3,0.9c0.2,0.1,0.3,0.2,0.4,0.2h3.7c2.1,2.3,4.3,4.1,6.4,4.1C246.4,200.1,250.3,198,247.9,195.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 233.0558,
    y1: 73.3529,
    x2: 234.9864,
    y2: 73.3529,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8B17E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#695133"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M235,195.4v-6h-1.9v6l0,0c0,0.1,0.1,0.3,0.3,0.4c0.4,0.2,1,0.2,1.4,0C234.9,195.7,235,195.6,235,195.4z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M234.7,189c0.4,0.2,0.4,0.6,0,0.8s-1,0.2-1.4,0s-0.4-0.6,0-0.8S234.3,188.8,234.7,189z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 229.5063,
    y1: 84.3831,
    x2: 239.0959,
    y2: 76.6333,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59E529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#47DE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3ABA56"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M241.9,188.9c0,4.4-3.6,5.3-7.9,5.3s-7.9-0.9-7.9-5.3s3.6-15.3,7.9-15.3S241.9,184.5,241.9,188.9z"
  })))), /*#__PURE__*/React.createElement("g", null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M278.5,199.5c-2.3-2.7-9.9-4.8-12.3-4.8c-2.1,0-1.1,1.9,0.9,4.3H264c-0.1,0-0.1,0.1-0.1,0.2 c0.1,0.3,0,0.7,0.3,0.9c0.2,0.1,0.3,0.2,0.4,0.2h3.7c2.1,2.3,4.3,4.1,6.4,4.1C276.9,204.3,280.8,202.1,278.5,199.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 263.5961,
    y1: 69.1529,
    x2: 265.5268,
    y2: 69.1529,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8B17E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#695133"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M265.5,199.6v-6h-1.9v6l0,0c0,0.1,0.1,0.3,0.3,0.4c0.4,0.2,1,0.2,1.4,0 C265.4,199.9,265.5,199.7,265.5,199.6z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M265.2,193.2c0.4,0.2,0.4,0.6,0,0.8s-1,0.2-1.4,0s-0.4-0.6,0-0.8C264.3,193,264.9,193,265.2,193.2z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 260.0146,
    y1: 80.1763,
    x2: 269.6043,
    y2: 72.4266,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59E529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#47DE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3ABA56"
    }
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M272.4,193.1c0,4.4-3.6,5.3-7.9,5.3s-7.9-0.9-7.9-5.3s3.6-15.3,7.9-15.3S272.4,188.7,272.4,193.1z"
  })))), /*#__PURE__*/React.createElement("g", null, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M197.6,166.9c-2.3-2.7-9.9-4.8-12.3-4.8c-2.1,0-1.1,1.9,0.9,4.3H183c-0.1,0-0.1,0.1-0.1,0.2 c0.1,0.3,0,0.7,0.3,0.9c0.2,0.1,0.3,0.2,0.4,0.2h3.7c2.1,2.3,4.3,4.1,6.4,4.1C196,171.7,199.9,169.6,197.6,166.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.7055,
    y1: 101.7529,
    x2: 184.6362,
    y2: 101.7529,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8B17E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#695133"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M184.6,167v-6h-1.9v6l0,0c0,0.1,0.1,0.3,0.3,0.4c0.4,0.2,1,0.2,1.4,0C184.5,167.3,184.6,167.2,184.6,167z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M184.4,160.6c0.4,0.2,0.4,0.6,0,0.8s-1,0.2-1.4,0s-0.4-0.6,0-0.8S184,160.4,184.4,160.6z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 179.132,
    y1: 112.7646,
    x2: 188.7217,
    y2: 105.0148,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59E529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#47DE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3ABA56"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M191.5,160.5c0,4.4-3.6,5.3-7.9,5.3c-4.4,0-7.9-0.9-7.9-5.3c0-4.4,3.6-15.3,7.9-15.3 C188,145.2,191.5,156.1,191.5,160.5z"
  })))), /*#__PURE__*/React.createElement("g", null, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M102.1,109.9c-2.2-2.6-9.6-4.7-11.8-4.7c-2.1,0-1.1,1.8,0.9,4.1h-3.1c-0.1,0-0.1,0.1-0.1,0.2 c0.1,0.2,0,0.6,0.3,0.9c0.2,0.1,0.3,0.2,0.4,0.2h3.5c2,2.3,4.1,4,6.1,4C100.6,114.5,104.3,112.4,102.1,109.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.7437,
    y1: 158.6529,
    x2: 89.6064,
    y2: 158.6529,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8B17E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#695133"
    }
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M89.6,110v-5.8h-1.9v5.8l0,0c0,0.1,0.1,0.3,0.3,0.4c0.4,0.2,1,0.2,1.3,0C89.5,110.3,89.6,110.1,89.6,110z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M89.3,103.8c0.4,0.2,0.4,0.6,0,0.8c-0.4,0.2-1,0.2-1.3,0s-0.4-0.6,0-0.8C88.4,103.6,89,103.6,89.3,103.8z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.248,
    y1: 169.2402,
    x2: 93.5002,
    y2: 161.7631,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59E529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#47DE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3ABA56"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M96.2,103.7c0,4.2-3.4,5.1-7.7,5.1c-4.2,0-7.7-0.9-7.7-5.1S84.2,89,88.5,89C92.8,89,96.2,99.5,96.2,103.7z"
  })))), /*#__PURE__*/React.createElement("g", null, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M116.8,96.8c-2.2-2.6-9.6-4.7-11.8-4.7c-2.1,0-1.1,1.8,0.9,4.1h-3.1c-0.1,0-0.1,0.1-0.1,0.2 c0.1,0.2,0,0.6,0.3,0.9c0.2,0.1,0.3,0.2,0.4,0.2h3.5c2,2.3,4.1,4,6.1,4C115.3,101.5,119.1,99.4,116.8,96.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 102.4661,
    y1: 171.7529,
    x2: 104.3288,
    y2: 171.7529,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E8B17E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#695133"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M104.3,96.9v-5.8h-1.9v5.8l0,0c0,0.1,0.1,0.3,0.3,0.4c0.4,0.2,1,0.2,1.3,0 C104.2,97.2,104.3,97.1,104.3,96.9z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M104.1,90.7c0.4,0.2,0.4,0.6,0,0.8s-1,0.2-1.3,0c-0.4-0.2-0.4-0.6,0-0.8C103.1,90.5,103.7,90.5,104.1,90.7 z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.004,
    y1: 182.3614,
    x2: 108.2562,
    y2: 174.8843,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59E529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#47DE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3ABA56"
    }
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M111,90.6c0,4.2-3.4,5.1-7.7,5.1c-4.2,0-7.7-0.9-7.7-5.1s3.4-14.7,7.7-14.7C107.5,75.9,111,86.4,111,90.6z"
  })))), /*#__PURE__*/React.createElement("g", null, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "88.7,130.4 68.5,142.1 48.2,130.4 68.5,118.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "68.5,142.1 68.5,143.1 88.7,131.4 88.7,130.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "48.2,130.4 48.2,131.4 68.5,143.1 68.5,142.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "50.2,130.4 68.5,119.9 86.7,130.4 68.5,140.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 71.7,
    cy: 129.2,
    rx: 5.3,
    ry: 3.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.453,
    y1: 139.0427,
    x2: 71.1716,
    y2: 135.2294,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59E529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#47DE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3ABA56"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M73.5,129.2c0,2.6-2.1,3.1-4.7,3.1s-4.7-0.5-4.7-3.1c0-2.6,2.1-4.7,4.7-4.7S73.5,126.6,73.5,129.2z"
  })))), /*#__PURE__*/React.createElement("g", null, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "139.6,157.8 119.4,169.5 99.1,157.8 119.4,146.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "119.4,169.5 119.4,170.5 139.6,158.8 139.6,157.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "99.1,157.8 99.1,158.8 119.4,170.5 119.4,169.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "101.1,157.8 119.4,147.3 137.6,157.8 119.4,168.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M126.3,154.4c2.1,1.2,2.1,3.1,0,4.3c-2.1,1.2-5.4,1.2-7.5,0s-2.1-3.1,0-4.3S124.3,153.2,126.3,154.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 117.3885,
    y1: 111.6544,
    x2: 122.1071,
    y2: 107.8411,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59E529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#47DE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3ABA56"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M124.4,156.6c0,2.6-2.1,3.1-4.7,3.1s-4.7-0.5-4.7-3.1s2.1-4.7,4.7-4.7S124.4,154,124.4,156.6z"
  })))), /*#__PURE__*/React.createElement("g", null, _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "185.2,184.5 165,196.1 144.7,184.5 165,172.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "165,196.1 165,197.1 185.2,185.5 185.2,184.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "144.7,184.5 144.7,185.5 165,197.1 165,196.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "146.7,184.5 165,173.9 183.2,184.5 165,195  "
  }))), /*#__PURE__*/React.createElement("g", null, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 168.2,
    cy: 183.3,
    rx: 5.3,
    ry: 3.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 162.9548,
    y1: 84.9995,
    x2: 167.6735,
    y2: 81.1861,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59E529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#47DE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3ABA56"
    }
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M170,183.2c0,2.6-2.1,3.1-4.7,3.1c-2.6,0-4.7-0.5-4.7-3.1s2.1-4.7,4.7-4.7C167.9,178.6,170,180.7,170,183.2 z"
  })))), /*#__PURE__*/React.createElement("g", null, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "232.7,212.2 212.5,223.9 192.2,212.2 212.5,200.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "212.5,223.9 212.5,224.9 232.7,213.2 232.7,212.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "192.2,212.2 192.2,213.2 212.5,224.9 212.5,223.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "194.2,212.2 212.5,201.7 230.7,212.2 212.5,222.8  "
  }))), /*#__PURE__*/React.createElement("g", null, _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st9",
    cx: 215.7,
    cy: 211,
    rx: 5.3,
    ry: 3.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 210.5283,
    y1: 57.2415,
    x2: 215.2469,
    y2: 53.4282,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#59E529"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5459,
    style: {
      stopColor: "#47DE3F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3ABA56"
    }
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st44",
    d: "M217.5,211c0,2.6-2.1,3.1-4.7,3.1c-2.6,0-4.7-0.5-4.7-3.1s2.1-4.7,4.7-4.7 C215.4,206.3,217.5,208.4,217.5,211z"
  })))), /*#__PURE__*/React.createElement("g", null, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M79.6,176.6l-34.3-19.8c-0.7-0.4-0.7-1.5,0-1.8l12.5-7.3c0.4-0.2,0.7-0.2,1.1,0l34.3,19.8 c0.7,0.4,0.7,1.5,0,1.8l-12.5,7.3C80.3,176.9,80,176.9,79.6,176.6z"
  })), /*#__PURE__*/React.createElement("g", null, _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "82.7,154.7 84,153.6 84,152.7 82.7,153.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "82.7,153.6 82.7,154.7 82.2,154.5 82.2,153.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "82.2,153.4 83.8,152.7 84,152.7 82.7,153.6  "
  }))), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "56.3,147.4 49.7,151.4 49.7,156.7 56.3,152.7  "
  })), /*#__PURE__*/React.createElement("g", null, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M56.1,158.8c0,1.8-1.3,2.2-3.1,1.3c-1.8-1.1-3.1-3.1-3.1-4.8c0-1.8,1.3-2.2,3.1-1.3 C54.6,155.1,56.1,157.3,56.1,158.8z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M58.1,157.8c0-1.8-1.3-4-3.1-4.8c-0.9-0.4-1.8-0.7-2.4-0.2l0,0l-2,1.1l0,0c0.7-0.2,1.3-0.2,2.4,0.2 c1.8,1.1,3.1,3.1,3.1,4.8c0,0.9-0.2,1.3-0.7,1.5l0,0l2-1.1l0,0C57.6,159.1,58.1,158.6,58.1,157.8z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M54.8,159.5l-0.9-1.8L55,158c0-0.4-0.2-0.7-0.4-1.1l-1.1-0.2v-1.3c-0.2-0.2-0.4-0.4-0.7-0.4 c0,0-0.2,0-0.2-0.2v1.3l-1.5-1.3c-0.2,0.2-0.2,0.4-0.2,0.7l1.3,1.3l-0.9,0.7c0.2,0.4,0.4,0.7,0.7,1.1l0.9-0.7l0.9,1.8 C54.3,159.7,54.6,159.5,54.8,159.5L54.8,159.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_19_",
    cx: -869.7988,
    cy: -500.8489,
    r: 2.188,
    gradientTransform: "matrix(1 0.5774 0 -1 922.7527 158.4035)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5407,
    style: {
      stopColor: "#FFF3EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7666,
    style: {
      stopColor: "#FDF1EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    style: {
      stopColor: "#F6ECE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    style: {
      stopColor: "#EBE2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9529,
    style: {
      stopColor: "#DAD5D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9926,
    style: {
      stopColor: "#C4C3C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFBFBE"
    }
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M54.8,159.5l-0.9-1.8l1.3,0.2c0-0.4-0.2-0.7-0.2-1.1l-1.5-0.2v-1.3c-0.2-0.2-0.2-0.2-0.4-0.4 c-0.2,0-0.2-0.2-0.4-0.2v1.5l-1.5-1.3c-0.2,0.2-0.2,0.4-0.2,0.7l1.3,1.3l-0.9,0.7c0.2,0.4,0.4,0.7,0.7,1.1l0.9-0.7l0.9,1.8 C54.3,159.7,54.6,159.7,54.8,159.5z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M53,156.9L53,156.9c-0.2,0-0.2,0-0.2-0.2C52.8,156.7,53,156.4,53,156.9C53,156.7,53,156.7,53,156.9z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M52.6,156.7C52.8,156.7,52.8,156.9,52.6,156.7C52.6,156.9,52.6,156.9,52.6,156.7 C52.6,156.7,52.4,156.7,52.6,156.7C52.6,156.4,52.6,156.7,52.6,156.7z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M52.6,157.1L52.6,157.1c0.2,0.2,0.2,0.2,0.2,0.2C52.6,157.3,52.6,157.3,52.6,157.1 C52.4,157.1,52.6,157.1,52.6,157.1z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M52.8,157.5C52.8,157.5,53,157.5,52.8,157.5c0.2,0,0.2,0,0.2,0.2C53,157.8,53,157.8,52.8,157.5 C53,157.8,52.8,157.5,52.8,157.5z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M53.2,157.8C53.2,157.5,53.2,157.5,53.2,157.8C53.2,157.5,53.5,157.5,53.2,157.8 C53.5,157.5,53.5,157.8,53.2,157.8C53.5,157.8,53.5,157.8,53.2,157.8z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M53.5,157.3C53.5,157.3,53.2,157.3,53.5,157.3c-0.2-0.2-0.2-0.2-0.2-0.2C53.5,157.1,53.5,157.1,53.5,157.3 L53.5,157.3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M53,157.3l-0.2-0.2c0-0.2,0-0.2,0-0.2l0.2,0.2C53.2,157.3,53.2,157.3,53,157.3z"
  })), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.8,159.7c-1.3-0.9-2.4-2.4-2.4-3.7c0-0.7,0.2-1.1,0.7-1.3c0.4-0.2,1.3-0.2,2,0.2 c1.3,0.9,2.4,2.4,2.4,3.7c0,0.7-0.2,1.1-0.7,1.3c-0.2,0.2-0.4,0.2-0.7,0.2C53.7,159.9,53.2,159.9,52.8,159.7z M51.5,154.9 c-0.4,0.2-0.4,0.7-0.4,0.9c0,1.1,0.9,2.6,2.2,3.3c0.7,0.2,1.1,0.4,1.3,0.2c0.4-0.2,0.4-0.7,0.4-0.9c0-1.1-0.9-2.6-2.2-3.3 c-0.4-0.2-0.7-0.2-0.9-0.2C51.7,154.9,51.5,154.9,51.5,154.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M52.8,159.7c-1.3-0.9-2.4-2.4-2.4-3.7c0-0.7,0.2-1.1,0.7-1.3c0.4-0.2,1.3-0.2,2,0.2 c1.3,0.9,2.4,2.4,2.4,3.7c0,0.7-0.2,1.1-0.7,1.3c-0.2,0.2-0.4,0.2-0.7,0.2C53.7,159.9,53.2,159.9,52.8,159.7z M51.5,154.9 c-0.4,0.2-0.4,0.7-0.4,0.9c0,1.1,0.9,2.6,2.2,3.3c0.7,0.2,1.1,0.4,1.3,0.2c0.4-0.2,0.4-0.7,0.4-0.9c0-1.1-0.9-2.6-2.2-3.3 c-0.4-0.2-0.7-0.2-0.9-0.2C51.7,154.9,51.5,154.9,51.5,154.9z"
  }))))), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "80.7,161.5 73.9,165.4 73.9,170.7 80.7,166.8  "
  })), /*#__PURE__*/React.createElement("g", null, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M80.3,172.9c0,1.8-1.3,2.2-3.1,1.3c-1.8-1.1-3.1-3.1-3.1-4.8c0-1.8,1.3-2.2,3.1-1.3 C78.9,169,80.3,171.2,80.3,172.9z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M82.2,171.8c0-1.8-1.3-4-3.1-4.8c-0.9-0.4-1.8-0.7-2.4-0.2l0,0l-2,1.1l0,0c0.7-0.2,1.3-0.2,2.4,0.2 c1.8,1.1,3.1,3.1,3.1,4.8c0,0.9-0.2,1.3-0.7,1.5l0,0l2-1.1l0,0C82,173.1,82.2,172.7,82.2,171.8z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M79.2,173.3l-0.9-1.8l1.1,0.2c0-0.4-0.2-0.7-0.4-1.1l-1.1-0.2v-1.3c-0.2-0.2-0.4-0.4-0.7-0.4 c0,0-0.2,0-0.2-0.2v1.3l-1.5-1.3c-0.2,0.2-0.2,0.4-0.2,0.7l1.3,1.3l-0.9,0.7c0.2,0.4,0.4,0.7,0.7,1.1l0.9-0.7l0.9,1.8 C78.7,173.6,78.9,173.6,79.2,173.3C79.2,173.6,79.2,173.6,79.2,173.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_20_",
    cx: -845.5547,
    cy: -500.8744,
    r: 2.188,
    gradientTransform: "matrix(1 0.5774 0 -1 922.7527 158.4035)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5407,
    style: {
      stopColor: "#FFF3EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7666,
    style: {
      stopColor: "#FDF1EB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848,
    style: {
      stopColor: "#F6ECE6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    style: {
      stopColor: "#EBE2DD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9529,
    style: {
      stopColor: "#DAD5D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9926,
    style: {
      stopColor: "#C4C3C2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BFBFBE"
    }
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M78.9,173.6l-0.9-1.8l1.3,0.2c0-0.4-0.2-0.7-0.2-1.1l-1.5-0.2v-1.5c-0.2-0.2-0.2-0.2-0.4-0.4 c-0.2,0-0.2-0.2-0.4-0.2v1.5l-1.5-1.3c-0.2,0.2-0.2,0.4-0.2,0.7l1.3,1.3l-0.9,0.7c0.2,0.4,0.4,0.7,0.7,1.1l0.9-0.7l0.9,1.8 C78.5,173.8,78.7,173.8,78.9,173.6z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M77.4,170.7C77.4,170.9,77.4,170.9,77.4,170.7c-0.2,0-0.2,0-0.2-0.2C77.2,170.5,77.2,170.5,77.4,170.7 L77.4,170.7z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M77,170.7C77,170.7,77,170.9,77,170.7C77,170.9,76.7,170.9,77,170.7C76.7,170.7,76.7,170.7,77,170.7 C76.7,170.5,76.7,170.5,77,170.7z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M76.7,170.9C76.7,170.9,77,171.2,76.7,170.9c0.2,0.2,0.2,0.2,0.2,0.2C76.7,171.4,76.7,171.4,76.7,170.9 C76.7,171.2,76.7,170.9,76.7,170.9z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M77.2,171.6C77.2,171.4,77.2,171.4,77.2,171.6c0.2,0,0.2,0,0.2,0.2C77.4,171.8,77.4,171.8,77.2,171.6 C77.2,171.8,77.2,171.6,77.2,171.6z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M77.6,171.8C77.4,171.6,77.4,171.6,77.6,171.8C77.6,171.4,77.6,171.4,77.6,171.8 C77.8,171.6,77.8,171.8,77.6,171.8L77.6,171.8z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M77.6,171.4L77.6,171.4c-0.2-0.2-0.2-0.2-0.2-0.2C77.6,170.9,77.6,171.2,77.6,171.4 C77.8,171.4,77.8,171.4,77.6,171.4z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M77.4,171.4l-0.2-0.2c0-0.2,0-0.2,0-0.2l0.2,0.2C77.4,171.4,77.4,171.4,77.4,171.4z"
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77,173.6c-1.3-0.9-2.4-2.4-2.4-3.7c0-0.7,0.2-1.1,0.7-1.3c0.4-0.2,1.3-0.2,2,0.2 c1.3,0.9,2.4,2.4,2.4,3.7c0,0.7-0.2,1.1-0.7,1.3c-0.2,0.2-0.4,0.2-0.7,0.2C77.8,174,77.4,174,77,173.6z M75.6,169 c-0.4,0.2-0.4,0.7-0.4,0.9c0,1.1,0.9,2.6,2.2,3.3c0.7,0.4,1.1,0.4,1.3,0.2c0.4-0.2,0.4-0.7,0.4-0.9c0-1.1-0.9-2.6-2.2-3.3 c-0.4-0.2-0.7-0.2-0.9-0.2C75.9,168.7,75.6,169,75.6,169z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M77,173.6c-1.3-0.9-2.4-2.4-2.4-3.7c0-0.7,0.2-1.1,0.7-1.3c0.4-0.2,1.3-0.2,2,0.2 c1.3,0.9,2.4,2.4,2.4,3.7c0,0.7-0.2,1.1-0.7,1.3c-0.2,0.2-0.4,0.2-0.7,0.2C77.8,174,77.4,174,77,173.6z M75.6,169 c-0.4,0.2-0.4,0.7-0.4,0.9c0,1.1,0.9,2.6,2.2,3.3c0.7,0.4,1.1,0.4,1.3,0.2c0.4-0.2,0.4-0.7,0.4-0.9c0-1.1-0.9-2.6-2.2-3.3 c-0.4-0.2-0.7-0.2-0.9-0.2C75.9,168.7,75.6,169,75.6,169z"
  }))))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M81.4,168.7l-9-6.2l-2.6-8.6l-10.5-5.7l-7.5,1.1l-5.1-1.3v5.7l2.9,2.9v-1.8c0-1.8,1.5-2.4,3.3-1.3 s3.3,3.5,3.3,5.3v1.8l17.6,10.1V169c0-1.8,1.5-2.4,3.3-1.3c1.8,1.1,3.3,3.5,3.3,5.3v1.8l0.7,0.2l0.2-5.1L81.4,168.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M81.4,174.7l-0.2-0.2v-1.5c0-2.2-1.3-4.4-3.3-5.7c-0.7-0.4-1.3-0.7-2-0.7c-0.7,0-1.3,0-1.5,0.4 c-0.4,0.4-0.7,1.1-0.7,1.8v0.7l-16.3-9.4v-1.3c0-2.2-1.5-4.6-3.7-5.9c-0.7-0.4-1.3-0.7-2-0.7s-1.3,0.2-1.8,0.7 c-0.4,0.4-0.7,1.1-0.7,1.8v1.1l0.7,0.7v-1.8c0-1.3,0.7-2,1.8-2c0.4,0,1.1,0.2,1.8,0.4c1.8,1.1,3.3,3.5,3.3,5.3v1.8l17.6,10.1 v-1.8c0-1.3,0.7-2,1.8-2c0.4,0,1.1,0.2,1.8,0.4c1.8,1.1,3.3,3.5,3.3,5.3v1.8L81.4,174.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "47.3,149 46.9,148.7 46.9,150.5 47.5,150.7 47.5,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "47.5,149 46.9,148.7 46.9,148.7 47.3,149 47.5,149.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "47.5,149.2 47.5,150.7 47.5,150.7 47.5,149  "
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M81.4,168.7l3.3-1.1c2.9-0.9,5.5-2.6,7.5-4.8l0.7-0.9l-9-6.2l-0.4,0.4c-2,1.8-4.4,3.3-6.8,4.4l-4.4,2 L81.4,168.7z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M78.9,148.5l-0.4,0.4c-1.8,2-4.2,3.5-6.8,4.2l-2,0.7l2.6,8.6l4.4-2c2.4-1.1,4.8-2.6,6.8-4.4l0.4-0.4 L78.9,148.5z"
  })), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M78.9,149.6C78.9,149.6,78.7,149.6,78.9,149.6l4,6.2h0.2L78.9,149.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M82.9,155.8L82.9,155.8c-2,1.8-4.2,3.3-6.6,4.4l-3.5,1.5l0,0l3.7-1.5c2.4-1.1,4.6-2.4,6.6-4.4l0,0H82.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M82.9,155.8L82.9,155.8l-4.2-6.2c-2,2-4.2,3.5-6.8,4.2l-1.3,0.4l2.2,7.3l3.5-1.5 C78.7,159.1,80.9,157.5,82.9,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M82.9,155.8L82.9,155.8l-4.2-6.2c-2,2-4.2,3.5-6.8,4.2l-1.3,0.4l2.2,7.3l3.5-1.5 C78.7,159.1,80.9,157.5,82.9,155.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st61",
    d: "M78.7,149.6c-0.9,0.9-1.8,1.5-2.6,2.2l6.8,4l0,0L78.7,149.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M82.5,155.1l-2-0.4l-3.1,1.8l-0.4,1.3l-4.6,2.2l0.7,2l3.5-1.5c2.4-1.1,4.6-2.4,6.6-4.4l0,0L82.5,155.1 L82.5,155.1z"
  })))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M58.5,141.3l-0.4,0.2c-3.3,1.3-6.4,3.1-9.2,5.1l-2,1.5l5.1,1.3l1.1-0.9c2.9-2,5.7-3.7,8.8-5.1l1.5-0.7 L58.5,141.3z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M68.4,142.8l-0.9,0.2c-3.1,0.9-5.9,2.6-8.1,4.8l-0.2,0.2l10.5,5.7l2-0.7c2.6-0.7,4.8-2.2,6.8-4.2l0.4-0.4 L68.4,142.8z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M67.5,143l0.9-0.2l-5.1-0.2l-1.5,0.7c-3.1,1.3-6.2,3.1-8.8,5.1l-1.1,0.9l7.5-1.1l0.2-0.2 C61.8,145.7,64.4,143.9,67.5,143z"
  })), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M62.2,143.5c-2.6,1.1-5.7,2.9-8.1,4.6l-0.9,0.7h0.2l0.7-0.7C56.3,146.3,59.4,144.8,62.2,143.5l1.3-0.4 v-0.2L62.2,143.5z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "63.6,142.8 63.6,143 67.1,143 67.3,143  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M59.4,147.6c2-2,4.6-3.7,7.3-4.4h0.4l-3.5-0.2l-1.3,0.7c-2.6,1.1-5.7,2.9-8.1,4.6l-0.9,0.4L59.4,147.6 L59.4,147.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st62",
    d: "M63.6,143l-1.3,0.7c-2.6,1.1-5.7,2.9-8.1,4.6l-0.9,0.4l2.6-0.4l8.8-5.3L63.6,143z"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M81.6,169.6l-0.2,5.1l3.3-1.1c2.9-0.9,5.5-2.6,7.5-4.8l0.7-0.9l0.2-3.3l-0.2-0.4l0.2-1.3 C90.1,168.1,81.6,169.6,81.6,169.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M84.7,168.7v2.6h0.2c2.6-0.9,5.3-2.2,7.3-4.4v-2.4C89.9,166.8,86.9,168.1,84.7,168.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M91.9,164.6v2.4h0.2L91.9,164.6C92.1,164.6,91.9,164.6,91.9,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M91.9,167c-2,2-4.4,3.5-7.3,4.4h-0.2l0,0h0.2C87.5,170.5,90.1,169.2,91.9,167L91.9,167z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M84.4,168.7v1.3h0.2L84.4,168.7C84.7,168.7,84.4,168.7,84.4,168.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M92.1,163c-2,2.2-4.6,4-7.5,4.8l-3.3,1.1l0.2,0.9c0,0,8.6-1.3,11.6-6.6l-0.2-0.9L92.1,163z"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M85.5,167.4l-2.9,0.9l0,0L85.5,167.4c2.6-0.7,4.8-2.4,6.6-4.4l0,0C90.1,165,88.2,166.5,85.5,167.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "83.3,156.4 83.3,156.4 92.1,163 92.1,163  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M83.1,156.2c-2,1.5-4,3.1-6.4,4l-3.1,1.3l9,6.6l2.9-0.9c2.6-0.9,4.8-2.4,6.6-4.4L83.1,156.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "73.7,161.7 73.7,161.9 82.7,168.3 82.7,168.3  "
  })))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M81.1,172.3l0.7,0.4c0,0,8.6-1.8,11.6-6.8l-0.4-0.2v0.2C89.7,170.7,81.1,172.3,81.1,172.3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M81.8,172.7v2.2c0,0,8.6-1.8,11.6-6.8v-2.2C90.4,170.7,81.8,172.7,81.8,172.7z"
  })), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M88,170.5v1.8c0.9-0.4,1.8-1.1,2.6-1.8v-1.8C89.9,169.6,88.8,170.1,88,170.5z"
  }))), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "81.1,172.3 81.1,174.4 81.8,174.7 81.8,172.7  "
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "51.9,149.2 72.4,162.6 69.7,153.8 59.4,148.1  "
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "46.9,147.9 81.6,169.6 81.4,168.7 72.4,162.6 71.3,161.7 52.6,149.6 51.9,149.2  "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M46.4,151.4C46.6,151.4,46.6,151.4,46.4,151.4c0.2-0.2,0.2-0.2,0.4-0.2v0.4l2.2,1.8v2.4l-0.2,0.2l0,0 c0,0,0,0,0-0.2c0,0,0-0.2-0.2-0.2c0,0,0-0.2-0.2-0.2l-0.2-0.2c0-0.2-0.2-0.2-0.2-0.4c0-0.2-0.2-0.2-0.2-0.4 c0-0.2-0.2-0.2-0.2-0.4c0-0.2-0.2-0.2-0.2-0.4c0-0.2-0.2-0.2-0.2-0.4c0-0.2-0.2-0.2-0.2-0.4c0-0.2-0.2-0.2-0.2-0.4l-0.2-0.2 c0,0,0-0.2-0.2-0.2v-0.2C46.4,151.6,46.4,151.6,46.4,151.4C46.4,151.6,46.4,151.6,46.4,151.4L46.4,151.4z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M46.4,151.6l0.4,0.4l2,1.8v2.4l-2.2-2.4c-0.2-0.2-0.2-0.4-0.2-0.7V151.6z"
  })), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "59.6,148.7 59.2,148.5 52.6,149.2 53.5,149.4 63.3,155.8 63.3,150.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "53,149.2 52.6,149.2 63.3,156.2 63.3,155.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "71.5,161.3 64.2,156.4 64,156.7 71.7,161.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "64,151.2 64,156.7 64.2,156.4 64.2,151.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st60",
    points: "71.5,161.3 69.3,154 64.2,151.2 64.2,156.4  "
  }))))), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M84.4,168.7c-1.1,0.2-2,0.4-2.4,0.7v1.3l2.4-0.7V168.7z"
  })), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M82,170.7v-1.3c-0.2,0-0.4,0-0.4,0v1.3l0,0H82L82,170.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "81.1,169.2 81.1,170.5 80.9,170.7 81.6,170.9 81.6,170.9 81.6,169.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st58",
    points: "84.7,170.1 82,170.7 82,170.9 84.7,170.3  "
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st63",
    d: "M92.1,164.6v1.3l0.2-0.2l0.7-0.9v-1.3C92.6,163.9,92.3,164.1,92.1,164.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M93.2,163l-0.2,0.4v1.5l0.2-0.4V163z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "92.8,163.5 93,163.5 93,165 92.8,165  "
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M92.8,165l-0.7,0.9v0.2C92.1,165.9,93,165,92.8,165L92.8,165z"
  }))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st65",
    d: "M76.3,152.7v-0.4c0,0,0-0.2-0.2,0l-0.7,0.4v-0.4c-0.2,0-0.2,0.2-0.4,0.2v0.4l-0.7,0.4l-0.2,0.2v0.4 c0,0,0,0.2,0.2,0l1.5-0.9C76.3,152.9,76.3,152.9,76.3,152.7z"
  })), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "71.9,161.3 70.2,162.1 70.2,161.3 71.9,160.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "69.9,161 69.9,161.9 70.2,162.1 70.2,161.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st48",
    points: "71.5,160.2 69.9,161 70.2,161.3 71.9,160.2  "
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st59",
    points: "72.4,150.9 64.7,146.5 65.5,143.7 73.2,148.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st66",
    points: "73.2,148.1 65.5,143.7 66.4,143 74.1,147.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "74.1,147.4 74.8,149.4 72.4,150.9 73.2,148.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "68.2,145.7 68.2,145.9 67.7,145.7 67.3,147.4 67.1,147.4 67.5,145.7 67.1,145.2 67.1,145  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M69.1,146.1v2.2l-0.2-0.2v-0.7l-0.7-0.2l-0.2,0.4l-0.2-0.2l1.1-1.8L69.1,146.1z M68.4,147.2l0.4,0.2v-0.2 c0-0.2,0-0.4,0-0.7l0,0C68.8,146.8,68.6,147,68.4,147.2L68.4,147.2L68.4,147.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "71.3,147.4 70.6,149.2 70.4,149.2 71,147.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "70.6,147 69.9,147.9 70.2,149 69.9,149 69.9,148.3 69.7,147.9 69.7,147.9 69.5,148.1 69.3,148.5 69.1,148.3  69.7,147.6 69.5,146.5 69.7,146.5 69.9,147.2 69.9,147.6 69.9,147.6 70.2,147.4 70.4,147  "
  }))))))), /*#__PURE__*/React.createElement("g", null, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M428.7,100.7l-0.9-0.5c-1.4-0.8-3.6-1-5.3-0.5l-25.6,7.5c-2.5,0.8-5.6,0.5-7.5-0.7l-9.6-5.6 c-2.5-1.4-6.5-1.4-9,0l0,0c-2.5,1.4-2.5,3.8,0,5.2l9.6,5.6c2,1.2,2.5,2.9,1.2,4.3l-13.5,14.8c-0.9,1-0.6,2.7,0.5,3.4l0.9,0.5 l25.5-14.7l10.9,6.4c1.2,0.7,1.7,1.7,1.3,2.6l-1.9,5.2c-0.3,0.5,0.1,1,0.8,1.4l0.5,0.3l7.9-4.6l1.4-0.8l6-3.5l1.4-0.8l7.9-4.6 l-0.5-0.3c-0.6-0.4-1.6-0.5-2.6-0.4l-9,1.2c-1.6,0.3-3.3-0.1-4.5-0.8l-10.9-6.4L428.7,100.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M393.6,117.3c0,0.4-0.3,0.5-0.6,0.3s-0.6-0.7-0.6-1c0-0.4,0.3-0.5,0.6-0.3 C393.3,116.5,393.6,117,393.6,117.3z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M393.3,117.2c0,0.3-0.1,0.3-0.4,0.1c-0.3-0.1-0.4-0.4-0.4-0.7s0.1-0.3,0.4-0.1 C393.2,116.7,393.3,117,393.3,117.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: -131.0054,
    y1: 149.1338,
    x2: -129.5605,
    y2: 149.1338,
    gradientTransform: "matrix(1 0 0 -1 523.4569 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1A232C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0A121C"
    }
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M393.9,117.2c0-0.4-0.3-0.8-0.6-1c-0.1-0.1-0.4-0.1-0.5,0l-0.4,0.3l0,0c0.1-0.1,0.3,0,0.5,0 c0.4,0.3,0.6,0.7,0.6,1c0,0.1,0,0.3-0.1,0.3l0,0l0.4-0.3C393.8,117.4,393.9,117.3,393.9,117.2z"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M395.1,118.3c0,0.4-0.3,0.5-0.6,0.3s-0.7-0.7-0.7-1c0-0.4,0.3-0.5,0.7-0.3 C394.9,117.4,395.1,118,395.1,118.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M395,118.1c0,0.3-0.1,0.3-0.4,0.1c-0.3-0.1-0.4-0.4-0.4-0.7s0.1-0.3,0.4-0.1 C394.7,117.7,395,118,395,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M395.5,118.1c0-0.4-0.3-0.8-0.6-1c-0.1-0.1-0.4-0.1-0.5,0l-0.4,0.3l0,0c0.1-0.1,0.3,0,0.5,0 c0.4,0.3,0.6,0.7,0.6,1c0,0.1,0,0.3-0.1,0.3l0,0l0.4-0.3C395.5,118.3,395.5,118.2,395.5,118.1z"
  }))), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "392.5,115.9 391.9,116.3 392.4,116.3 393,115.9  "
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "392.4,116.3 392.8,116.4 393.3,116.1 393,115.9  "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M394.5,117.8l-0.5-0.7l-0.3-0.1v-1.8l-0.9-0.5v1.8l-0.3-0.1H392c-0.1,0.1-0.1,0.1-0.3,0.3v0.4l3.1,1.8v-0.4 C394.6,118.1,394.6,118,394.5,117.8z"
  })), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M395.1,117.4l-0.6,0.4l0.3,0.5l0.6-0.4C395.2,117.7,395.2,117.6,395.1,117.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "394.7,118.2 394.7,118.6 395.4,118.2 395.4,118  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "394.6,116.8 393.9,117.2 394.5,117.8 395.1,117.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "394.2,116.7 393.7,116.9 393.9,117.2 394.6,116.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "393.3,114.3 392.8,114.7 393.7,115.2 394.2,114.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "393.7,115.2 393.7,116.9 394.2,116.7 394.2,114.8  "
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M392.6,117.8c0,0.4-0.3,0.5-0.6,0.3c-0.4-0.3-0.7-0.6-0.7-1s0.3-0.5,0.7-0.3 C392.4,117,392.6,117.6,392.6,117.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M392.4,117.7c0,0.3-0.1,0.3-0.4,0.1c-0.3-0.1-0.4-0.4-0.4-0.7c0-0.3,0.1-0.3,0.4-0.1 C392.3,117.3,392.4,117.6,392.4,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M392.9,117.7c0-0.4-0.3-0.8-0.6-1c-0.1-0.1-0.4-0.1-0.5,0l-0.4,0.3l0,0c0.1-0.1,0.3,0,0.5,0 c0.4,0.3,0.6,0.6,0.6,1c0,0.1,0,0.3-0.1,0.3l0,0l0.4-0.3C392.9,118,392.9,117.8,392.9,117.7z"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M394.2,118.9c0,0.4-0.3,0.5-0.6,0.3s-0.6-0.7-0.6-1c0-0.4,0.3-0.5,0.6-0.3S394.2,118.5,394.2,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M393.9,118.7c0,0.3-0.1,0.3-0.4,0.1c-0.3-0.1-0.4-0.4-0.4-0.7s0.1-0.3,0.4-0.1 C393.8,118.2,393.9,118.5,393.9,118.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M394.6,118.6c0-0.4-0.3-0.8-0.6-1c-0.1-0.1-0.4-0.1-0.5,0l-0.4,0.3l0,0c0.1-0.1,0.3,0,0.5,0 c0.4,0.3,0.6,0.7,0.6,1c0,0.1,0,0.3-0.1,0.3l0,0l0.4-0.3C394.6,118.9,394.6,118.7,394.6,118.6z"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M374.2,106.1c0,0.4-0.3,0.5-0.6,0.3s-0.6-0.7-0.6-1c0-0.4,0.3-0.5,0.6-0.3 C373.8,105.3,374.2,105.7,374.2,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M373.9,106c0,0.3-0.1,0.3-0.4,0.1c-0.3-0.1-0.4-0.4-0.4-0.7s0.1-0.3,0.4-0.1 C373.7,105.5,373.9,105.7,373.9,106z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M374.4,105.9c0-0.4-0.3-0.8-0.6-1c-0.1-0.1-0.4-0.1-0.5,0l-0.4,0.3l0,0c0.1-0.1,0.3,0,0.5,0 c0.4,0.3,0.6,0.7,0.6,1c0,0.1,0,0.3-0.1,0.3l0,0l0.4-0.3C374.4,106.1,374.4,106.1,374.4,105.9z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "373.1,103.4 373.1,106.3 372.6,106 372.6,103.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "373.3,102.7 372.6,103.1 373.1,103.4 373.8,103  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st17",
    points: "373.1,103.4 373.1,106.3 373.8,105.9 373.8,103  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M373.1,106.6c0,0.4-0.3,0.5-0.6,0.3c-0.4-0.3-0.7-0.6-0.7-1s0.3-0.5,0.7-0.3 C372.9,105.9,373.1,106.3,373.1,106.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M373,106.5c0,0.3-0.1,0.3-0.4,0.1c-0.3-0.1-0.4-0.4-0.4-0.7s0.1-0.3,0.4-0.1 C372.8,106,373,106.3,373,106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M373.5,106.5c0-0.4-0.3-0.8-0.6-1c-0.1-0.1-0.4-0.1-0.5,0l-0.4,0.3l0,0c0.1-0.1,0.3,0,0.5,0 c0.4,0.3,0.6,0.7,0.6,1c0,0.1,0,0.3-0.1,0.3l0,0l0.4-0.3C373.5,106.8,373.5,106.6,373.5,106.5z"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M430.6,116.1l-12.9,4.8l-5.5-3.4l15.2-2.2c0.6-0.1,1.4,0,1.9,0.3L430.6,116.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "416.8,120.4 416.8,120.3 427.5,116.3 428.7,116.9 428.3,117 427.5,116.5 417,120.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "430.6,116.1 430.6,116.4 418,121.5 417.7,120.9  "
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M391.9,103c0-1.2,0.9-2.6,2.1-3.4c0.6-0.4,1.2-0.4,1.6-0.1l0,0l3.5,1.9l0,0c0,0,0,0-0.1,0 c0.1,0,0.3,0.1,0.3,0.3l0,0l2.1,2.2L399,107l-3-0.8l0,0c-0.1,0-0.1,0-0.3-0.1l0,0l0,0l-3.5-1.9l0,0 C392,103.9,391.9,103.5,391.9,103z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M391.9,103c0-1.2,0.9-2.6,2.1-3.4c0.1-0.1,0.4-0.1,0.5-0.3c0,0,4,2.1,4.3,2.9c0.3,0.8,1,3.6-2.7,3.3 l-4.3-2.3C391.9,103.1,391.9,103,391.9,103z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M398.5,106.1c0,0.8,0.6,1,1.4,0.7c0.8-0.5,1.4-1.4,1.4-2.3c0-0.8-0.7-1-1.4-0.7 C399.1,104.3,398.5,105.3,398.5,106.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M398.8,106c0-0.6,0.5-1.6,1.2-1.9c0.4-0.3,0.8-0.3,1-0.1l0,0l3.1,2.5l0,0c-0.1-0.1-0.4-0.1-0.6,0 c-0.5,0.3-0.9,0.9-0.9,1.3c0,0.3,0.1,0.4,0.3,0.4l0,0l-3.6-1.7l0,0C398.9,106.5,398.8,106.3,398.8,106z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M402.5,107.8c0,0.5,0.4,0.7,0.9,0.4c0.5-0.3,0.9-0.9,0.9-1.3c0-0.5-0.4-0.7-0.9-0.4 C402.9,106.8,402.5,107.3,402.5,107.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M403.2,107.8c0.4-0.3,0.6-0.7,0.6-1c0-0.1,0-0.3-0.1-0.3c0.1,0,0.3,0.1,0.3,0.4c0,0.4-0.3,0.9-0.6,1 c-0.3,0.1-0.5,0.1-0.6,0C402.9,107.9,403,107.9,403.2,107.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M403.4,106.6c0.1-0.1,0.3-0.1,0.4-0.1c0,0.1,0.1,0.1,0.1,0.3c0,0.4-0.3,0.9-0.6,1 c-0.1,0.1-0.3,0.1-0.4,0.1c0-0.1-0.1-0.1-0.1-0.3C402.7,107.3,403,106.9,403.4,106.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M403.8,100.1c0-1.2,0.9-2.6,2.1-3.4c0.6-0.4,1.2-0.4,1.6-0.1l0,0l3.5,2l0,0c0,0,0,0-0.1,0 c0.1,0,0.3,0.1,0.3,0.3l0,0l2.1,2.2l-2.2,3.1l-3-0.8l0,0c-0.1,0-0.1,0-0.3-0.1l0,0l0,0l-3.5-1.9l0,0 C404,101.1,403.8,100.8,403.8,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M403.8,100.1c0-1.2,0.9-2.6,2.1-3.4c0.1-0.1,0.4-0.1,0.5-0.3c0,0,4,2.1,4.3,2.9c0.3,0.8,1,3.6-2.7,3.3 l-4.3-2.3C403.8,100.3,403.8,100.3,403.8,100.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M410.5,103.3c0,0.8,0.7,1,1.4,0.7c0.8-0.5,1.4-1.4,1.4-2.3c0-0.8-0.6-1-1.4-0.7 C411.1,101.4,410.5,102.5,410.5,103.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M410.7,103.1c0-0.7,0.5-1.6,1.2-1.9c0.4-0.3,0.8-0.3,1-0.1l0,0l3.1,2.5l0,0c-0.1-0.1-0.4-0.1-0.6,0 c-0.5,0.3-0.9,0.9-0.9,1.3c0,0.3,0.1,0.4,0.3,0.4l0,0l-3.6-1.7l0,0C410.8,103.8,410.7,103.5,410.7,103.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M414.5,105.1c0,0.5,0.4,0.7,0.9,0.4c0.5-0.3,0.9-0.9,0.9-1.3c0-0.5-0.4-0.6-0.9-0.4 C414.9,103.9,414.5,104.6,414.5,105.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M415.1,105.1c0.4-0.3,0.6-0.6,0.6-1c0-0.1,0-0.3-0.1-0.3c0.1,0,0.3,0.1,0.3,0.4c0,0.4-0.3,0.9-0.6,1 c-0.3,0.1-0.5,0.1-0.6,0C414.9,105.2,415,105.2,415.1,105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M415.4,103.9c0.1-0.1,0.3-0.1,0.4-0.1c0,0.1,0.1,0.1,0.1,0.3c0,0.4-0.3,0.9-0.6,1 c-0.1,0.1-0.3,0.1-0.4,0.1c0-0.1-0.1-0.1-0.1-0.3C414.6,104.6,415,104,415.4,103.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M392.8,102l30.9-8.1c0.8-0.3,1.6-0.1,2.3,0.3l2.3,1.3l-23.1,9.5l-5.2,3.8L392.8,102z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "405.3,105 405.3,105.1 405,105.2 402.7,103.9 402.9,103.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "419.7,99.1 419.4,99.2 418,98.5 418.1,98.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "398.4,107.2 398.1,106.9 402.8,103.5 424.8,95.9 426.1,96.5 425.7,96.6 424.8,96.1 402.9,103.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "405.3,105.1 428.4,95.5 428.4,95.7 405.3,105.7 400.1,109.5 400.1,108.7  "
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M394.1,104c-2.2-2.1-4-3.1-7.4-5.1c0,0-6.1-3.6-8.2-4.9c-1.7-0.9-3-1.7-4.4-2.1c-0.6-0.3-1.4-0.3-2.2-0.1 c-0.4,0-0.9,0.1-1.4,0.3c1-0.5,2-0.8,2.7-0.9c0.8-0.1,1.4-0.1,2.2,0.1c1.3,0.4,2.6,1.2,4.4,2.1c2.2,1.2,8.2,4.9,8.2,4.9 c3.3,2,5.1,3,7.4,5.1c2.2,2.1,8.7,5.6,10,6.6c1.4,1,13.9,10.5,13.9,10.5l-0.1,0.3c-2.5-1.7-13.8-9.2-15.1-10.1 C402.8,109.6,396.3,106.1,394.1,104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M367,93.8c0.3-0.1,0.6-0.3,1-0.4c0.5-0.1,0.9-0.3,0.9-0.3c0.5-0.5,1-0.8,1.6-1c0.5-0.1,1-0.1,1.4-0.3 c0.8-0.1,1.4-0.1,2.2,0.1c1.3,0.4,2.6,1.2,4.4,2.1c2.2,1.2,8.2,4.9,8.2,4.9c3.3,1.9,5.1,3,7.4,5.1c2.2,2.1,8.7,5.6,10,6.6 c1.2,0.9,12.5,8.5,15.1,10.1l-0.4,0.7l-21.6-10.3c0,0-2.6-1.2-5.7-3.3c-1.6-1-3.3-2.6-5.1-3.6c-7-4.2-14.7-8.5-15.3-8.8 c-1.7-1-3.8-0.9-3.8-0.9c-0.4,0-0.6,0-0.9,0c-0.3,0-0.5,0-0.8,0C366,94.2,366.5,93.9,367,93.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M365.5,97.2c0.4,0.3,0.9,0.7,1.2,0.9c0,0,0.8,0.9,2.3,1.8c1.3,0.8,26.3,15.7,26.3,15.7s5.3,2.9,8.8,3.4 l14.2,3.4l-0.3,0.4l-13.5-2.5c-3.6-0.5-7.3-2.3-7.3-2.3s-27.3-16-28.5-16.9c-0.9-0.8-2.2-2-3-2.7c0-0.1-0.1-0.1-0.1-0.3 c-0.3-0.5-0.4-0.9-0.5-1.3C365.2,96.9,365.3,97,365.5,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M368.6,101.1c1.2,0.9,28.5,16.9,28.5,16.9s3.8,1.8,7.3,2.3l13.5,2.5l0,0l-14.3-1.3c-3.6-0.5-7-2.7-7-2.7 s-26.8-15.6-28-16.5c-1.2-0.9-2.1-2.6-2.1-2.6c-0.4-0.4-0.6-0.8-0.9-1.3C366.4,99.2,367.7,100.4,368.6,101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M365.1,95.5c0.1-0.3,0.3-0.5,0.5-0.8c0.1,0,0.4,0,0.8,0c0.3,0,0.5,0,0.9,0c0,0,2.1-0.1,3.8,0.9 c0.7,0.4,8.3,4.7,15.3,8.8c1.8,1.2,3.5,2.6,5.1,3.6c3.3,2.1,5.7,3.3,5.7,3.3l21.6,10.3l-0.4,0.5l-13.5-4.4c-3.6-1-9-3.5-9-3.5 s-2.6-1.2-5.7-3.3c-1.6-1-3.3-2.6-5.1-3.6c-7-4.2-14.7-8.4-15.3-8.8c-1.7-1-3.1-1.7-3.1-1.7c-0.4-0.1-0.8-0.3-1-0.4 c-0.3-0.1-0.4-0.3-0.5-0.4C365.1,95.7,365.1,95.5,365.1,95.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M365.1,95.9c0.1,0.1,0.3,0.3,0.5,0.4c0.3,0.1,0.6,0.3,1,0.4c0,0,1.4,0.7,3.1,1.7c0.6,0.4,8.3,4.7,15.3,8.8 c1.8,1.2,3.5,2.6,5.1,3.6c3.3,2.1,5.7,3.3,5.7,3.3s5.3,2.5,9,3.5l13.5,4.4l-0.1,0.4l-14-3.4c-3.6-0.5-8.8-3.4-8.8-3.4 s-25-14.9-26.3-15.7c-1.7-1-2.3-1.8-2.3-1.8c-0.4-0.4-0.8-0.6-1.2-0.9c-0.1-0.1-0.3-0.1-0.4-0.3C365,96.5,365,96.1,365.1,95.9z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M417.6,122.2c0,0.5,0.4,0.7,0.9,0.4c0.5-0.3,0.9-1,0.9-1.6c0-0.5-0.4-0.7-0.9-0.4 C418,120.9,417.6,121.7,417.6,122.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M417.9,122.1c0-0.4,0.3-0.8,0.6-1c0.3-0.1,0.4-0.1,0.5,0l0,0l0.9,0.5l-1,1.4l-0.9-0.5l0,0 C417.9,122.4,417.9,122.2,417.9,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M418.6,122.5c0,0.4,0.3,0.5,0.6,0.3c0.4-0.3,0.6-0.6,0.6-1s-0.3-0.5-0.6-0.3 C419,121.7,418.6,122.2,418.6,122.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M369.8,92.6l-1.3,0.8c0,0-0.8,0.7-1,1c-0.1,0.4-0.1,1,0.4,1.6l1.3,1l0.8-1.6c0,0-1.3-0.9-1.2-1.6 C368.9,93.3,369.4,92.7,369.8,92.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M385.6,104.6l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C385.2,104.7,385.4,104.4,385.6,104.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M384.7,104l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C384.3,104.2,384.5,103.9,384.7,104z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M383.8,103.5l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C383.4,103.7,383.5,103.4,383.8,103.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M382.9,103l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C382.5,103.1,382.6,102.9,382.9,103z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M382,102.5l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C381.6,102.6,381.7,102.4,382,102.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M381.1,102l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C380.7,102.1,380.8,101.8,381.1,102z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M380.2,101.3l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C379.8,101.6,379.9,101.3,380.2,101.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M379.1,100.8l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C378.9,101.1,379,100.8,379.1,100.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M378.2,100.3l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C378,100.5,378.1,100.3,378.2,100.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M377.3,99.8l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C377,100,377.2,99.8,377.3,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M376.4,99.2l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C376.1,99.5,376.3,99.2,376.4,99.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M375.5,98.7l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C375.2,98.8,375.4,98.6,375.5,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M374.6,98.2l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C374.3,98.3,374.4,98.1,374.6,98.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M373.7,97.7l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c-0.1,0-0.1-0.1-0.1-0.4 l0.4-1C373.4,97.8,373.4,97.5,373.7,97.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M372.8,97.2l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c0,0-0.1-0.1-0.1-0.4l0.4-1 C372.5,97.3,372.5,97,372.8,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M371.8,96.6l0.3,0.1c0,0,0.3,0.1,0.1,0.4l-0.4,1c0,0-0.1,0.3-0.3,0.1l-0.3-0.1c0,0-0.1-0.1-0.1-0.4l0.4-1 C371.6,96.8,371.6,96.5,371.8,96.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M391.5,111.5l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C391.2,111.6,391.2,111.5,391.5,111.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M390.4,110.9l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C390.3,111.1,390.3,110.9,390.4,110.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M394.2,113l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C393.9,113.3,393.9,113,394.2,113z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M395.1,113.5l0.1,0.1c0,0,0.3,0.1,0.3,0.4s0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C395,113.8,395,113.5,395.1,113.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M396.2,114.1l0.1,0.1c0,0,0.3,0.1,0.3,0.4s0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C395.9,114.3,395.9,114.1,396.2,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M397.1,114.7l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C396.8,114.8,396.8,114.6,397.1,114.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M389.5,110.4l0.1,0.1c0,0,0.3,0.1,0.3,0.4s0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C389.3,110.5,389.3,110.4,389.5,110.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M388.6,109.9l0.1,0.1c0,0,0.3,0.1,0.3,0.4s0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C388.4,110,388.4,109.8,388.6,109.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M387.7,109.4l0.1,0.1c0,0,0.3,0.1,0.3,0.4s0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C387.4,109.5,387.4,109.2,387.7,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M386.8,108.9l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C386.5,109,386.5,108.7,386.8,108.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M392.9,112.1l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,0.7,0,0.7s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4 v-0.7C392.6,112.2,392.6,112.1,392.9,112.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M393.2,114.8c-0.1,0-0.1,0-0.3,0l-0.4-0.3c0,0-0.4-0.3-0.4-0.7l0.1-1.8c0,0,0-0.3,0.1-0.3s0.1-0.1,0.3,0 l0,0l0.4,0.3c0,0,0.4,0.3,0.4,0.8c0,0.5-0.1,1.7-0.1,1.7S393.3,114.8,393.2,114.8C393.3,114.8,393.3,114.8,393.2,114.8z  M392.8,111.8C392.6,111.8,392.6,111.8,392.8,111.8c-0.3,0.1-0.3,0.3-0.3,0.3l-0.1,1.8c0,0.4,0.3,0.5,0.3,0.5l0.4,0.3 c0.1,0,0.1,0,0.3,0s0.1-0.3,0.1-0.3s0.1-1.2,0.1-1.7c0-0.5-0.4-0.7-0.4-0.7L392.8,111.8L392.8,111.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M378.5,103.8l0.1,0.1c0,0,0.3,0.1,0.3,0.4s0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C378.2,103.9,378.2,103.7,378.5,103.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M379.4,104.3l0.1,0.1c0,0,0.3,0.1,0.3,0.4s0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C379.1,104.4,379.1,104.2,379.4,104.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M381.3,105.3l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C381.1,105.5,381.1,105.2,381.3,105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M380.3,104.8l0.1,0.1c0,0,0.3,0.1,0.3,0.4s0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C380.2,105,380.2,104.8,380.3,104.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M377.6,103.3l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C377.3,103.4,377.3,103.1,377.6,103.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M376.7,102.6l0.1,0.1c0,0,0.3,0.1,0.3,0.4s0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C376.4,102.9,376.4,102.6,376.7,102.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M375.6,102.1l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C375.5,102.4,375.5,102.1,375.6,102.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M374.7,101.6l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C374.4,101.7,374.4,101.6,374.7,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M373.8,101.1l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C373.5,101.2,373.5,101.1,373.8,101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M381.3,105.3l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C381.1,105.5,381.1,105.3,381.3,105.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M382.2,105.9l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C382,106,382,105.9,382.2,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M383.2,106.5l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C382.9,106.6,382.9,106.4,383.2,106.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M384.1,107l0.1,0.1c0,0,0.3,0.1,0.3,0.4s0,1,0,1s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4v-1 C383.8,107.2,383.8,106.9,384.1,107z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M372.1,100l0.1,0.1c0,0,0.3,0.1,0.3,0.4c0,0.3,0,0.7,0,0.7s0,0.3-0.3,0.1l-0.1-0.1c0,0-0.1-0.1-0.1-0.4 v-0.6C372,100.1,372,99.9,372.1,100z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M372.5,102.7c-0.1,0-0.1,0-0.3,0l-0.4-0.3c0,0-0.4-0.3-0.4-0.7l0.1-1.8c0,0,0-0.3,0.1-0.3s0.1-0.1,0.3,0 l0,0l0.4,0.3c0,0,0.4,0.3,0.4,0.8c0,0.5-0.1,1.7-0.1,1.7S372.6,102.7,372.5,102.7C372.6,102.7,372.5,102.7,372.5,102.7z  M372,99.8L372,99.8c-0.3,0.1-0.3,0.3-0.3,0.3l-0.1,1.8c0,0.4,0.3,0.5,0.3,0.5l0.4,0.3c0.1,0,0.1,0,0.3,0s0.1-0.3,0.1-0.3 s0.1-1.2,0.1-1.7s-0.4-0.7-0.4-0.7L372,99.8C372.1,99.8,372,99.8,372,99.8z"
  }))))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M372,114.6c0-1.2,0.9-2.6,2.1-3.4c0.6-0.4,1.2-0.4,1.6-0.1l0,0l3.5,2l0,0c0,0,0,0-0.1,0 c0.1,0,0.3,0.1,0.3,0.3l0,0l2.1,2.2l-2.2,3.1l-3-0.8l0,0c-0.1,0-0.1,0-0.3-0.1l0,0l0,0l-3.5-2l0,0 C372.2,115.5,372,115.2,372,114.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M372,114.6c0-1.2,0.9-2.6,2.1-3.4c0.1-0.1,0.4-0.1,0.5-0.3c0,0,4,2.1,4.3,2.9c0.3,0.8,1,3.6-2.7,3.3 l-4.3-2.3C372,114.7,372,114.7,372,114.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M378.7,117.7c0,0.8,0.6,1,1.4,0.7c0.8-0.5,1.4-1.4,1.4-2.3c0-0.8-0.6-1-1.4-0.7 C379.4,115.9,378.7,116.9,378.7,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M378.9,117.6c0-0.7,0.5-1.6,1.2-1.9c0.4-0.3,0.8-0.3,1-0.1l0,0l3.1,2.5l0,0c-0.1-0.1-0.4-0.1-0.6,0 c-0.5,0.3-0.9,0.9-0.9,1.3c0,0.3,0.1,0.4,0.3,0.4l0,0l-3.6-1.7l0,0C379,118.2,378.9,118,378.9,117.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M382.8,119.5c0,0.5,0.4,0.7,0.9,0.4s0.9-0.9,0.9-1.3c0-0.4-0.4-0.6-0.9-0.4 C383,118.3,382.8,119,382.8,119.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M383.3,119.5c0.4-0.3,0.6-0.6,0.6-1c0-0.1,0-0.3-0.1-0.3c0.1,0,0.3,0.1,0.3,0.4c0,0.4-0.3,0.9-0.6,1 c-0.3,0.1-0.5,0.1-0.6,0C383,119.6,383.2,119.6,383.3,119.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M383.5,118.3c0.1-0.1,0.3-0.1,0.4-0.1c0,0.1,0.1,0.1,0.1,0.3c0,0.4-0.3,0.9-0.6,1 c-0.1,0.1-0.3,0.1-0.4,0.1c0-0.1-0.1-0.1-0.1-0.3C382.9,119,383.2,118.5,383.5,118.3z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M369.1,120.3c0-1.2,0.9-2.6,2.1-3.4c0.6-0.4,1.2-0.4,1.6-0.1l0,0l3.5,2l0,0c0,0,0,0-0.1,0 c0.1,0,0.3,0.1,0.3,0.3l0,0l2.1,2.2l-2.2,3.1l-3-0.8l0,0c-0.1,0-0.1,0-0.3-0.1l0,0l0,0l-3.5-1.9l0,0 C369.4,121.2,369.1,120.8,369.1,120.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M369.1,120.3c0-1.2,0.9-2.6,2.1-3.4c0.1-0.1,0.4-0.1,0.5-0.3c0,0,4,2.1,4.3,2.9c0.3,0.8,1,3.6-2.7,3.3 l-4.3-2.3C369.1,120.4,369.1,120.3,369.1,120.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M375.9,123.4c0,0.8,0.6,1,1.4,0.7c0.8-0.5,1.4-1.4,1.4-2.3c0-0.8-0.6-1-1.4-0.7 C376.5,121.6,375.9,122.6,375.9,123.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M376.1,123.3c0-0.7,0.5-1.6,1.2-2c0.4-0.3,0.8-0.3,1-0.1l0,0l3.1,2.5l0,0c-0.1-0.1-0.4-0.1-0.6,0 c-0.5,0.3-0.9,0.9-0.9,1.3c0,0.3,0.1,0.4,0.3,0.4l0,0l-3.6-1.7l0,0C376.3,123.8,376.1,123.7,376.1,123.3z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M379.9,125.1c0,0.5,0.4,0.7,0.9,0.4s0.9-0.9,0.9-1.3c0-0.5-0.4-0.6-0.9-0.4 C380.3,124.1,379.9,124.7,379.9,125.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M380.6,125.2c0.4-0.3,0.6-0.7,0.6-1c0-0.1,0-0.3-0.1-0.3c0.1,0,0.3,0.1,0.3,0.4c0,0.4-0.3,0.9-0.7,1 c-0.3,0.1-0.5,0.1-0.6,0C380.3,125.4,380.4,125.2,380.6,125.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M380.7,123.9c0.1-0.1,0.3-0.1,0.4-0.1c0,0.1,0.1,0.1,0.1,0.3c0,0.4-0.3,0.9-0.6,1 c-0.1,0.1-0.3,0.1-0.4,0.1c0-0.1-0.1-0.1-0.1-0.3C380,124.7,380.3,124.2,380.7,123.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M368.9,126.7l2.6,1.6l12.7-11.2l6.4-2.9v0.9l-6.4,2.9l-12.7,10.4l-2.6-1.6c-0.3-0.1-0.5-0.5-0.4-0.9 C368.5,126.3,368.7,126.5,368.9,126.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M390.7,114.2l-10.7-6.2l-11.3,17.5c-0.3,0.4-0.1,0.9,0.3,1.2l2.6,1.6l12.7-11.2L390.7,114.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "388.2,112.8 388.5,112.9 388.5,112.9 382,115.9 372.6,125.8 373.8,126.3 373.5,126.5 372.2,125.8  381.9,115.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "377.4,123.2 377.2,123.3 375.6,122.4 375.7,122.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "382,115.6 384.3,117 384.3,117 384.1,117.2 381.9,115.9  "
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M417,121.7l-7.5,6.9L408,128c-0.4-0.3-0.6-0.7-0.5-1.2l2.5-7L417,121.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "410.2,127.7 409,127.1 415.5,121.2 415.7,121.3 415.8,121.5 409.5,127.1 410.5,127.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M407.5,126.8L407.5,126.8c0,0.4,0.1,0.8,0.5,0.9l1.4,0.6l7.5-6.9v0.5l-7.5,6.5l-1.4-0.6 C407.6,127.8,407.3,127.3,407.5,126.8z"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M407.3,113.3l9.1-6.2c0.5-0.4,1.3-0.4,1.8-0.1l1.9,1l-3.3,11.7L407.3,113.3z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "418.9,107.3 415.8,118.7 415.5,118.6 418.6,107  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M418.3,106.9c-0.5-0.3-1.2-0.3-1.7,0l0,0c0.4-0.4,1.3-0.4,1.8,0l2,1l-2.9,11.4l-0.5,0.3l3.3-11.7 L418.3,106.9z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g61 || (_g61 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "120.2,39.8 120,85.3 103.8,75.9 103.9,30.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "105.4,49.3 111.3,52.8 111.3,36.9 105.4,33.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "111.3,50.8 111.3,46 105.4,35.4 105.4,40.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "105.4,44 109.9,51.9 111.3,52.8 111.3,52.5 105.4,41.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "112.6,53.6 118.6,57.1 118.6,41.2 112.6,37.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "118.6,55.1 118.6,50.3 112.6,39.7 112.6,44.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "112.6,48.4 117.3,56.2 118.6,57.1 118.6,56.8 112.6,46.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "105.4,68.1 111.3,71.5 111.3,55.8 105.4,52.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "111.3,69.6 111.3,64.8 105.4,54.1 105.4,59.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "105.4,62.8 109.9,70.7 111.3,71.5 111.3,71.4 105.4,60.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "112.6,72.4 118.6,75.8 118.6,60.1 112.6,56.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "118.6,73.9 118.6,69.2 112.6,58.4 112.6,63.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "112.6,67.1 117.3,75 118.6,75.8 118.6,75.7 112.6,65  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "170.2,68.7 170.1,114.3 160.1,120.1 160.2,74.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "160.2,74.5 160.1,120.1 110,91.1 110.2,45.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "149,74.4 149,90.1 156.6,94.4 156.6,78.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "149,85.8 152.8,92.3 156.6,94.4 156.6,94.3 149,80.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "149,89.3 149.8,90.5 151.4,91.4 149,87.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "151.8,75.9 156.6,84.3 156.6,79.1 156.6,78.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "150.9,75.4 149,74.4 149,74.8 156.6,87.8 156.6,85.6  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "139.9,69 139.9,84.9 147.5,89.2 147.5,73.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "139.9,80.5 143.7,87 147.5,89.2 147.5,88.9 139.9,75.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "139.9,84.1 140.7,85.3 142.3,86.2 139.9,82.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "142.7,70.7 147.5,78.9 147.5,73.7 147.5,73.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "141.8,70.1 139.9,69 139.9,69.6 147.5,82.6 147.5,80.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "130.8,63.8 130.8,79.6 138.4,84 138.4,68.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "130.8,75.3 134.6,81.8 138.4,84 138.4,83.7 130.8,70.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "130.8,78.8 131.6,80 133.2,80.9 130.8,76.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "133.6,65.4 138.4,73.7 138.4,68.5 138.4,68.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "132.7,64.9 130.8,63.8 130.8,64.2 138.4,77.2 138.4,75  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "121.7,58.6 121.7,74.4 129.3,78.7 129.3,62.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "121.7,70 125.5,76.6 129.3,78.7 129.3,78.5 121.7,65.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "121.7,73.6 122.5,74.8 124.1,75.7 121.7,71.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "124.5,60.2 129.3,68.4 129.3,63.3 129.3,62.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "123.6,59.7 121.7,58.6 121.7,59 129.3,72 129.3,69.8  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "112.6,53.3 112.6,69 120.2,73.5 120.2,57.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "112.6,64.8 116.4,71.3 120.2,73.5 120.2,73.2 112.6,59.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "112.6,68.3 113.4,69.4 115,70.3 112.6,66.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "115.4,54.9 120.2,63.2 120.2,58 120.2,57.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "114.5,54.4 112.6,53.3 112.6,53.7 120.2,66.7 120.2,64.5  "
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "186.5,78 186.3,123.6 170.1,114.3 170.2,68.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "237.2,48.5 237,94.1 186.3,123.6 186.5,78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "237.2,48.5 186.5,78 170.2,68.7 160.2,74.5 110.2,45.6 120.2,39.8 103.9,30.4 154.8,0.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "170.2,62.7 160.2,68.5 120.4,45.6 130.6,39.8 114.3,30.4 154.8,6.9 226.9,48.6 186.5,72  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "111.3,75.5 111.3,91.3 159.7,119.2 159.7,103.4  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "171.3,88.2 177.2,91.7 177.2,75.8 171.3,72.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "177.2,89.7 177.2,84.9 171.3,74.2 171.3,79.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "171.3,83 175.8,90.8 177.2,91.7 177.2,91.4 171.3,80.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "178.5,92.4 184.5,96 184.5,80.2 178.5,76.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "184.5,94 184.5,89.2 178.5,78.5 178.5,83.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "178.5,87.2 183.1,95.2 184.5,96 184.5,95.7 178.5,85  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "171.3,107 177.2,110.4 177.2,94.7 171.3,91.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "177.2,108.4 177.2,103.6 171.3,93 171.3,98.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "171.3,101.7 175.8,109.6 177.2,110.4 177.2,110.3 171.3,99.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "178.5,111.3 184.5,114.7 184.5,98.9 178.5,95.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "184.5,112.7 184.5,108 178.5,97.4 178.5,102.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "178.5,106 183.1,113.9 184.5,114.7 184.5,114.5 178.5,103.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "208.3,68.1 208.3,88.8 215.6,84.6 215.6,63.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "199.6,73.1 199.6,93.9 207.1,89.5 207.1,68.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "190.8,78.3 190.8,98.9 198.3,94.5 198.3,73.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "225.6,58.1 225.6,78.8 232.9,74.6 232.9,54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "216.9,63.2 216.9,83.9 224.4,79.4 224.4,58.8  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 143.9369,
    y1: 146.5447,
    x2: 145.7255,
    y2: 146.5447,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E3E3E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3452,
    style: {
      stopColor: "#E0E0DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5955,
    style: {
      stopColor: "#D7D7D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    style: {
      stopColor: "#C7C7C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3B3B3"
    }
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M143.7,111.6v15.2c0,0.1,0.1,0.3,0.3,0.4c0.4,0.3,1,0.3,1.4,0c0.3-0.1,0.3-0.3,0.3-0.4v-15.2H143.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.5369,
    y1: 175.0147,
    x2: 96.3256,
    y2: 175.0147,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E3E3E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3452,
    style: {
      stopColor: "#E0E0DF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5955,
    style: {
      stopColor: "#D7D7D6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    style: {
      stopColor: "#C7C7C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3B3B3"
    }
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M94.3,83.1v15.2c0,0.1,0.1,0.3,0.3,0.4c0.4,0.3,1,0.3,1.4,0c0.3-0.1,0.3-0.3,0.3-0.4V83.1H94.3z"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st51",
    points: "141.9,112.7 160.2,102.1 160.2,104.1 141.9,114.8  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "92,83.9 110.3,73.2 160.2,102.1 141.9,112.7  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "141.9,112.7 141.9,114.8 92,85.9 92,83.9  "
  }))), /*#__PURE__*/React.createElement("g", null, _g62 || (_g62 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st77",
    points: "158.3,72.9 113.2,46.8 113.2,31.9 158.3,57.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st78",
    points: "115.8,30.3 113.2,31.9 158.3,57.9 160.9,56.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "158.3,57.9 158.3,72.9 160.9,71.4 160.9,56.4  "
  }))), /*#__PURE__*/React.createElement("g", null, _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    className: "st80"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "115.1,42.8 116,42.3 115.2,44.3 114.3,45  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "115.6,41 116.5,40.4 116.1,41.6 115.2,42.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "115.2,42.1 116.1,41.6 118.4,42.8 117.4,43.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M116.4,38.6l0.9-0.5c-0.3,0.8-0.5,1.6-0.8,2.3l-0.9,0.5C115.9,40.2,116.1,39.4,116.4,38.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "115.9,37.5 116.8,36.9 117.8,37.6 116.9,38.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "116.9,38.1 117.8,37.6 120.3,47.3 119.4,47.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M116.9,38.1l2.5,9.8l-1-0.5l-0.7-3l-2.6-1.6l-0.7,2.1l-0.9-0.5l2.5-6.9L116.9,38.1z M115.2,42.1 l2.2,1.3l-0.4-1.4c-0.3-1-0.5-2.1-0.8-3.3l0,0c-0.3,0.8-0.5,1.6-0.8,2.3L115.2,42.1L115.2,42.1z"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    className: "st80"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "121.3,40.6 122.3,40.1 122.3,48.4 121.3,49  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "120.4,40.1 121.3,39.5 122.3,40.1 121.3,40.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "121.3,40.6 121.3,49 120.4,48.4 120.4,40.1  "
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st80"
  }, _g65 || (_g65 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "124.2,47.1 125.1,46.6 125.1,50.1 124.2,50.6  "
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "124.2,46.3 125.1,45.8 126.4,46.4 125.5,46.9  "
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "126.4,48.2 127.5,47.7 129.3,52.5 128.4,53.1  "
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "124.2,43.2 125.1,42.7 125.1,45.8 124.2,46.3  "
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M127.7,46.7l-0.9,0.5c-0.3,0.1-0.8,0.1-1.4-0.3l0.9-0.5C126.9,46.8,127.5,46.9,127.7,46.7z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.2119,
    y1: 222.1928,
    x2: 126.3778,
    y2: 219.3321,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E3E3E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3B3B3"
    }
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "st81",
    d: "M126.5,42.5l-2.2-1.3l-0.9,0.5l2.2,1.3c1.4,0.9,2.6,2.1,2.5,3.8c0,0.8-0.3,1.2-0.5,1.4l0.9-0.5 c0.4-0.3,0.5-0.6,0.5-1.4C129,44.6,128,43.4,126.5,42.5z"
  })), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M126.4,48.2l1.8,4.7l-1-0.7l-1.7-4.5l-1.3-0.8v3.5l-0.9-0.5v-8.3l2.2,1.3c1.4,0.9,2.6,2.1,2.5,3.8 C128.1,48.2,127.5,48.6,126.4,48.2z M125.5,46.9c1.2,0.7,1.8,0.5,1.8-0.6c0-1-0.7-1.8-1.8-2.5l-1.2-0.7v3.1L125.5,46.9 L125.5,46.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st80"
  }, _g71 || (_g71 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "130.6,51 131.5,50.5 131.5,53.7 130.6,54.2  "
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "130.6,46.8 131.5,46.3 131.5,49.5 130.6,50.1  "
  }))), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132.5,50.2l-1-0.6l-0.9,0.5l1,0.7c0.6,0.4,1.2,0.5,1.6,0.4l0.9-0.5C133.7,50.7,133.2,50.6,132.5,50.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 132.5128,
    y1: 218.4992,
    x2: 132.6825,
    y2: 215.5725,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E3E3E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3B3B3"
    }
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "st82",
    d: "M132.7,46l-2.1-1.2l-0.9,0.5l2.1,1.2c1.6,0.9,2.7,2.2,2.7,4c0,0.8-0.3,1.3-0.5,1.4l0.9-0.5 c0.4-0.3,0.5-0.7,0.5-1.4C135.3,48.2,134.2,46.9,132.7,46z"
  })), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M131.7,46.6c1.6,0.9,2.7,2.2,2.7,4c0,1.7-1,2-2.7,1l-1.2-0.7v3.3l-0.9-0.5v-8.3L131.7,46.6z  M131.6,50.7c1.3,0.8,1.8,0.5,1.8-0.7s-0.7-2-2-2.7l-1-0.7v3.3L131.6,50.7L131.6,50.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st80"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 138.4461,
    y1: 212.4579,
    x2: 138.6255,
    y2: 209.3631,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E3E3E2"
    }
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M139.4,57.6c-1.3-0.8-2.1-2.6-2.1-4.7c0-1.2,0.3-2,0.8-2.2l-0.9,0.5c-0.5,0.3-0.8,1-0.8,2.2 c0,2.1,0.9,3.9,2.1,4.7c0.5,0.3,1,0.4,1.3,0.1l0.9-0.5C140.5,58,139.9,57.9,139.4,57.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 139.4853,
    y1: 212.9267,
    x2: 139.7147,
    y2: 208.9695,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E3E3E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3B3B3"
    }
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M139.4,49.9c-0.8-0.5-1.6-0.5-2.1-0.3l-0.9,0.5c0.5-0.3,1.3-0.3,2.1,0.3c1.8,1,3.1,3.4,3.1,6.1 c0,1.4-0.4,2.5-1,2.9l0.9-0.5c0.7-0.4,1-1.3,1-2.9C142.5,53.3,141.2,51,139.4,49.9z"
  })), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M138.5,50.5c1.8,1,3.1,3.4,3.1,6.1c0,2.7-1.3,3.6-3.1,2.6s-3.1-3.5-3.1-6.1 C135.5,50.2,136.7,49.4,138.5,50.5z M138.5,58.1c1.3,0.8,2.2-0.1,2.2-2.2s-0.9-3.9-2.1-4.6c-1.3-0.8-2.2,0-2.2,2.1 C136.4,55.5,137.2,57.3,138.5,58.1L138.5,58.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st80"
  }, _g75 || (_g75 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "144.1,58.6 145,58.1 145,61.6 144.1,62.2  "
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "146.4,59.8 147.3,59.3 149.2,64 148.3,64.5  "
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "144.1,54.6 145,54.1 145,57.2 144.1,57.7  "
  }))), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M146.3,57.9l-1.2-0.6l-0.9,0.5l1.2,0.7c0.7,0.4,1.2,0.5,1.4,0.3l0.9-0.5C147.3,58.4,147,58.3,146.3,57.9 z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 146.1589,
    y1: 210.702,
    x2: 146.3248,
    y2: 207.8393,
    gradientTransform: "matrix(1 0 0 -1 0 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E3E3E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3B3B3"
    }
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M146.4,54.1l-2.2-1.3l-0.9,0.5l2.2,1.3c1.4,0.9,2.6,2.1,2.6,3.8c0,0.8-0.3,1.2-0.5,1.4l0.9-0.5 c0.4-0.3,0.5-0.7,0.5-1.4C148.9,56.2,147.9,54.9,146.4,54.1z"
  })), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M146.4,59.8l1.8,4.7l-1-0.6l-1.7-4.5l-1.3-0.8V62l-0.9-0.5v-8.3l2.2,1.3c1.4,0.9,2.6,2.1,2.6,3.8 C148,59.7,147.3,60.1,146.4,59.8z M145.4,58.5c1.2,0.7,1.8,0.5,1.8-0.7c0-1-0.6-1.8-1.8-2.5l-1.2-0.6v3.1L145.4,58.5 L145.4,58.5z"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    className: "st80"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "151.8,59.2 152.7,58.5 152.7,66.1 151.8,66.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "154,59.4 154.9,58.9 154.9,59.8 154,60.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st68",
    points: "148.6,56.4 149.6,55.9 154.9,58.9 154,59.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "154,59.4 154,60.3 151.8,59.2 151.8,66.6 150.9,66.1 150.9,58.5 148.6,57.3 148.6,56.4  "
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _g80 || (_g80 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "322.2,152 236.1,102.3 192.8,127.4 219.5,142.8 230.2,136.6 289.6,171  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "322.2,133.4 236.1,83.7 192.8,108.8 219.5,124.2 230.2,118.1 289.6,152.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "192.8,108.8 192.8,127.4 219.5,142.8 219.5,124.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "230.2,118.1 230.2,136.6 289.6,171 289.6,152.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "322.2,133.4 322.2,152 289.6,171 289.6,152.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "219.5,142.8 230.2,136.6 230.2,118.1 219.5,124.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "220.7,124.9 229,120.1 229,135.9 220.7,140.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "265.1,139.6 265.1,155.4 272.3,159.5 272.3,143.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "273.6,144.4 273.6,160.2 281.1,164.6 281.1,148.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "256.3,134.6 256.3,150.3 263.8,154.6 263.8,138.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "231.5,120.1 231.5,135.9 237.8,139.6 237.8,123.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "247.8,129.6 247.8,145.4 255.1,149.5 255.1,133.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "239.1,124.6 239.1,140.3 246.7,144.7 246.7,129  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "282.3,165.2 288.3,168.8 288.3,153 282.3,149.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "321,135.6 315.6,138.7 315.6,154.5 321,151.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "307.1,143.5 307.1,159.3 314.4,155.1 314.4,139.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "290.7,153 290.7,168.8 297.1,165.1 297.1,149.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "298.4,148.6 298.4,164.3 305.9,160 305.9,144.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "231.5,121.6 231.5,126.6 237.8,137.7 237.8,132.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "239.1,139.9 239.5,140.5 243.4,142.9 239.1,135.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "231.5,130.1 236.4,138.9 237.8,139.6 237.8,139.5 231.5,128.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "247.8,140.5 252.1,147.8 255.1,149.5 255.1,148.5 247.8,135.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "246.7,133.4 242.9,126.8 239.1,124.6 239.1,125.5 246.7,138.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "237.8,124.4 237.4,123.6 235.2,122.3 237.8,126.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "247.8,144.1 249,146 250.6,146.9 247.8,142.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "239.1,126.5 239.1,129 246.7,142 246.7,139.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "265.1,155.4 268.9,157.6 265.1,150.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "256.3,135.2 256.3,140.4 263.8,153.4 263.8,148.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "255.1,133.8 251.2,131.6 255.1,138.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "256.3,143.9 261.9,153.5 263.4,154.5 256.3,141.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "250.3,131.1 248.1,129.9 255.1,141.8 255.1,139.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "272.3,153.8 272.3,148.7 268.2,141.6 265.1,139.8 265.1,141.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "273.6,155.9 277.3,162.4 281.1,164.6 281.1,164.3 273.6,150.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st89",
    d: "M263.8,139.1L263.8,139.1L263.8,139.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "265.1,142.5 265.1,144.8 272.3,157.3 272.3,155.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "273.6,159.4 274.2,160.7 275.8,161.6 273.6,157.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "262.9,138.6 260.7,137.3 263.8,142.8 263.8,140.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "276.3,146.3 281.1,154.3 281.1,149.1 280.9,148.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "288.3,166.8 288.3,162 282.3,151.3 282.3,156.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "275.5,145.7 273.6,144.6 273.6,145 281.1,157.8 281.1,155.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "282.3,160 286.8,168 288.3,168.8 288.3,168.5 282.3,157.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "218.2,124.9 210.4,120.4 210.4,125.3 218.2,129.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "218.2,129.9 218.2,127.8 215.9,123.5 211.6,121 215.9,128.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "210.4,120.4 210.4,122.5 212.7,126.6 214.6,127.7  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "210.4,136.1 218.2,140.7 218.2,131.3 210.4,126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "218.2,136.3 218.2,134.2 215.7,129.9 213.9,128.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "200.4,114.5 194,110.9 194,115.8 200.4,119.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "194,126.8 200.4,130.3 200.4,120.9 194,117.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "209.1,119.6 201.6,115.3 201.6,120.3 209.1,124.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "201.6,131.1 209.1,135.3 209.1,126 201.6,121.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "195.3,111.7 194,110.9 194,114.7 195.1,116.5 199.5,119  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "200.4,120.9 196.4,118.7 200.4,125.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "201.6,127.7 204.5,132.7 208.4,135.1 201.6,122.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "195.2,117.9 194,117.3 194,118.2 200.4,129.1 200.4,127.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "201.6,131.1 203,131.8 201.6,129.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "210.4,130.9 214.8,138.7 218.2,140.7 218.2,140 210.9,127 210.4,126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "209.1,124.6 209.1,123.8 205.6,117.7 201.6,115.3 201.6,115.8 205.5,122.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "209.1,126 206.6,124.6 209.1,128.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "210.4,134.4 211.8,136.9 213.4,137.8 210.4,132.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "200.4,114.7 200.3,114.5 198,113.2 200.4,117.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "202.3,120.7 204.3,121.8 201.6,116.9 201.6,119.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "205.6,123.9 203.6,122.9 209.1,132.4 209.1,130.3  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "219.5,121.6 219.5,126.1 230.2,119.9 230.2,115.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "186.6,102.6 186.6,107.1 219.5,126.1 219.5,121.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "289.6,149.6 289.6,154.2 328.4,131.7 328.4,127.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "289.6,149.6 230.2,115.3 269,93 328.4,127.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "230.2,115.3 230.2,119.9 289.6,154.2 289.6,149.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "219.5,121.6 186.6,102.6 236.1,74 269,93  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "192.8,102.6 236.1,77.5 262.4,92.6 219.1,117.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "203,100.5 203,103 208.7,99.6 208.7,97.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "200.4,99.1 200.4,101.4 203,103 203,100.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "203,100.5 200.4,99.1 206.1,95.7 208.7,97.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "220.9,110.8 220.9,113.2 226.6,109.9 226.6,107.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "218.3,109.3 218.3,111.7 220.9,113.2 220.9,110.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "220.9,110.8 218.3,109.3 224,106 226.6,107.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "216.9,92.4 216.9,94.9 222.6,91.5 222.6,89.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "214.3,91 214.3,93.4 216.9,94.9 216.9,92.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "216.9,92.4 214.3,91 220,87.6 222.6,89.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "234.8,102.7 234.8,105.1 240.6,101.8 240.6,99.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "232.2,101.2 232.2,103.6 234.8,105.1 234.8,102.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "234.8,102.7 232.2,101.2 238,97.9 240.6,99.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "230.8,84.4 230.8,86.7 236.5,83.5 236.5,81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "228.2,82.8 228.2,85.3 230.8,86.7 230.8,84.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "230.8,84.4 228.2,82.8 233.9,79.6 236.5,81  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "248.7,94.7 248.7,97 254.5,93.7 254.5,91.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "246.1,93.1 246.1,95.6 248.7,97 248.7,94.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "248.7,94.7 246.1,93.1 251.9,89.8 254.5,91.3  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "230.2,92.7 230.2,111.4 289.6,145.6 289.6,127  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "322.2,108.2 322.2,126.8 289.6,145.6 289.6,127  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "321,110.4 315.6,113.4 315.6,129.2 321,126.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "307.1,118.3 307.1,134 314.4,129.9 314.4,114.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "290.7,127.8 290.7,143.5 297.1,139.9 297.1,124  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "298.4,123.4 298.4,139.1 305.9,134.8 305.9,119  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "265.1,114.4 265.1,130.1 272.3,134.3 272.3,118.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "273.6,119.2 273.6,135 281.1,139.4 281.1,123.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "256.3,109.3 256.3,125.1 263.8,129.4 263.8,113.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "231.5,94.9 231.5,110.6 237.8,114.4 237.8,98.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "247.8,104.4 247.8,120.1 255.1,124.3 255.1,108.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "239.1,99.3 239.1,115.1 246.7,119.5 246.7,103.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "282.3,140 288.3,143.5 288.3,127.8 282.3,124.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "231.5,96.2 231.5,101.4 237.8,112.5 237.8,107.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "239.1,114.7 239.5,115.3 243.4,117.7 239.1,109.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "231.5,104.9 236.4,113.5 237.8,114.4 237.8,114.2 231.5,102.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "247.8,115.3 252.1,122.6 255.1,124.3 255.1,123.3 247.8,110.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "246.7,108.2 242.9,101.5 239.1,99.3 239.1,100.2 246.7,113.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "237.8,99.1 237.4,98.4 235.2,97.1 237.8,101.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "247.8,118.8 249,120.8 250.6,121.7 247.8,116.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "239.1,101.3 239.1,103.8 246.7,116.8 246.7,114.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "265.1,130.1 268.9,132.4 265.1,125.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "256.3,110 256.3,115.2 263.8,128.2 263.8,123.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "255.1,108.6 251.2,106.4 255.1,113  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "256.3,118.7 261.9,128.2 263.4,129.1 256.3,116.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "250.3,105.8 248.1,104.5 255.1,116.6 255.1,114.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "272.3,128.5 272.3,123.5 268.2,116.4 265.1,114.5 265.1,116.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "273.6,130.7 277.3,137.2 281.1,139.4 281.1,139.1 273.6,125.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "263.8,113.9 263.8,113.9 263.8,113.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "265.1,117.3 265.1,119.6 272.3,132.1 272.3,130  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "273.6,134.2 274.2,135.3 275.8,136.3 273.6,132.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "262.9,113.4 260.7,112.1 263.8,117.5 263.8,115.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "276.3,120.9 281.1,129.1 281.1,123.9 280.9,123.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "288.3,141.6 288.3,136.8 282.3,126.1 282.3,131.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "275.5,120.5 273.6,119.4 273.6,119.6 281.1,132.6 281.1,130.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "282.3,134.8 286.8,142.8 288.3,143.5 288.3,143.3 282.3,132.6  "
  })))), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "225.2,89.7 262.7,67.7 327.1,105.1 289.6,126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "231.5,89.7 262.7,71.4 321,105.1 289.6,123.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "289.6,126.8 289.6,129.9 327.1,108.2 327.1,105.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "225.2,89.7 225.2,92.8 289.6,129.9 289.6,126.8  "
  }))))), /*#__PURE__*/React.createElement("g", null, _g81 || (_g81 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "359.2,85.4 341.8,75.3 318,79.1 311.7,92.7 329.1,102.8 352.9,99.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "311.7,161.7 311.7,92.7 329.1,102.8 329.1,171.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "311.7,96.9 311.7,92.7 329.1,102.8 329.1,107  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "352.9,99.1 352.9,168.1 329.1,171.7 329.1,102.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st91",
    points: "352.9,99.1 352.9,103.2 329.1,107 329.1,102.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "359.2,85.4 359.2,154.3 352.9,168.1 352.9,99.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "315,142.6 315,155.1 316.3,154.3 316.3,143.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "316.3,154.3 315,155.1 325.7,161.3 325.7,159.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "316.3,143.4 316.3,154.3 325.7,159.8 325.7,148.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "317,153.9 317,144.4 325.2,149.1 325.2,158.7  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "319.2,145.7 317,144.4 317,146.8 323.2,157.6 325.2,158.7 325.2,156  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "317,150.3 320.1,155.8 321.8,156.8 317,148.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "348.1,147.7 348.1,159.3 349.1,160.2 349.1,147.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "348.1,159.3 332.9,161.6 332.9,162.8 349.1,160.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "348.1,147.7 332.9,150.2 332.9,161.6 348.1,159.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "333.4,150.7 347.4,148.5 347.4,158.7 333.4,160.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "356.9,137.4 356.9,149.4 357.9,149.4 357.9,135.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "356.9,149.4 354,155.5 354,157.7 357.9,149.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "356.9,137.4 354,143.5 354,155.5 356.9,149.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "354.4,143.5 356.6,138.9 356.6,149.4 354.4,154.1  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "315,126 315,138.5 316.3,137.7 316.3,126.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "316.3,137.7 315,138.5 325.7,144.6 325.7,143  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "316.3,126.6 316.3,137.7 325.7,143 325.7,132.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "317,137.3 317,127.8 325.2,132.5 325.2,142  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "318.6,128.7 317,127.8 317,130.8 322.6,140.5 325.2,142 325.2,140.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "317,134.4 319.5,138.7 321.2,139.8 317,132.4  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "348.1,131.1 348.1,142.5 349.1,143.5 349.1,130.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "348.1,142.5 332.9,144.8 332.9,146 349.1,143.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "348.1,131.1 332.9,133.4 332.9,144.8 348.1,142.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "333.4,133.9 347.4,131.8 347.4,142 333.4,144.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "356.9,120.8 356.9,132.7 357.9,132.7 357.9,118.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "356.9,132.7 354,138.7 354,141.1 357.9,132.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "356.9,120.8 354,126.8 354,138.7 356.9,132.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "354.4,126.9 356.6,122.2 356.6,132.6 354.4,137.3  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "315,109.2 315,121.7 316.3,120.9 316.3,110  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "316.3,120.9 315,121.7 325.7,127.9 325.7,126.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "316.3,110 316.3,120.9 325.7,126.4 325.7,115.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "317,120.5 317,111 325.2,115.8 325.2,125.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "317,120.5 317,111 325.2,115.8 325.2,125.3  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "319.5,112.6 317,111 317,113.1 323.5,124.3 325.2,125.3 325.2,122.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "317,116.6 320.4,122.6 322.1,123.5 317,114.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "348.1,114.4 348.1,125.9 349.1,126.8 349.1,114.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "348.1,125.9 332.9,128.2 332.9,129.4 349.1,126.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "348.1,114.4 332.9,116.8 332.9,128.2 348.1,125.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "333.4,117.3 347.4,115.1 347.4,125.3 333.4,127.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st93",
    points: "356.9,104 356.9,116 357.9,116 357.9,101.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st94",
    points: "356.9,116 354,122.1 354,124.4 357.9,116  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "356.9,104 354,110.1 354,122.1 356.9,116  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "354.4,110.1 356.6,105.4 356.6,116 354.4,120.7  "
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "359.2,85.4 359.2,89.6 352.9,103.2 352.9,99.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "364.4,75.9 343.3,63.7 314.1,68.3 306.3,85 327.7,97.3 356.8,92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "361.6,76.5 342.5,65.4 316.3,69.4 309.3,84.5 328.4,95.6 354.6,91.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "364.4,75.9 364.4,82.6 356.8,99.3 356.8,92.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "356.8,99.3 356.8,92.7 327.7,97.3 327.7,103.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "306.3,85 306.3,91.5 327.7,103.8 327.7,97.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "352.9,89.5 355.6,78.7 328,83 329.1,93.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "328.7,83.5 354.8,79.4 352.4,88.9 329.6,92.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "363,62.8 359.2,75.8 352.9,89.5 355.6,78.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "355.9,78.8 361.6,66.6 358.9,75.7 354,86.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "307.9,71.3 311.7,83.1 329.1,93.1 328,83  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st69",
    points: "312.2,82.7 308.9,72.6 327.5,83.3 328.3,92.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "321.7,88.2 325.8,90.6 318.8,78.3 314.5,75.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "318.6,86.3 320.4,87.4 313.4,75.2 311.4,74  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "364.4,56.2 343.3,43.8 314.1,48.4 306.3,65.1 327.7,77.4 356.8,72.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st13",
    points: "362.8,56.4 342.7,44.9 315.4,49 308.2,64.9 328.2,76.5 355.5,72.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "364.4,56.2 364.4,62.7 356.8,79.4 356.8,72.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "356.8,79.4 356.8,72.9 327.7,77.4 327.7,84  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "306.3,65.1 306.3,71.6 327.7,84 327.7,77.4  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "328.8,62.8 328.8,75.2 353.7,71.4 353.7,58.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st92",
    points: "329.3,63.3 353,59.7 353,70.7 329.3,74.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st86",
    points: "310.5,52.3 310.5,64.6 328.8,75.2 328.8,62.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "311.1,64.2 311.1,53.3 328.2,63.1 328.2,74.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "323.1,71.3 327.3,73.6 317.9,57.2 313.5,54.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "312.3,54 311.4,53.4 311.4,54.5 320,69.4 321.7,70.3  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "353.7,71.4 353.7,58.9 360.4,44.5 360.4,57  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st74",
    points: "354,59 360,45.9 360,56.8 354,70  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st15",
    points: "363,38 342.9,26.3 315.3,30.6 307.9,46.4 328,58.1 355.6,53.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "356.8,38.9 341.2,29.9 319.9,33.2 314.1,45.5 329.7,54.5 351.1,51.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "363,38 363,44.1 355.6,60.1 355.6,53.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st14",
    points: "355.6,60.1 355.6,53.8 328,58.1 328,64.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "307.9,46.4 307.9,52.7 328,64.2 328,58.1  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.36,
    y1: 226.7222,
    x2: 359.5651,
    y2: 226.7222,
    gradientTransform: "matrix(1 0 0 -1 -18.6871 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3B3B3"
    }
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "st98",
    d: "M331.7,33.9V42l0,0c0,0.7,0.4,1.3,1.3,1.8c1.8,1,4.7,1,6.5,0c0.9-0.5,1.3-1.2,1.3-1.8l0,0v-8.1H331.7z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M339.5,32.1c1.8,1,1.8,2.7,0,3.8c-1.8,1-4.7,1-6.5,0c-1.8-1-1.8-2.7,0-3.8S337.8,31.1,339.5,32.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 351.494,
    y1: 234.3597,
    x2: 358.4312,
    y2: 234.3597,
    gradientTransform: "matrix(1 0 0 -1 -18.6871 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3B3B3"
    }
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "st99",
    d: "M332.9,27.6v6.1l0,0c0,0.5,0.4,1,1,1.4c1.3,0.8,3.5,0.8,4.9,0c0.7-0.4,1-0.9,1-1.4l0,0v-6.1H332.9z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M338.7,26.1c1.3,0.8,1.3,2.1,0,2.9c-1.3,0.8-3.5,0.8-4.9,0c-1.3-0.8-1.3-2.1,0-2.9 C335.2,25.4,337.4,25.4,338.7,26.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 353.4258,
    y1: 243.4759,
    x2: 356.4993,
    y2: 243.4759,
    gradientTransform: "matrix(1 0 0 -1 -18.6871 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#EDEDEC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B3B3B3"
    }
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M334.7,16.4v11.3l0,0c0,0.3,0.1,0.4,0.4,0.6c0.7,0.4,1.6,0.4,2.2,0c0.3-0.1,0.4-0.4,0.4-0.6l0,0V16.4 H334.7z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M337.4,15.7c0.6,0.4,0.6,0.9,0,1.3c-0.6,0.4-1.6,0.4-2.2,0c-0.6-0.4-0.6-0.9,0-1.3 C335.8,15.4,336.8,15.4,337.4,15.7z"
  }))), /*#__PURE__*/React.createElement("g", null, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "st71",
    d: "M347.7,25.6l-0.8,0.4c0,0-9.6-16-23.7-17.7l0.8-0.4c16.8,0.7,23.7,10.9,23.7,10.9V25.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 341.9231,
    y1: 248.7572,
    x2: 365.5331,
    y2: 248.7572,
    gradientTransform: "matrix(1 0 0 -1 -18.6871 266)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3B3B3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1874,
    style: {
      stopColor: "#C6C6C5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4734,
    style: {
      stopColor: "#DBDBDB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7488,
    style: {
      stopColor: "#E9E9E8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EDEDEC"
    }
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M346.9,26.1c0,0-6.9-10.3-23.7-12.3V8.3C340,9,346.9,19.3,346.9,19.3V26.1z"
  })))))))), /*#__PURE__*/React.createElement("g", null, _g82 || (_g82 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.6,138.6c0.3,0.2,0.9,0.2,1.2,0l3.6-2.1c0.3-0.2,0.3-0.5,0-0.7l-1.6-0.9c-0.3-0.2-0.9-0.2-1.2,0l-3.6,2.1 c-0.3,0.2-0.3,0.5,0,0.7L96.6,138.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M96,136.6c-0.2-0.2-0.3-0.2-0.5-0.2h0l-0.4,0.2l0.6,1.1c0,0,0.3-0.2,0.4-0.2l0,0l0,0c0,0,0.1-0.1,0.1-0.1 C96.4,137.2,96.2,136.8,96,136.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M95.9,137.6c-0.1,0.2-0.3,0.2-0.6,0c-0.2-0.2-0.3-0.6-0.3-0.8c0.1-0.2,0.3-0.2,0.6,0 C95.9,137,96,137.4,95.9,137.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M95.7,137.4c-0.1,0.1-0.2,0.1-0.3,0c-0.1-0.1-0.2-0.3-0.1-0.4c0-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0 c0,0.1,0,0.3,0.1,0.4C95.6,137.4,95.7,137.4,95.7,137.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M95.7,137.4C95.7,137.4,95.7,137.4,95.7,137.4c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.2-0.3-0.1-0.4 c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0.1C95.7,137.1,95.8,137.3,95.7,137.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M96.2,136.5c0,0,0.1,0,0.1,0l2,1.1h0l2.9-1.7l-1.8-1.1v0c0,0,0,0,0,0c0,0,0-0.1,0.1-0.2c0,0,0.1,0,0.1,0 l2,1.1c0.3,0.1,0.1,0.3,0,0.4v0l-3,1.7c0,0-0.1,0.1-0.3,0l-2-1.1v0c0,0,0,0,0,0C96.1,136.6,96.2,136.6,96.2,136.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st107",
    d: "M95.8,128.3l3.8-2.2c0.1-0.1,0.2-0.1,0.3,0v0l0,0c0,0,0,0,0,0l2,1.2l-1.9,4.6v1.9c0,0.3-0.2,0.6-0.4,0.7 l-0.9,0.5l-1.2,2.9l-2-1.2v0c-0.1,0-0.1-0.1-0.1-0.3V129C95.4,128.7,95.5,128.4,95.8,128.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6,128.8l3.8-2.2c0.1-0.1,0.2-0.1,0.3,0l0,0h0c0,0,0,0,0,0l0.1,0.1c-0.1,0-0.2,0-0.3,0l-3.8,2.2 c-0.2,0.1-0.4,0.4-0.4,0.7v2.4l-0.1-0.1v-2.4C96.2,129.2,96.4,128.9,96.6,128.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st108",
    d: "M97.4,137.5c0,0.2,0.2,0.4,0.4,0.2l3.8-2.2c0.2-0.1,0.4-0.4,0.4-0.7v-7.4c0-0.3-0.2-0.4-0.4-0.2l-3.8,2.2 c-0.2,0.1-0.4,0.4-0.4,0.7V137.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M97,133l-1.3-0.8c0,0-0.1,0-0.1,0v0l0,0c0,0,0,0,0,0l-0.4,0.2l0.3,2.9v0.7c0,0.1,0.1,0.2,0.1,0.2l0.3,0.2 l0.7,0.8l0.4-0.2l0,0c0,0,0,0,0-0.1v-3.7C97.2,133.1,97.1,133,97,133z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M96.8,137.2c0,0.1-0.1,0.1-0.1,0.1l-1.3-0.8c-0.1,0-0.1-0.2-0.1-0.2v-3.7c0-0.1,0.1-0.1,0.1-0.1l1.3,0.8 c0.1,0,0.1,0.2,0.1,0.2V137.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "96.6,134 95.3,133.3 95.3,133.2 96.6,133.9  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M97.8,130.3l0,1.5c0,0,0,0.1,0,0.1h0h0c0,0,0,0,0,0l0.2,0.1l2.5-1.7l0.6-0.3c0.1,0,0.1-0.2,0.1-0.2l0-0.3 l0.2-1.1l-0.2-0.1l0,0c0,0-0.1,0-0.1,0l-3.2,1.9C97.9,130.1,97.8,130.2,97.8,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M101.4,128.4c0.1,0,0.1,0,0.1,0.1l0,1.5c0,0.1-0.1,0.2-0.1,0.2l-3.2,1.9c-0.1,0-0.1,0-0.1-0.1l0-1.5 c0-0.1,0.1-0.2,0.1-0.2L101.4,128.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "98.3,130.7 101.3,129 101.3,128.9 98.3,130.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M97.8,133.2l0,3.6c0,0,0,0.1,0,0.1h0h0c0,0,0,0,0,0l0.4,0.2l2.3-1.8l0.6-0.3c0.1,0,0.1-0.2,0.1-0.2l0-2.4 l0.4-1l-0.4-0.2l0,0c0,0-0.1,0-0.1,0L98,133C97.9,133,97.8,133.1,97.8,133.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M101.6,131.4c0.1,0,0.1,0,0.1,0.1l0,3.6c0,0.1-0.1,0.2-0.1,0.2l-3.2,1.9c-0.1,0-0.1,0-0.1-0.1l0-3.6 c0-0.1,0.1-0.2,0.1-0.2L101.6,131.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "98.5,133.9 101.5,132.2 101.5,132.1 98.5,133.8  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M96.7,128.2c0.1,0,0.1-0.1,0.1-0.1l0-0.1l-0.5,0v0.1h0c0,0,0,0,0,0.1C96.5,128.2,96.6,128.3,96.7,128.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M96.4,128c-0.1-0.1,0-0.1,0.1-0.2c0.1,0,0.3,0,0.3,0.1c0.1,0.1,0,0.1-0.1,0.2 C96.6,128.1,96.5,128.1,96.4,128z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M99.4,126.7c0.1,0,0.1-0.1,0.1-0.1l0-0.1l-0.5,0v0.1h0c0,0,0,0,0,0.1C99.2,126.7,99.3,126.7,99.4,126.7z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M99.1,126.5c-0.1-0.1,0-0.1,0.1-0.2c0.1,0,0.3,0,0.3,0.1c0.1,0.1,0,0.1-0.1,0.2 C99.3,126.6,99.2,126.5,99.1,126.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M99.3,126.5C99.2,126.5,99.2,126.4,99.3,126.5l-0.1-1l0.3,0l0,1h0c0,0,0,0,0,0 C99.4,126.5,99.3,126.5,99.3,126.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M99.5,125.5c0,0,0-0.1-0.1-0.1c-0.1,0-0.2,0-0.2,0c0,0,0,0.1,0.1,0.1C99.3,125.5,99.4,125.5,99.5,125.5z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M96.6,128C96.5,128,96.5,128,96.6,128l-0.1-1l0.3,0l0,1h0c0,0,0,0,0,0C96.7,128,96.7,128.1,96.6,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M96.8,127.1c0,0,0-0.1-0.1-0.1c-0.1,0-0.2,0-0.2,0c0,0,0,0.1,0.1,0.1C96.7,127.1,96.7,127.1,96.8,127.1z "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M99.5,125c-0.1-0.1-0.2-0.1-0.2-0.1l-0.2,0.1l0.3,0.5l0.2-0.1v0c0,0,0,0,0.1-0.1 C99.7,125.3,99.6,125.1,99.5,125z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M99.5,125.5c0,0.1-0.2,0.1-0.3,0c-0.1-0.1-0.2-0.3-0.1-0.4c0-0.1,0.2-0.1,0.3,0 C99.5,125.2,99.5,125.4,99.5,125.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M99.3,125.2c0,0-0.1-0.1-0.1,0l-2.7,1.6l0.2,0.3l2.7-1.6v0c0,0,0,0,0,0 C99.4,125.3,99.4,125.2,99.3,125.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M96.7,126.9c0,0.1-0.1,0.1-0.1,0c-0.1-0.1-0.1-0.1-0.1-0.2c0-0.1,0.1-0.1,0.1,0 C96.6,126.8,96.7,126.9,96.7,126.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M96.8,126.5c-0.1-0.1-0.2-0.1-0.2-0.1l-0.2,0.1l0.3,0.5l0.2-0.1v0c0,0,0,0,0.1-0.1 C97,126.8,96.9,126.7,96.8,126.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M96.8,127c0,0.1-0.2,0.1-0.3,0c-0.1-0.1-0.2-0.3-0.1-0.4c0-0.1,0.2-0.1,0.3,0 C96.7,126.7,96.8,126.9,96.8,127z"
  }))))), /*#__PURE__*/React.createElement("g", null, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M95.7,139c-1.5-0.9-3.9-0.9-5.4,0c-1.1,0.6-1.4,1.5-0.9,2.3c-1-0.1-2.1,0.1-2.9,0.5 c-1.2,0.7-1.2,1.9,0,2.6c1.2,0.7,3.3,0.7,4.5,0c0.8-0.5,1.1-1.1,0.8-1.7c1.3,0.2,2.8,0,3.8-0.6C97.2,141.3,97.2,139.9,95.7,139z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M96.5,118.9l0.7-0.3c-0.2-0.6,0.1-1.7-0.1-2.9c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.3-0.7-0.2-0.9 c0.1-0.1,0.4,0.3,0.4,0.3s-0.3-1.2,0.2-1.5c0.2-0.1,1,0.4,1.1,0.6c0.3,0.8-0.1,1.7-0.1,1.7s0.7,2.7,0.6,3.3 c-0.2,0.8-1.3,1.1-1.3,1.1L96.5,118.9z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M94.2,119.4c0.3-0.4,1.2-0.2,2.7-0.8c0.9,0.1,0.7,1.5,0.7,1.5s-1.5,0.7-2,1.5c-0.3,0.5-1.7-1.7-1.7-1.7 S93.9,119.8,94.2,119.4z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M91.8,119.2c0,0.7-0.3,0.9-0.3,0.9l0.1,0.5l1.1,0.9l1.2-0.3l0.5-0.6l-0.8-1.4l-1.2-0.1 C92.3,119.1,91.8,119.1,91.8,119.2z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M94.7,138.7c0.4,0.6,1.4,1.1,1.6,1.4c0.1,0.1,0,0.6-0.1,0.6c-1,0.3-2-0.7-2-0.7c-0.2,0-1-0.2-1.3-0.5 c-0.2-0.2,0.1-1,0.1-1S94.5,138.7,94.7,138.7z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M95.6,127.5c0.5,3,0.1,6,0.1,6.6c0.1,0.7-0.7,3-0.6,4.7c-0.3,0.3-1.6,0.7-2.3-0.1c0.3-1.6,0.4-3.2,0.8-4.6 c-0.2-1.2-1-4-1-4S95.3,127.2,95.6,127.5z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M91.2,139.8c0.1,0.6,0.7,1.4,0.8,1.7c0.2,0.2,0.2,0.6,0.1,0.7c-0.6,0.5-1.4,0.2-1.7-0.2 c-0.4-0.4-0.6-1.5-0.6-1.6c0-0.1,0.3-0.8,0.3-0.8S91.1,139.7,91.2,139.8z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M90.7,128c-1.1,1.4-1.1,11.9-1.1,11.9s1,0.3,1.8-0.1c0-3.4,2-9.3,2-9.3s1.7-0.9,2.2-3 c0-0.3-1.6-0.8-1.6-0.8S91.2,127.4,90.7,128z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    className: "st117",
    d: "M90.9,127.3l-0.2,0.7c0,0,2.1,1.6,4.9-0.5c0-0.2-0.1-0.8-0.1-0.8L90.9,127.3z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M91.5,120.2c0,0,1.2,1.4,2.1,0.9c0.5-0.3,0-1.6,0-1.6h0.5c0,0,1.5,0.4,1.6,2.6c0,1.5-0.4,2.8-0.3,4.5 c0.1,0.8-3.4,2.3-4.5,0.6c-0.1-2-0.7-3-0.9-3.6c-0.2-0.6,0.3-2.4,0.3-2.4L91.5,120.2z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M87.9,123.1c0.6-0.4,1.5-1.6,2.5-1.9c0.1,0,1.1,1.3,0.7,2c-0.2,0.5-0.7,0.2-1.9,1.3 C88.9,124.6,87.3,123.6,87.9,123.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 87.5105,
    y1: 125.6694,
    x2: 85.5633,
    y2: 125.266
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0C1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6997E"
    }
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    className: "st119",
    d: "M86.7,124.1c-0.9,0.7-0.7,2.2-0.9,2.7c0,0.2,0.8,0.1,0.8,0.1l0.9-0.4l0.3-1.5l-0.2-0.8 C87.6,124.2,86.8,123.9,86.7,124.1z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    className: "st116",
    d: "M87.3,125.3c0,0.5-0.2,0.8-0.2,0.8v0.4l0.7,0.6l0.9-0.1l0.5-0.4l0-1.2l-1.2-0.2 C88,125.2,87.1,124.8,87.3,125.3z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M89.8,142c0.1,0.4,1.2,0.8,1.4,0.9c0.1,0,0.3,0.4,0.2,0.7c0,0.1-0.2,0.4-0.9,0.2c-0.4-0.1-0.9-0.6-0.9-0.6 s-1-0.1-1-0.5c0-0.4,0.1-0.6,0.1-0.9L89.8,142z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M88.6,141.9c0-0.1,0-0.1,0-0.2c0.2-0.8,0-2.3,0.1-2.8c0.1-0.4,0.3-0.8,0.3-0.8l-0.3-1.2l1.8-0.5 c0,0,0,1.5,0,1.8c0,0.4-0.8,3.4-0.7,3.8C89.9,142.5,88.7,142.6,88.6,141.9z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    className: "st115",
    d: "M90.4,132.7l0.2,3.7c0,0-0.9,0.8-2.1,0.6c0-0.1-0.5-2.1-0.5-2.1L90.4,132.7z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M87.3,142.5c0,0.2,0.8,1.1,0.9,1.3c0.1,0.2,0.1,0.6-0.1,0.7c-0.4,0.2-1.1,0.1-1.3,0 c-0.1-0.1-0.6-0.9-0.6-1.2c0-0.3,0.1-0.6,0.1-0.7L87.3,142.5z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M86.3,142.5c0-0.6-0.5-2.4-0.4-3c0.1-0.6,0.3-0.9,0.3-0.9s-0.1-1.3,0-1.6c0.1-0.3,1.9-0.1,1.9,0.2 c0,0.8-0.6,2-0.6,2s-0.4,2.9-0.1,3.3C87.4,143.1,86.4,143.1,86.3,142.5z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    className: "st118",
    d: "M86.2,133.2c-0.2,0.8-0.2,2.5-0.3,3.7c0.1,0.4,1.6,1,2.4,0.1c0.2-1.2,0.3-1.9,0.3-2.1 c1.5-0.6,1.8-2.2,1.8-2.2S86.4,132.9,86.2,133.2z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M91.2,128.6c0,0,0.2,0.5,0.3,0.7c0.5,0.4,1.6,3.1,1.6,3.1s0.9,0.9,1,1.1c0.1,0.2,0,1-0.1,1.1 c-0.1,0.1-0.8,0-0.9-0.3c-0.1-0.2,0-0.6,0-0.6s-0.5-0.5-0.6-0.6c-0.1-0.1-0.1-0.3-0.1-0.5c-0.5-0.8-1.6-1.7-2-2.8 c-0.2-0.5-0.4-0.8-0.4-0.8L91.2,128.6z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M89.7,125.3c0.9,0.2,1,1.2,1,1.2l0.6,2.2c0,0-0.4,0.5-1.2,0.7c-0.1-0.7-1-3.5-1-3.5S89.5,125.3,89.7,125.3 z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    className: "st122",
    d: "M85.9,128.7c0,0.4,0.2,1.5,0.3,2.5c0,1.1-0.1,2-0.1,2.1c1.3,1.4,4.2-0.4,4.4-0.6c-0.1-1-0.1-4.8-0.2-5.6 c-0.1-0.8-0.8-1.3-0.8-1.3l-1,0c0,0,0.9,0.7,0.1,1c-0.8,0.3-1.6-0.7-1.6-0.7l-1,0.8C86,126.9,86,127.8,85.9,128.7z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M84.6,129.4c0,0-0.6-0.1-0.8-0.6c-0.2-0.6,0.3-0.8,0.3-0.8l0.8,0.4L84.6,129.4z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M82.3,125.5c0.3,0.2,0.4,0.8,0.4,0.8s0.3,0.1,0.3,0.3c0,0.2-0.2,0.5-0.2,0.6c0.2,0.6,0.6,0.8,0.7,1.1 c0,0,0.6-0.2,0.9-0.4c0.1,0,0.5,0.7,0.5,0.7l-0.1,0.5c0,0-1.2,0.7-1.6,0.6c-0.8-0.2-0.9-1.8-1.1-2.2c-0.1-0.1-0.5-0.4-0.6-0.8 c-0.1-0.3,0.1-0.9,0.3-1C81.9,125.5,82.2,125.4,82.3,125.5z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    className: "st121",
    d: "M84.1,127.9c0.7,0.5,0.5,1.5,0.5,1.5l1.9-0.7c0,0,0.3-1.3-0.1-1.5C86.1,126.9,84.5,127.8,84.1,127.9z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M89.8,123.9c0.1,1-0.2,2.1-0.3,2.2c-0.1,0.1-0.5,0.2-0.6,0.2c-1.1-0.3-1.5-1-1.5-1s-0.4,0.1-0.5-0.5 c-0.1-0.2-0.1-0.6-0.1-0.6l0.7-0.6l1.4-0.2l0.4,0.1C89.4,123.4,89.8,123.8,89.8,123.9z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M93.9,116.9c0.4,0.3,0.6,1.1,0.6,1.2c0,0.1,0,0.2-0.1,0.3c0.2,0.4-0.2,1.9-0.2,2c-0.1,0.1-0.3,0.3-0.5,0.3 c-1.5-0.3-1.5-1.2-1.5-1.2s-0.4-0.1-0.6-0.6c-0.1-0.2-0.1-0.6-0.1-0.6l0.2-0.7l0.6-0.8h1C93.2,116.7,93.8,116.9,93.9,116.9z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M91.5,118.9c0,0-0.1-0.5,0.2-0.5c0.2,0,0.6,0.6,0.6,0.6s0.2-0.4,0.2-0.9c0-0.2-0.5-0.7-0.3-0.9 c0.4-0.4,1.2,0.5,1.7,0c0.3-0.3-0.9-1.8-2.1-0.7C90.6,117.6,91.5,118.9,91.5,118.9z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M87.2,124.5c0.3,0,0.4,0.5,0.4,0.5s0-0.5,0.2-0.6c0.2-0.1,0.6,0.4,1.2,0.1c-0.2-0.1-0.1-0.4-0.1-0.4 s0.5,0.2,1.1-0.2c-0.3-0.2-0.5-1.6-2.3-1.3c-0.1,0.1-0.1-0.3-0.1-0.3l-0.2,0.3h-0.5c0,0,0.2,0.2,0.2,0.3c-0.8,0.8-0.1,2-0.1,2 S86.9,124.5,87.2,124.5z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_34_",
    cx: 87.437,
    cy: 125.946,
    r: 2.0409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F0C1AD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D6997E"
    }
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    className: "st125",
    d: "M86.3,126.4c-0.5,0-0.6,0.5-0.6,0.5s-0.1,1.6,0.2,1.8c0.2,0.2,0.7,0.3,0.9,0.3c0.2,0,0.4-0.6,0.4-0.8 c0-0.3-0.1-0.7-0.1-0.7s0.3-0.3,0.2-0.4c-0.3-0.3-0.5-0.5-0.5-0.7C86.8,126.3,86.4,126.4,86.3,126.4z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    className: "st126",
    d: "M83.5,128.2c0,0,0.2,0.4-0.1,0.9C84,128.8,83.5,128.2,83.5,128.2z"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M108.7,150.4c-1.6,0.9-4.1,0.9-5.7,0c-1.6-0.9-1.6-2.4,0-3.3c1.6-0.9,4.1-0.9,5.7,0 C110.3,148.1,110.3,149.5,108.7,150.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M103.5,135.2c0-0.1-0.2-1.6,0.4-3.5l0.2,0.1c-0.6,1.8-0.4,3.4-0.4,3.4L103.5,135.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M104.6,125.1c0,0-0.4,0-0.5,0.1c-0.2,0.1-0.2,0.5-0.2,0.5l0.9,0.4l0.3-0.1l-0.1-0.7L104.6,125.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "103.4,127.3 103,127.1 103,126.1 103.4,126.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "104.8,126.5 103.4,127.3 103.4,126.3 104.8,125.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "103.4,126.3 103,126.1 104.4,125.3 104.8,125.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "103.6,126.1 103.4,126 103.4,125.8 103.6,125.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "103.9,125.9 103.6,126.1 103.6,125.9 103.9,125.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "103.8,125.8 103.8,125.9 103.6,126 103.6,126 103.8,125.9 103.8,125.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "103.8,125.8 103.8,125.9 103.6,126 103.6,125.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "103.6,125.9 103.4,125.8 103.7,125.6 103.9,125.7  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M104.5,125.5c0,0-0.1,0-0.1,0c0,0,0,0,0,0l0,0l0-0.1h0c0,0,0,0,0,0c0,0,0.1,0,0.1,0 C104.5,125.4,104.5,125.4,104.5,125.5L104.5,125.5L104.5,125.5C104.5,125.5,104.5,125.5,104.5,125.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M104.5,125.4C104.5,125.4,104.5,125.4,104.5,125.4c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0,0.1 C104.4,125.5,104.5,125.5,104.5,125.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M104.3,125.6c0,0-0.1,0-0.2,0c0,0,0,0,0,0l0,0l0-0.1h0c0,0,0,0,0,0c0,0,0.1,0,0.2,0c0,0,0,0,0,0l0,0 L104.3,125.6C104.4,125.6,104.4,125.6,104.3,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M104.4,125.5C104.4,125.5,104.4,125.5,104.4,125.5c0-0.1-0.1-0.1-0.2-0.1c0,0,0,0.1,0,0.1 C104.2,125.5,104.3,125.5,104.4,125.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st123",
    points: "104.5,126.5 103.5,127.1 103.5,126.4 104.5,125.9  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M104.2,125.6c-0.1-0.1,0.1-0.5,0.2-0.6c0.2-0.1,0.5,0.1,0.7,0.3c0.1,0.1,0.4,0.8,0.4,0.8s0.5,1.2,0.6,1.4 c0.2,0.2,0.2,1.5,0.2,1.5s-0.1,0.8-0.4,0.6c-0.6-0.5-0.7-2.5-0.9-3.1c-0.3-0.1-0.4-0.3-0.5-0.4c-0.2-0.4-0.1-0.5,0.2-0.2 c0,0,0-0.4,0-0.4l-0.3-0.2C104.5,125.3,104.3,125.6,104.2,125.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M108,148.4c0,0-0.3,0-0.5-0.1c-0.6-0.3-1.2-0.2-1.3,0.1c-0.1,0.3,0.6,0.8,0.7,0.8c0.1,0,0.8,0.3,0.8,0.3 s0.5,0.6,0.8,0.7c0.5,0.1,0.5-0.2,0.5-0.4c0-0.2-0.1-0.5-0.2-0.7L108,148.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M109,149.1c0-0.1-0.1-0.2-0.1-0.3c0-0.3,0.8-3.2,0.7-4.1c-0.1-0.9-0.5-1.9-0.5-1.9v-1.9l-1.8,1.1 c0,0,0.2,1.2,0.5,1.6c0.3,3.2,0.4,3.9,0.1,4.8c-0.3-0.1-0.8,0.2,0.3,0.8C108.9,149.6,109,149.1,109,149.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st120",
    d: "M104.2,147.5c-0.2,0-1.1-0.3-1.3-0.3c-0.6-0.1-0.8,0.8-0.1,1.1c0.8,0.4,1.7,1.1,2.1,1.1 c0.8,0,0.7-0.7,0.6-1.1L104.2,147.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M105.5,148.2c0-0.2-0.1-0.3-0.1-0.4c-0.1-2.2,0.7-3.3-0.2-4.7c0-0.2,0.1-0.7,0.1-0.7l-1.5-0.5 c0,0-0.1,0.9-0.1,1.1c0.6,2.4,0.5,4.3,0.5,4.3c-0.6-0.2-1.5,0.3,0.3,0.9C105.5,148.7,105.5,148.2,105.5,148.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M104.4,135.5c-0.9,2.2-0.6,5.6-0.9,6.6c1.8,2.1,5.2,0.1,5.8-1c-0.2-1.6,0.3-4.6-1-6.2 C108,134.4,104.7,135,104.4,135.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st129",
    d: "M104.6,134.8c0,0,0,0.3-0.2,0.7c1.9,1.1,3.9-0.7,3.9-0.7l-0.2-0.6L104.6,134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st128",
    d: "M106.6,129.8c0,0-0.6,0.6-1.6,0.9c-0.3,0.3-0.6,0.6-0.6,1.1c0.2,0.8,0.1,2.6,0.2,2.9 c0.7,1,3.5,0.1,3.5-0.7c0.2-1.1,2-2.7,1.8-4.4c-0.1-0.4-0.3-0.8-0.3-0.8l-1.9,0.5L106.6,129.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st124",
    d: "M107.2,125.2c0,0-0.5-0.2-0.9,0.2c-0.6,0.6-0.5,2.7-0.5,2.7s0,1.1-0.3,1.9c0.3,0.1,0.6,0,0.6,0 s0.2,0.3,0.1,0.4c0.4,0.1,0.8-0.5,0.8-0.5s0.2,0.6-0.1,0.8c1.1,0.4,1.6-0.7,1.6-0.7s0.2,0.2,0.1,0.5c0.4-0.1,0.6-0.8,0.6-0.8 s0.1,0.2,0.1,0.4C110.1,129.5,110.3,124.4,107.2,125.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M108.9,126c0,0-0.7-0.6-1.7-0.8C108.4,125.1,108.9,126,108.9,126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st114",
    d: "M103,126.2l0.3,0.4c0,0,0.2-0.2,0.3-0.2c0.2,0,0.2,0.4,0.2,0.4c-0.2,0-0.3-0.1-0.3,0.1 c0,0.1,0.1,0.3-0.1,0.6c-0.1,0.2-0.2,0.2-0.3,0.3c-0.2,1.1-0.1,2-0.4,2.6c-0.1,0.1,0,0.6,0,0.6l-0.3,0.6c0,0-1,0-1.2-0.6 c-0.3-0.8,1.1-2.7,1.3-3.5c0-0.3,0.2-1.1,0.3-1.2C102.8,126.3,103,126.2,103,126.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st130",
    d: "M102.7,130.5c-0.6-0.5-1.2,0.2-1.2,0.2S102.1,130.4,102.7,130.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st131",
    d: "M105.6,130.7c0,0-1.6,0-2.8-0.3c-1,0.2-0.6,1.3-0.5,1.4c0.1,0.1,2.8,0.5,2.8,0.5s0.9,0.2,1.2-0.7 C106.5,130.8,105.6,130.7,105.6,130.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M106.4,136.5c0-0.1-0.1-0.3-0.3-0.4l-2.1-1.2c-0.1,0-0.1,0-0.2,0v0l0,0c0,0-0.6,0.4-0.6,0.4l0.1,0.5 l0.1,0l-0.1,0.2c0,0.2,0.1,0.5,0.3,0.6l2.1,1.2l-0.1,0l0.4,0.8l0.6-0.4c0.1,0,0.1-0.2,0.1-0.3L106.4,136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st123",
    d: "M105.8,136.9c0-0.2-0.2-0.3-0.3-0.4l-2.1-1.2c-0.1-0.1-0.2,0-0.2,0.1l-0.4,1.2c-0.1,0.2,0.1,0.5,0.3,0.6 l2.9,1.6c0.2,0.1,0.3,0,0.3-0.3L105.8,136.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M104.4,136.6c-0.1,0-0.1,0-0.1,0.1v0.2c0,0.1,0.1,0.2,0.1,0.2l0.1,0.1c0.1,0,0.1,0,0.1-0.1v-0.2 c0-0.1,0-0.2-0.1-0.3L104.4,136.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M106.2,136.5l-0.3,0.2c0,0,1.1-4.3,0.1-5.6c-0.2-0.2-0.4-0.5-0.7-0.5c0,0,0,0,0,0c0.4,0,0.7,0,0.9,0.3 C107.3,132.4,106.2,136.4,106.2,136.5z"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st102"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85,147.3c-0.3,0.2-0.8,0.2-1.1,0l-3.3-1.9c-0.3-0.2-0.3-0.5,0-0.6l1.5-0.8c0.3-0.2,0.8-0.2,1.1,0l3.3,1.9 c0.3,0.2,0.3,0.5,0,0.6L85,147.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M85.5,145.6c0.1-0.1,0.3-0.2,0.4-0.1h0l0.3,0.2l-0.6,1c0,0-0.3-0.2-0.3-0.2l0,0l0,0c0,0-0.1-0.1-0.1-0.1 C85.2,146.1,85.3,145.8,85.5,145.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M85.6,146.5c0.1,0.2,0.3,0.2,0.5,0c0.2-0.2,0.3-0.5,0.2-0.7c-0.1-0.2-0.3-0.2-0.5,0 C85.6,145.9,85.5,146.3,85.6,146.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M85.8,146.3c0,0.1,0.2,0.1,0.2,0c0.1-0.1,0.2-0.3,0.1-0.4c0,0-0.1-0.1-0.1-0.1c0,0,0,0,0,0 c0,0.1,0,0.3-0.1,0.4C85.9,146.3,85.8,146.3,85.8,146.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M85.8,146.3C85.8,146.3,85.8,146.3,85.8,146.3c0.1,0,0.1,0,0.2-0.1c0.1-0.1,0.2-0.3,0.1-0.4c0,0,0,0,0,0 c0,0-0.1,0-0.2,0.1C85.8,146,85.7,146.2,85.8,146.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M85.3,145.5C85.3,145.4,85.3,145.4,85.3,145.5l-1.9,1h0l-2.6-1.5l1.7-1v0c0,0,0,0,0,0c0,0,0-0.1-0.1-0.2 c0,0-0.1,0-0.1,0l-1.8,1c-0.2,0.1-0.1,0.3,0,0.3v0l2.7,1.6c0,0,0.1,0.1,0.3,0l1.8-1v0c0,0,0,0,0,0 C85.4,145.6,85.4,145.5,85.3,145.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st132",
    d: "M85.7,138.1l-3.4-2c-0.1-0.1-0.2-0.1-0.2,0v0l0,0c0,0,0,0,0,0l-1.8,1l1.7,4.2v1.7c0,0.2,0.2,0.5,0.4,0.6 l0.8,0.4l1.1,2.6l1.8-1v0c0.1,0,0.1-0.1,0.1-0.2v-6.6C86.1,138.5,85.9,138.2,85.7,138.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85,138.5l-3.4-2c-0.1-0.1-0.2-0.1-0.2,0l0,0h0c0,0,0,0,0,0l-0.1,0.1c0.1,0,0.1,0,0.2,0l3.4,2c0.2,0.1,0.4,0.4,0.4,0.6 v2.2l0.1-0.1v-2.2C85.3,138.9,85.2,138.6,85,138.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st127",
    d: "M84.3,146.4c0,0.2-0.2,0.3-0.4,0.2l-3.4-2c-0.2-0.1-0.4-0.4-0.4-0.6v-6.6c0-0.2,0.2-0.3,0.4-0.2l3.4,2 c0.2,0.1,0.4,0.4,0.4,0.6V146.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M84.6,142.3l1.2-0.7c0,0,0.1,0,0.1,0v0l0,0c0,0,0,0,0,0l0.3,0.2l-0.3,2.6v0.6c0,0.1-0.1,0.2-0.1,0.2 l-0.3,0.2l-0.7,0.7l-0.3-0.2l0,0c0,0,0,0,0-0.1v-3.3C84.5,142.4,84.5,142.3,84.6,142.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M84.8,146c0,0.1,0.1,0.1,0.1,0.1l1.2-0.7c0.1,0,0.1-0.1,0.1-0.2v-3.3c0-0.1-0.1-0.1-0.1-0.1l-1.2,0.7 c-0.1,0-0.1,0.1-0.1,0.2V146z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "85,143.3 86.1,142.6 86.1,142.5 85,143.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M83.9,139.9l0,1.4c0,0,0,0.1,0,0.1h0h0c0,0,0,0,0,0l-0.2,0.1l-2.3-1.5l-0.5-0.3c-0.1,0-0.1-0.1-0.1-0.2 l0-0.3l-0.2-1l0.2-0.1l0,0c0,0,0.1,0,0.1,0l2.9,1.7C83.8,139.7,83.9,139.8,83.9,139.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M80.7,138.1c-0.1,0-0.1,0-0.1,0.1l0,1.4c0,0.1,0.1,0.2,0.1,0.2l2.9,1.7c0.1,0,0.1,0,0.1-0.1l0-1.4 c0-0.1-0.1-0.2-0.1-0.2L80.7,138.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "83.4,140.3 80.7,138.7 80.7,138.6 83.4,140.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st110",
    d: "M83.9,142.5l0,3.2c0,0,0,0.1,0,0.1h0h0c0,0,0,0,0,0l-0.4,0.2l-2.1-1.6l-0.5-0.3c-0.1,0-0.1-0.1-0.1-0.2 l0-2.2l-0.3-0.9l0.4-0.2l0,0c0,0,0.1,0,0.1,0l2.9,1.7C83.8,142.3,83.9,142.4,83.9,142.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st109",
    d: "M80.5,140.8c-0.1,0-0.1,0-0.1,0.1l0,3.2c0,0.1,0.1,0.2,0.1,0.2l2.9,1.7c0.1,0,0.1,0,0.1-0.1l0-3.2 c0-0.1-0.1-0.2-0.1-0.2L80.5,140.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st103",
    points: "83.2,143.2 80.6,141.6 80.6,141.5 83.2,143.1  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M84.9,138c-0.1,0-0.1-0.1-0.1-0.1l0-0.1l0.4,0v0.1h0c0,0,0,0,0,0.1C85.1,138,85,138.1,84.9,138z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M85.1,137.9c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.2,0-0.3,0.1c0,0.1,0,0.1,0.1,0.2 C85,138,85.1,137.9,85.1,137.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M82.4,136.6c-0.1,0-0.1-0.1-0.1-0.1l0-0.1l0.4,0v0.1h0c0,0,0,0,0,0.1C82.7,136.6,82.5,136.7,82.4,136.6z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M82.7,136.5c0-0.1,0-0.1-0.1-0.2c-0.1,0-0.2,0-0.3,0.1c0,0.1,0,0.1,0.1,0.2 C82.5,136.5,82.7,136.5,82.7,136.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M82.6,136.5C82.6,136.4,82.7,136.4,82.6,136.5l0.1-0.9l-0.3,0l0,0.9h0c0,0,0,0,0,0 C82.4,136.5,82.5,136.5,82.6,136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M82.4,135.6C82.4,135.5,82.4,135.5,82.4,135.6c0.1-0.1,0.2-0.1,0.2-0.1c0,0,0,0.1-0.1,0.1 C82.5,135.6,82.4,135.6,82.4,135.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st111",
    d: "M85,137.9C85,137.9,85.1,137.8,85,137.9l0.1-0.9l-0.3,0l0,0.9h0c0,0,0,0,0,0 C84.9,137.9,84.9,137.9,85,137.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st112",
    d: "M84.8,137C84.8,136.9,84.8,136.9,84.8,137c0.1-0.1,0.2-0.1,0.2-0.1c0,0,0,0.1-0.1,0.1 C84.9,137,84.9,137,84.8,137z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M82.4,135.1c0.1-0.1,0.2-0.1,0.2-0.1l0.2,0.1l-0.3,0.5l-0.1-0.1v0c0,0,0,0,0-0.1 C82.2,135.4,82.3,135.2,82.4,135.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M82.4,135.6c0,0.1,0.2,0.1,0.3,0c0.1-0.1,0.2-0.3,0.1-0.4c0-0.1-0.2-0.1-0.3,0 C82.4,135.3,82.4,135.5,82.4,135.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st106",
    d: "M82.6,135.3c0,0,0.1,0,0.1,0l2.4,1.4l-0.1,0.2l-2.4-1.4v0c0,0,0,0,0,0C82.5,135.4,82.5,135.3,82.6,135.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st113",
    d: "M84.9,136.9c0,0,0.1,0,0.1,0c0.1-0.1,0.1-0.1,0.1-0.2c0,0-0.1,0-0.1,0C84.9,136.7,84.9,136.8,84.9,136.9 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st103",
    d: "M84.8,136.5c0.1-0.1,0.2-0.1,0.2-0.1l0.2,0.1l-0.3,0.5l-0.1-0.1v0c0,0,0,0,0-0.1 C84.7,136.8,84.7,136.6,84.8,136.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st104",
    d: "M84.8,137c0,0.1,0.2,0.1,0.3,0c0.1-0.1,0.2-0.3,0.1-0.4c0-0.1-0.2-0.1-0.3,0 C84.9,136.7,84.8,136.9,84.8,137z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.883e2807f1bdf4d2d5580e823256c032.svg";
export { ForwardRef as ReactComponent };